import { Fragment as e, computed as t, createBlock as n, createCommentVNode as r, createElementBlock as i, createElementVNode as a, createTextVNode as o, createVNode as s, defineComponent as c, guardReactiveProps as l, inject as u, mergeModels as d, mergeProps as f, normalizeClass as p, normalizeProps as m, normalizeStyle as h, onMounted as ee, onUnmounted as te, openBlock as g, provide as ne, reactive as re, ref as _, renderList as v, renderSlot as y, resolveDynamicComponent as ie, toDisplayString as b, useModel as ae, useSlots as oe, vModelText as se, watch as ce, withCtx as x, withDirectives as le } from "vue";
import { AccordionContent as ue, AccordionHeader as de, AccordionItem as fe, AccordionRoot as pe, AccordionTrigger as me, AlertDialogAction as he, AlertDialogCancel as ge, AlertDialogContent as _e, AlertDialogDescription as ve, AlertDialogOverlay as ye, AlertDialogPortal as be, AlertDialogRoot as xe, AlertDialogTitle as Se, AlertDialogTrigger as Ce, AvatarFallback as we, AvatarImage as Te, AvatarRoot as Ee, CalendarCell as De, CalendarCellTrigger as Oe, CalendarGrid as ke, CalendarGridBody as Ae, CalendarGridHead as je, CalendarGridRow as Me, CalendarHeadCell as Ne, CalendarHeader as Pe, CalendarHeading as Fe, CalendarNext as Ie, CalendarPrev as Le, CalendarRoot as Re, CheckboxIndicator as ze, CheckboxRoot as Be, CollapsibleContent as Ve, CollapsibleRoot as He, CollapsibleTrigger as Ue, DialogClose as S, DialogContent as We, DialogDescription as Ge, DialogOverlay as Ke, DialogPortal as qe, DialogRoot as Je, DialogTitle as Ye, DialogTrigger as Xe, DropdownMenuCheckboxItem as Ze, DropdownMenuContent as Qe, DropdownMenuGroup as $e, DropdownMenuItem as et, DropdownMenuItemIndicator as tt, DropdownMenuLabel as nt, DropdownMenuPortal as rt, DropdownMenuPortal as it, DropdownMenuRadioGroup as at, DropdownMenuRadioItem as ot, DropdownMenuRoot as st, DropdownMenuSeparator as ct, DropdownMenuSub as lt, DropdownMenuSubContent as ut, DropdownMenuSubTrigger as dt, DropdownMenuTrigger as ft, HoverCardContent as pt, HoverCardPortal as mt, HoverCardRoot as ht, HoverCardTrigger as gt, Label as _t, ListboxContent as vt, ListboxFilter as yt, ListboxGroup as bt, ListboxGroupLabel as xt, ListboxItem as St, ListboxRoot as Ct, NumberFieldDecrement as wt, NumberFieldIncrement as Tt, NumberFieldInput as Et, NumberFieldRoot as Dt, PaginationEllipsis as Ot, PaginationFirst as kt, PaginationLast as At, PaginationList as jt, PaginationListItem as Mt, PaginationNext as Nt, PaginationPrev as Pt, PaginationRoot as Ft, PinInputInput as It, PinInputRoot as Lt, PopoverAnchor as Rt, PopoverContent as zt, PopoverPortal as Bt, PopoverRoot as Vt, PopoverTrigger as Ht, Primitive as C, ProgressIndicator as Ut, ProgressRoot as Wt, RadioGroupIndicator as Gt, RadioGroupItem as Kt, RadioGroupRoot as qt, RangeCalendarCell as Jt, RangeCalendarCellTrigger as Yt, RangeCalendarGrid as Xt, RangeCalendarGridBody as Zt, RangeCalendarGridHead as Qt, RangeCalendarGridRow as $t, RangeCalendarHeadCell as en, RangeCalendarHeader as tn, RangeCalendarHeading as nn, RangeCalendarNext as rn, RangeCalendarPrev as an, RangeCalendarRoot as on, ScrollAreaCorner as sn, ScrollAreaRoot as cn, ScrollAreaScrollbar as ln, ScrollAreaThumb as un, ScrollAreaViewport as dn, SelectContent as fn, SelectGroup as pn, SelectIcon as mn, SelectItem as hn, SelectItemIndicator as gn, SelectItemText as _n, SelectLabel as vn, SelectPortal as yn, SelectRoot as bn, SelectScrollDownButton as xn, SelectScrollUpButton as Sn, SelectSeparator as Cn, SelectTrigger as wn, SelectValue as Tn, SelectViewport as En, Separator as Dn, SliderRange as On, SliderRoot as kn, SliderThumb as An, SliderTrack as jn, SwitchRoot as Mn, SwitchThumb as Nn, TabsContent as Pn, TabsList as Fn, TabsRoot as In, TabsTrigger as Ln, Toggle as Rn, ToggleGroupItem as zn, ToggleGroupRoot as Bn, TooltipArrow as Vn, TooltipContent as Hn, TooltipPortal as Un, TooltipProvider as Wn, TooltipRoot as Gn, TooltipTrigger as Kn, createContext as qn, useFilter as Jn, useForwardProps as w, useForwardPropsEmits as T, useId as Yn } from "reka-ui";
import { reactiveOmit as E, useCurrentElement as Xn, useVModel as Zn } from "@vueuse/core";
import { clsx as Qn } from "clsx";
import { twMerge as $n } from "tailwind-merge";
import { Check as D, ChevronDown as er, ChevronLeft as tr, ChevronLeftIcon as nr, ChevronRight as O, ChevronRightIcon as rr, ChevronUp as ir, ChevronsUpDown as ar, Circle as or, CircleCheckIcon as sr, CircleIcon as cr, InfoIcon as lr, ListFilter as ur, Loader2Icon as dr, Menu as fr, Minus as pr, Moon as mr, MoreHorizontal as hr, OctagonXIcon as gr, Plus as _r, Search as vr, Sun as yr, TriangleAlertIcon as br, X as k, XIcon as xr } from "@lucide/vue";
import { cva as A } from "class-variance-authority";
import { Toaster as Sr } from "vue-sonner";
import "vue-sonner/style.css";
// \0rolldown/runtime.js
var Cr = Object.defineProperty, wr = (e, t) => {
	let n = {};
	for (var r in e) Cr(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || Cr(n, Symbol.toStringTag, { value: "Module" }), n;
}, Tr = /*@__PURE__*/ c({
	__name: "Accordion",
	props: {
		collapsible: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		orientation: {
			type: String,
			required: !1
		},
		unmountOnHide: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		type: {
			type: String,
			required: !1
		},
		modelValue: {
			type: null,
			required: !1
		},
		defaultValue: {
			type: null,
			required: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = {
			props: r,
			emits: i,
			forwarded: T(r, i),
			get AccordionRoot() {
				return pe;
			}
		};
		return Object.defineProperty(a, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), a;
	}
}), j = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
};
// src/components/ui/accordion/Accordion.vue
function Er(e, t, r, i, a, o) {
	return g(), n(i.AccordionRoot, f({ "data-slot": "accordion" }, i.forwarded), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16);
}
var Dr = /*#__PURE__*/ j(Tr, [["render", Er], ["__file", "/workspace/packages/ui/src/components/ui/accordion/Accordion.vue"]]);
// src/lib/utils.ts
function M(...e) {
	return $n(Qn(e));
}
// src/components/ui/accordion/AccordionContent.vue?vue&type=script&setup=true&lang.ts
var Or = /*@__PURE__*/ c({
	__name: "AccordionContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get AccordionContent() {
				return ue;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/accordion/AccordionContent.vue
function kr(e, t, r, i, o, s) {
	return g(), n(i.AccordionContent, f({ "data-slot": "accordion-content" }, i.delegatedProps, { class: "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm" }), {
		default: x(() => [a("div", { class: p(i.cn("pt-0 pb-4", i.props.class)) }, [y(e.$slots, "default")], 2)]),
		_: 3
	}, 16);
}
var Ar = /*#__PURE__*/ j(Or, [["render", kr], ["__file", "/workspace/packages/ui/src/components/ui/accordion/AccordionContent.vue"]]), jr = /*@__PURE__*/ c({
	__name: "AccordionItem",
	props: {
		disabled: {
			type: Boolean,
			required: !1
		},
		value: {
			type: String,
			required: !0
		},
		unmountOnHide: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get cn() {
				return M;
			},
			get AccordionItem() {
				return fe;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/accordion/AccordionItem.vue
function Mr(e, t, r, i, a, o) {
	return g(), n(i.AccordionItem, f({ "data-slot": "accordion-item" }, i.forwardedProps, { class: i.cn("border-b last:border-b-0", i.props.class) }), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16, ["class"]);
}
var Nr = /*#__PURE__*/ j(jr, [["render", Mr], ["__file", "/workspace/packages/ui/src/components/ui/accordion/AccordionItem.vue"]]), Pr = /*@__PURE__*/ c({
	__name: "AccordionTrigger",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get ChevronDown() {
				return er;
			},
			get cn() {
				return M;
			},
			get AccordionHeader() {
				return de;
			},
			get AccordionTrigger() {
				return me;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/accordion/AccordionTrigger.vue
function Fr(e, t, r, i, a, o) {
	return g(), n(i.AccordionHeader, { class: "flex" }, {
		default: x(() => [s(i.AccordionTrigger, f({ "data-slot": "accordion-trigger" }, i.delegatedProps, { class: i.cn("focus-visible:border-ring focus-visible:ring-ring/50 flex flex-1 items-start justify-between gap-4 rounded-md py-4 text-left text-sm font-medium transition-all outline-none hover:underline focus-visible:ring-3 disabled:pointer-events-none disabled:opacity-50 [&[data-state=open]>svg]:rotate-180", i.props.class) }), {
			default: x(() => [y(e.$slots, "default"), y(e.$slots, "icon", {}, () => [s(i.ChevronDown, { class: "text-muted-foreground pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200" })])]),
			_: 3
		}, 16, ["class"])]),
		_: 3
	});
}
var Ir = /*#__PURE__*/ j(Pr, [["render", Fr], ["__file", "/workspace/packages/ui/src/components/ui/accordion/AccordionTrigger.vue"]]), Lr = /*@__PURE__*/ c({
	__name: "AlertDialog",
	props: {
		open: {
			type: Boolean,
			required: !1
		},
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		unmountOnHide: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = {
			props: r,
			emits: i,
			forwarded: T(r, i),
			get AlertDialogRoot() {
				return xe;
			}
		};
		return Object.defineProperty(a, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), a;
	}
});
// src/components/ui/alert-dialog/AlertDialog.vue
function Rr(e, t, r, i, a, o) {
	return g(), n(i.AlertDialogRoot, f({ "data-slot": "alert-dialog" }, i.forwarded), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16);
}
var zr = /*#__PURE__*/ j(Lr, [["render", Rr], ["__file", "/workspace/packages/ui/src/components/ui/alert-dialog/AlertDialog.vue"]]), Br = /*@__PURE__*/ c({
	__name: "Button",
	props: {
		variant: {
			type: null,
			required: !1
		},
		size: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			},
			get Primitive() {
				return C;
			},
			get buttonVariants() {
				return P;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/button/Button.vue
function Vr(e, t, r, i, a, o) {
	return g(), n(i.Primitive, {
		"data-slot": "button",
		"data-variant": r.variant,
		"data-size": r.size,
		as: r.as,
		"as-child": r.asChild,
		class: p(i.cn(i.buttonVariants({
			variant: r.variant,
			size: r.size
		}), i.props.class))
	}, {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 8, [
		"data-variant",
		"data-size",
		"as",
		"as-child",
		"class"
	]);
}
var N = /*#__PURE__*/ j(Br, [["render", Vr], ["__file", "/workspace/packages/ui/src/components/ui/button/Button.vue"]]), P = A("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-3 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", {
	variants: {
		variant: {
			default: "bg-primary text-primary-foreground shadow-sm hover:bg-primary/90",
			destructive: "bg-destructive text-white hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
			outline: "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
			secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
			ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
			glass: "glass-button text-foreground",
			back: "justify-start gap-1.5 text-xs text-sidebar-foreground hover:text-foreground",
			link: "text-primary underline-offset-4 hover:underline"
		},
		size: {
			default: "h-9 px-4 py-2 has-[>svg]:px-3",
			xs: "h-6 gap-1 rounded-md px-2 text-xs has-[>svg]:px-1.5 [&_svg:not([class*='size-'])]:size-3",
			sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
			lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
			icon: "size-9",
			"icon-xs": "size-6 rounded-md [&_svg:not([class*='size-'])]:size-3",
			"icon-sm": "size-8",
			"icon-lg": "size-10"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
}), Hr = /*@__PURE__*/ c({
	__name: "AlertDialogAction",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get AlertDialogAction() {
				return he;
			},
			get buttonVariants() {
				return P;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/alert-dialog/AlertDialogAction.vue
function Ur(e, t, r, i, a, o) {
	return g(), n(i.AlertDialogAction, f({ "data-slot": "alert-dialog-action" }, i.delegatedProps, { class: i.cn(i.buttonVariants(), "h-11 w-full", i.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var Wr = /*#__PURE__*/ j(Hr, [["render", Ur], ["__file", "/workspace/packages/ui/src/components/ui/alert-dialog/AlertDialogAction.vue"]]), Gr = /*@__PURE__*/ c({
	__name: "AlertDialogCancel",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get AlertDialogCancel() {
				return ge;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/alert-dialog/AlertDialogCancel.vue
function Kr(e, t, r, i, a, o) {
	return g(), n(i.AlertDialogCancel, f({ "data-slot": "alert-dialog-cancel" }, i.delegatedProps, { class: i.cn("mx-auto rounded-md px-3 py-1.5 text-sm text-foreground/60 transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring", i.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var qr = /*#__PURE__*/ j(Gr, [["render", Kr], ["__file", "/workspace/packages/ui/src/components/ui/alert-dialog/AlertDialogCancel.vue"]]), Jr = /*@__PURE__*/ c({
	inheritAttrs: !1,
	__name: "AlertDialogContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get cn() {
				return M;
			},
			get AlertDialogContent() {
				return _e;
			},
			get AlertDialogOverlay() {
				return ye;
			},
			get AlertDialogPortal() {
				return be;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/alert-dialog/AlertDialogContent.vue
function Yr(e, t, r, i, a, o) {
	return g(), n(i.AlertDialogPortal, null, {
		default: x(() => [s(i.AlertDialogOverlay, {
			"data-slot": "alert-dialog-overlay",
			class: "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 blur-overlay"
		}), s(i.AlertDialogContent, f({ "data-slot": "alert-dialog-content" }, {
			...e.$attrs,
			...i.forwarded
		}, { class: i.cn("text-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-5 p-6 duration-200 sm:max-w-[410px]", i.props.class) }), {
			default: x(() => [y(e.$slots, "default")]),
			_: 3
		}, 16, ["class"])]),
		_: 3
	});
}
var Xr = /*#__PURE__*/ j(Jr, [["render", Yr], ["__file", "/workspace/packages/ui/src/components/ui/alert-dialog/AlertDialogContent.vue"]]), Zr = /*@__PURE__*/ c({
	__name: "AlertDialogDescription",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get AlertDialogDescription() {
				return ve;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/alert-dialog/AlertDialogDescription.vue
function Qr(e, t, r, i, a, o) {
	return g(), n(i.AlertDialogDescription, f({ "data-slot": "alert-dialog-description" }, i.delegatedProps, { class: i.cn("text-sm text-foreground/70", i.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var $r = /*#__PURE__*/ j(Zr, [["render", Qr], ["__file", "/workspace/packages/ui/src/components/ui/alert-dialog/AlertDialogDescription.vue"]]), ei = /*@__PURE__*/ c({
	__name: "AlertDialogFooter",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/alert-dialog/AlertDialogFooter.vue
function ti(e, t, n, r, a, o) {
	return g(), i("div", {
		"data-slot": "alert-dialog-footer",
		class: p(r.cn("flex flex-col-reverse gap-2", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var ni = /*#__PURE__*/ j(ei, [["render", ti], ["__file", "/workspace/packages/ui/src/components/ui/alert-dialog/AlertDialogFooter.vue"]]), ri = /*@__PURE__*/ c({
	__name: "AlertDialogHeader",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/alert-dialog/AlertDialogHeader.vue
function ii(e, t, n, r, a, o) {
	return g(), i("div", {
		"data-slot": "alert-dialog-header",
		class: p(r.cn("flex flex-col gap-2 text-center", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var ai = /*#__PURE__*/ j(ri, [["render", ii], ["__file", "/workspace/packages/ui/src/components/ui/alert-dialog/AlertDialogHeader.vue"]]), oi = /*@__PURE__*/ c({
	__name: "AlertDialogTitle",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get AlertDialogTitle() {
				return Se;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/alert-dialog/AlertDialogTitle.vue
function si(e, t, r, i, a, o) {
	return g(), n(i.AlertDialogTitle, f({ "data-slot": "alert-dialog-title" }, i.delegatedProps, { class: i.cn("text-xl font-semibold text-foreground", i.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var ci = /*#__PURE__*/ j(oi, [["render", si], ["__file", "/workspace/packages/ui/src/components/ui/alert-dialog/AlertDialogTitle.vue"]]), li = /*@__PURE__*/ c({
	__name: "AlertDialogTrigger",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get AlertDialogTrigger() {
				return Ce;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/alert-dialog/AlertDialogTrigger.vue
function ui(e, t, r, i, a, o) {
	return g(), n(i.AlertDialogTrigger, f({ "data-slot": "alert-dialog-trigger" }, i.props), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var di = /*#__PURE__*/ j(li, [["render", ui], ["__file", "/workspace/packages/ui/src/components/ui/alert-dialog/AlertDialogTrigger.vue"]]), fi = /*@__PURE__*/ c({
	__name: "Alert",
	props: {
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		},
		variant: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			},
			get alertVariants() {
				return xi;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/alert/Alert.vue
function pi(e, t, n, r, a, o) {
	return g(), i("div", {
		"data-slot": "alert",
		class: p(r.cn(r.alertVariants({ variant: n.variant }), r.props.class)),
		role: "alert"
	}, [y(e.$slots, "default")], 2);
}
var mi = /*#__PURE__*/ j(fi, [["render", pi], ["__file", "/workspace/packages/ui/src/components/ui/alert/Alert.vue"]]), hi = /*@__PURE__*/ c({
	__name: "AlertDescription",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/alert/AlertDescription.vue
function gi(e, t, n, r, a, o) {
	return g(), i("div", {
		"data-slot": "alert-description",
		class: p(r.cn("text-muted-foreground col-start-2 text-sm [&_p]:leading-relaxed", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var _i = /*#__PURE__*/ j(hi, [["render", gi], ["__file", "/workspace/packages/ui/src/components/ui/alert/AlertDescription.vue"]]), vi = /*@__PURE__*/ c({
	__name: "AlertTitle",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/alert/AlertTitle.vue
function yi(e, t, n, r, a, o) {
	return g(), i("div", {
		"data-slot": "alert-title",
		class: p(r.cn("col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var bi = /*#__PURE__*/ j(vi, [["render", yi], ["__file", "/workspace/packages/ui/src/components/ui/alert/AlertTitle.vue"]]), xi = A("relative w-full rounded-lg border px-4 py-3 text-sm grid has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current", {
	variants: { variant: {
		default: "bg-card text-card-foreground",
		destructive: "text-destructive bg-card [&>svg]:text-current *:data-[slot=alert-description]:text-destructive/90"
	} },
	defaultVariants: { variant: "default" }
}), Si = /*@__PURE__*/ c({
	__name: "Avatar",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			},
			get AvatarRoot() {
				return Ee;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/avatar/Avatar.vue
function Ci(e, t, r, i, a, o) {
	return g(), n(i.AvatarRoot, {
		"data-slot": "avatar",
		class: p(i.cn("relative flex size-8 shrink-0 overflow-hidden rounded-full", i.props.class))
	}, {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 8, ["class"]);
}
var wi = /*#__PURE__*/ j(Si, [["render", Ci], ["__file", "/workspace/packages/ui/src/components/ui/avatar/Avatar.vue"]]), Ti = /*@__PURE__*/ c({
	__name: "AvatarFallback",
	props: {
		delayMs: {
			type: Number,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get AvatarFallback() {
				return we;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/avatar/AvatarFallback.vue
function Ei(e, t, r, i, a, o) {
	return g(), n(i.AvatarFallback, f({ "data-slot": "avatar-fallback" }, i.delegatedProps, { class: i.cn("bg-muted flex size-full items-center justify-center rounded-full", i.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var Di = /*#__PURE__*/ j(Ti, [["render", Ei], ["__file", "/workspace/packages/ui/src/components/ui/avatar/AvatarFallback.vue"]]), Oi = /*@__PURE__*/ c({
	__name: "AvatarImage",
	props: {
		src: {
			type: String,
			required: !0
		},
		referrerPolicy: {
			type: null,
			required: !1
		},
		crossOrigin: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get AvatarImage() {
				return Te;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/avatar/AvatarImage.vue
function ki(e, t, r, i, a, o) {
	return g(), n(i.AvatarImage, f({ "data-slot": "avatar-image" }, i.props, { class: "aspect-square size-full" }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var Ai = /*#__PURE__*/ j(Oi, [["render", ki], ["__file", "/workspace/packages/ui/src/components/ui/avatar/AvatarImage.vue"]]), ji = /*@__PURE__*/ c({
	__name: "Badge",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		variant: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get Primitive() {
				return C;
			},
			get badgeVariants() {
				return Pi;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/badge/Badge.vue
function Mi(e, t, r, i, a, o) {
	return g(), n(i.Primitive, f({
		"data-slot": "badge",
		class: i.cn(i.badgeVariants({ variant: r.variant }), i.props.class)
	}, i.delegatedProps), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var Ni = /*#__PURE__*/ j(ji, [["render", Mi], ["__file", "/workspace/packages/ui/src/components/ui/badge/Badge.vue"]]), Pi = A("inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-semibold w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-3 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden", {
	variants: { variant: {
		default: "border-transparent bg-primary text-primary-foreground [a&]:hover:bg-primary/90",
		secondary: "border-transparent bg-foreground/8 text-foreground/80 [a&]:hover:bg-foreground/12",
		destructive: "border-transparent bg-destructive text-white [a&]:hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
		success: "border-transparent bg-success text-success-foreground [a&]:hover:bg-success/90",
		warning: "border-transparent bg-warning text-warning-foreground [a&]:hover:bg-warning/90",
		outline: "text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground"
	} },
	defaultVariants: { variant: "default" }
}), Fi = /*@__PURE__*/ c({
	__name: "Breadcrumb",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = { props: e };
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/breadcrumb/Breadcrumb.vue
function Ii(e, t, n, r, a, o) {
	return g(), i("nav", {
		"aria-label": "breadcrumb",
		"data-slot": "breadcrumb",
		class: p(r.props.class)
	}, [y(e.$slots, "default")], 2);
}
var Li = /*#__PURE__*/ j(Fi, [["render", Ii], ["__file", "/workspace/packages/ui/src/components/ui/breadcrumb/Breadcrumb.vue"]]), Ri = /*@__PURE__*/ c({
	__name: "BreadcrumbEllipsis",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get MoreHorizontal() {
				return hr;
			},
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/breadcrumb/BreadcrumbEllipsis.vue
function zi(e, t, n, r, o, c) {
	return g(), i("span", {
		"data-slot": "breadcrumb-ellipsis",
		role: "presentation",
		"aria-hidden": "true",
		class: p(r.cn("flex size-9 items-center justify-center", r.props.class))
	}, [y(e.$slots, "default", {}, () => [s(r.MoreHorizontal, { class: "size-4" })]), t[0] ||= a("span", { class: "sr-only" }, "More", -1)], 2);
}
var Bi = /*#__PURE__*/ j(Ri, [["render", zi], ["__file", "/workspace/packages/ui/src/components/ui/breadcrumb/BreadcrumbEllipsis.vue"]]), Vi = /*@__PURE__*/ c({
	__name: "BreadcrumbItem",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/breadcrumb/BreadcrumbItem.vue
function Hi(e, t, n, r, a, o) {
	return g(), i("li", {
		"data-slot": "breadcrumb-item",
		class: p(r.cn("inline-flex items-center gap-1.5", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var Ui = /*#__PURE__*/ j(Vi, [["render", Hi], ["__file", "/workspace/packages/ui/src/components/ui/breadcrumb/BreadcrumbItem.vue"]]), Wi = /*@__PURE__*/ c({
	__name: "BreadcrumbLink",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "a"
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			},
			get Primitive() {
				return C;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/breadcrumb/BreadcrumbLink.vue
function Gi(e, t, r, i, a, o) {
	return g(), n(i.Primitive, {
		"data-slot": "breadcrumb-link",
		as: r.as,
		"as-child": r.asChild,
		class: p(i.cn("hover:text-foreground transition-colors", i.props.class))
	}, {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 8, [
		"as",
		"as-child",
		"class"
	]);
}
var Ki = /*#__PURE__*/ j(Wi, [["render", Gi], ["__file", "/workspace/packages/ui/src/components/ui/breadcrumb/BreadcrumbLink.vue"]]), qi = /*@__PURE__*/ c({
	__name: "BreadcrumbList",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/breadcrumb/BreadcrumbList.vue
function Ji(e, t, n, r, a, o) {
	return g(), i("ol", {
		"data-slot": "breadcrumb-list",
		class: p(r.cn("text-muted-foreground flex flex-wrap items-center gap-1.5 text-sm break-words sm:gap-2.5", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var Yi = /*#__PURE__*/ j(qi, [["render", Ji], ["__file", "/workspace/packages/ui/src/components/ui/breadcrumb/BreadcrumbList.vue"]]), Xi = /*@__PURE__*/ c({
	__name: "BreadcrumbPage",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/breadcrumb/BreadcrumbPage.vue
function Zi(e, t, n, r, a, o) {
	return g(), i("span", {
		"data-slot": "breadcrumb-page",
		role: "link",
		"aria-disabled": "true",
		"aria-current": "page",
		class: p(r.cn("text-foreground font-normal", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var Qi = /*#__PURE__*/ j(Xi, [["render", Zi], ["__file", "/workspace/packages/ui/src/components/ui/breadcrumb/BreadcrumbPage.vue"]]), $i = /*@__PURE__*/ c({
	__name: "BreadcrumbSeparator",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get ChevronRight() {
				return O;
			},
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/breadcrumb/BreadcrumbSeparator.vue
function ea(e, t, n, r, a, o) {
	return g(), i("li", {
		"data-slot": "breadcrumb-separator",
		role: "presentation",
		"aria-hidden": "true",
		class: p(r.cn("[&>svg]:size-3.5", r.props.class))
	}, [y(e.$slots, "default", {}, () => [s(r.ChevronRight)])], 2);
}
var ta = /*#__PURE__*/ j($i, [["render", ea], ["__file", "/workspace/packages/ui/src/components/ui/breadcrumb/BreadcrumbSeparator.vue"]]), na = /*@__PURE__*/ c({
	__name: "Calendar",
	props: {
		defaultValue: {
			type: Object,
			required: !1
		},
		defaultPlaceholder: {
			type: Object,
			required: !1
		},
		placeholder: {
			type: Object,
			required: !1
		},
		pagedNavigation: {
			type: Boolean,
			required: !1
		},
		preventDeselect: {
			type: Boolean,
			required: !1
		},
		weekStartsOn: {
			type: Number,
			required: !1
		},
		weekdayFormat: {
			type: String,
			required: !1
		},
		calendarLabel: {
			type: String,
			required: !1
		},
		fixedWeeks: {
			type: Boolean,
			required: !1
		},
		maxValue: {
			type: Object,
			required: !1
		},
		minValue: {
			type: Object,
			required: !1
		},
		locale: {
			type: String,
			required: !1
		},
		numberOfMonths: {
			type: Number,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		readonly: {
			type: Boolean,
			required: !1
		},
		initialFocus: {
			type: Boolean,
			required: !1
		},
		isDateDisabled: {
			type: Function,
			required: !1
		},
		isDateUnavailable: {
			type: Function,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		nextPage: {
			type: Function,
			required: !1
		},
		prevPage: {
			type: Function,
			required: !1
		},
		modelValue: {
			type: [
				Object,
				Array,
				null
			],
			required: !1
		},
		multiple: {
			type: Boolean,
			required: !1
		},
		disableDaysOutsideCurrentView: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: ["update:modelValue", "update:placeholder"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			navButtonClass: M(P({ variant: "outline" }), "absolute size-7 bg-transparent p-0 opacity-50 hover:opacity-100"),
			get ChevronLeft() {
				return tr;
			},
			get ChevronRight() {
				return O;
			},
			get cn() {
				return M;
			},
			get CalendarCell() {
				return De;
			},
			get CalendarCellTrigger() {
				return Oe;
			},
			get CalendarGrid() {
				return ke;
			},
			get CalendarGridBody() {
				return Ae;
			},
			get CalendarGridHead() {
				return je;
			},
			get CalendarGridRow() {
				return Me;
			},
			get CalendarHeadCell() {
				return Ne;
			},
			get CalendarHeader() {
				return Pe;
			},
			get CalendarHeading() {
				return Fe;
			},
			get CalendarNext() {
				return Ie;
			},
			get CalendarPrev() {
				return Le;
			},
			get CalendarRoot() {
				return Re;
			},
			get buttonVariants() {
				return P;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
}), ra = { class: "mt-4 flex flex-col gap-y-4 sm:flex-row sm:gap-x-4 sm:gap-y-0" };
function ia(t, r, c, l, u, d) {
	return g(), n(l.CalendarRoot, f({
		"data-slot": "calendar",
		class: l.cn("p-3", l.props.class)
	}, l.forwarded), {
		default: x(({ grid: t, weekDays: r }) => [s(l.CalendarHeader, {
			"data-slot": "calendar-header",
			class: "relative flex w-full items-center justify-center pt-1"
		}, {
			default: x(() => [
				s(l.CalendarHeading, {
					"data-slot": "calendar-heading",
					class: "text-sm font-medium"
				}),
				s(l.CalendarPrev, {
					"data-slot": "calendar-prev-button",
					class: p(l.cn(l.navButtonClass, "left-1"))
				}, {
					default: x(() => [s(l.ChevronLeft, { class: "size-4" })]),
					_: 1
				}, 8, ["class"]),
				s(l.CalendarNext, {
					"data-slot": "calendar-next-button",
					class: p(l.cn(l.navButtonClass, "right-1"))
				}, {
					default: x(() => [s(l.ChevronRight, { class: "size-4" })]),
					_: 1
				}, 8, ["class"])
			]),
			_: 1
		}), a("div", ra, [(g(!0), i(e, null, v(t, (t) => (g(), n(l.CalendarGrid, {
			key: t.value.toString(),
			"data-slot": "calendar-grid",
			class: "w-full border-collapse"
		}, {
			default: x(() => [s(l.CalendarGridHead, null, {
				default: x(() => [s(l.CalendarGridRow, { class: "flex" }, {
					default: x(() => [(g(!0), i(e, null, v(r, (e) => (g(), n(l.CalendarHeadCell, {
						key: e,
						"data-slot": "calendar-head-cell",
						class: "w-8 rounded-md text-[0.8rem] font-normal text-muted-foreground"
					}, {
						default: x(() => [o(b(e), 1)]),
						_: 2
					}, 1024))), 128))]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1024), s(l.CalendarGridBody, null, {
				default: x(() => [(g(!0), i(e, null, v(t.rows, (r, a) => (g(), n(l.CalendarGridRow, {
					key: `weekDate-${a}`,
					class: "mt-2 flex w-full"
				}, {
					default: x(() => [(g(!0), i(e, null, v(r, (e) => (g(), n(l.CalendarCell, {
						key: e.toString(),
						date: e,
						"data-slot": "calendar-cell",
						class: "relative p-0 text-center text-sm focus-within:relative focus-within:z-20"
					}, {
						default: x(() => [s(l.CalendarCellTrigger, {
							day: e,
							month: t.value,
							"data-slot": "calendar-trigger",
							class: p(l.cn(l.buttonVariants({ variant: "ghost" }), "size-8 p-0 font-normal", "[&[data-today]:not([data-selected])]:bg-accent [&[data-today]:not([data-selected])]:text-accent-foreground", "data-[selected]:bg-primary data-[selected]:text-primary-foreground data-[selected]:hover:bg-primary data-[selected]:hover:text-primary-foreground data-[selected]:focus:bg-primary data-[selected]:focus:text-primary-foreground", "data-[outside-view]:text-muted-foreground", "data-[disabled]:text-muted-foreground data-[disabled]:opacity-50", "data-[unavailable]:text-destructive-foreground data-[unavailable]:line-through"))
						}, null, 8, [
							"day",
							"month",
							"class"
						])]),
						_: 2
					}, 1032, ["date"]))), 128))]),
					_: 2
				}, 1024))), 128))]),
				_: 2
			}, 1024)]),
			_: 2
		}, 1024))), 128))])]),
		_: 1
	}, 16, ["class"]);
}
var aa = /*#__PURE__*/ j(na, [["render", ia], ["__file", "/workspace/packages/ui/src/components/ui/calendar/Calendar.vue"]]), oa = /*@__PURE__*/ c({
	__name: "Card",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/card/Card.vue
function sa(e, t, n, r, a, o) {
	return g(), i("div", {
		"data-slot": "card",
		class: p(r.cn("glass-panel text-card-foreground flex flex-col gap-6 rounded-xl py-6", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var ca = /*#__PURE__*/ j(oa, [["render", sa], ["__file", "/workspace/packages/ui/src/components/ui/card/Card.vue"]]), la = /*@__PURE__*/ c({
	__name: "CardAction",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/card/CardAction.vue
function ua(e, t, n, r, a, o) {
	return g(), i("div", {
		"data-slot": "card-action",
		class: p(r.cn("col-start-2 row-span-2 row-start-1 self-start justify-self-end", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var da = /*#__PURE__*/ j(la, [["render", ua], ["__file", "/workspace/packages/ui/src/components/ui/card/CardAction.vue"]]), fa = /*@__PURE__*/ c({
	__name: "CardContent",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/card/CardContent.vue
function pa(e, t, n, r, a, o) {
	return g(), i("div", {
		"data-slot": "card-content",
		class: p(r.cn("px-6", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var ma = /*#__PURE__*/ j(fa, [["render", pa], ["__file", "/workspace/packages/ui/src/components/ui/card/CardContent.vue"]]), ha = /*@__PURE__*/ c({
	__name: "CardDescription",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/card/CardDescription.vue
function ga(e, t, n, r, a, o) {
	return g(), i("p", {
		"data-slot": "card-description",
		class: p(r.cn("text-muted-foreground text-sm", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var _a = /*#__PURE__*/ j(ha, [["render", ga], ["__file", "/workspace/packages/ui/src/components/ui/card/CardDescription.vue"]]), va = /*@__PURE__*/ c({
	__name: "CardFooter",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/card/CardFooter.vue
function ya(e, t, n, r, a, o) {
	return g(), i("div", {
		"data-slot": "card-footer",
		class: p(r.cn("flex items-center px-6 [.border-t]:pt-6", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var ba = /*#__PURE__*/ j(va, [["render", ya], ["__file", "/workspace/packages/ui/src/components/ui/card/CardFooter.vue"]]), xa = /*@__PURE__*/ c({
	__name: "CardHeader",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/card/CardHeader.vue
function Sa(e, t, n, r, a, o) {
	return g(), i("div", {
		"data-slot": "card-header",
		class: p(r.cn("@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var Ca = /*#__PURE__*/ j(xa, [["render", Sa], ["__file", "/workspace/packages/ui/src/components/ui/card/CardHeader.vue"]]), wa = /*@__PURE__*/ c({
	__name: "CardTitle",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/card/CardTitle.vue
function Ta(e, t, n, r, a, o) {
	return g(), i("h3", {
		"data-slot": "card-title",
		class: p(r.cn("leading-none font-semibold", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var Ea = /*#__PURE__*/ j(wa, [["render", Ta], ["__file", "/workspace/packages/ui/src/components/ui/card/CardTitle.vue"]]), Da = /*@__PURE__*/ c({
	__name: "Checkbox",
	props: {
		defaultValue: {
			type: null,
			required: !1
		},
		modelValue: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		value: {
			type: null,
			required: !1
		},
		id: {
			type: String,
			required: !1
		},
		trueValue: {
			type: null,
			required: !1
		},
		falseValue: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get Check() {
				return D;
			},
			get Minus() {
				return pr;
			},
			get cn() {
				return M;
			},
			get CheckboxIndicator() {
				return ze;
			},
			get CheckboxRoot() {
				return Be;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/checkbox/Checkbox.vue
function Oa(e, t, r, i, a, o) {
	return g(), n(i.CheckboxRoot, f({ "data-slot": "checkbox" }, i.forwarded, { class: i.cn("peer border-[color:var(--switch-track)] data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground data-[state=checked]:border-primary data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-primary-foreground data-[state=indeterminate]:border-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive size-4 shrink-0 rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-3 disabled:cursor-not-allowed disabled:opacity-50", i.props.class) }), {
		default: x((t) => [s(i.CheckboxIndicator, {
			"data-slot": "checkbox-indicator",
			class: "grid place-content-center text-current transition-none"
		}, {
			default: x(() => [y(e.$slots, "default", m(l(t)), () => [t.state === "indeterminate" ? (g(), n(i.Minus, {
				key: 0,
				class: "size-3.5"
			})) : (g(), n(i.Check, {
				key: 1,
				class: "size-3.5"
			}))])]),
			_: 2
		}, 1024)]),
		_: 3
	}, 16, ["class"]);
}
var ka = /*#__PURE__*/ j(Da, [["render", Oa], ["__file", "/workspace/packages/ui/src/components/ui/checkbox/Checkbox.vue"]]), Aa = /*@__PURE__*/ c({
	__name: "Collapsible",
	props: {
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		open: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		unmountOnHide: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = {
			props: r,
			emits: i,
			forwarded: T(r, i),
			get CollapsibleRoot() {
				return He;
			}
		};
		return Object.defineProperty(a, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), a;
	}
});
// src/components/ui/collapsible/Collapsible.vue
function ja(e, t, r, i, a, o) {
	return g(), n(i.CollapsibleRoot, f({ "data-slot": "collapsible" }, i.forwarded), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16);
}
var Ma = /*#__PURE__*/ j(Aa, [["render", ja], ["__file", "/workspace/packages/ui/src/components/ui/collapsible/Collapsible.vue"]]), Na = /*@__PURE__*/ c({
	__name: "CollapsibleContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get CollapsibleContent() {
				return Ve;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/collapsible/CollapsibleContent.vue
function Pa(e, t, r, i, a, o) {
	return g(), n(i.CollapsibleContent, f({ "data-slot": "collapsible-content" }, i.props), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var Fa = /*#__PURE__*/ j(Na, [["render", Pa], ["__file", "/workspace/packages/ui/src/components/ui/collapsible/CollapsibleContent.vue"]]), Ia = /*@__PURE__*/ c({
	__name: "CollapsibleTrigger",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get CollapsibleTrigger() {
				return Ue;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/collapsible/CollapsibleTrigger.vue
function La(e, t, r, i, a, o) {
	return g(), n(i.CollapsibleTrigger, f({ "data-slot": "collapsible-trigger" }, i.props), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var Ra = /*#__PURE__*/ j(Ia, [["render", La], ["__file", "/workspace/packages/ui/src/components/ui/collapsible/CollapsibleTrigger.vue"]]), za = /*@__PURE__*/ c({
	__name: "Command",
	props: {
		modelValue: {
			type: null,
			required: !1,
			default: ""
		},
		defaultValue: {
			type: null,
			required: !1
		},
		multiple: {
			type: Boolean,
			required: !1
		},
		orientation: {
			type: String,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		selectionBehavior: {
			type: String,
			required: !1
		},
		highlightOnHover: {
			type: Boolean,
			required: !1,
			default: !0
		},
		loop: {
			type: Boolean,
			required: !1
		},
		by: {
			type: [String, Function],
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: [
		"update:modelValue",
		"highlight",
		"entryFocus",
		"leave"
	],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = T(a, i), s = _(/* @__PURE__ */ new Map()), c = _(/* @__PURE__ */ new Map()), { contains: l } = Jn({ sensitivity: "base" }), u = re({
			search: "",
			filtered: {
				count: 0,
				items: /* @__PURE__ */ new Map(),
				groups: /* @__PURE__ */ new Set()
			}
		});
		function d() {
			if (!u.search) {
				u.filtered.count = s.value.size;
				return;
			}
			u.filtered.groups = /* @__PURE__ */ new Set();
			let e = 0;
			for (let [t, n] of s.value) {
				let r = l(n, u.search);
				u.filtered.items.set(t, +!!r), r && e++;
			}
			for (let [e, t] of c.value) for (let n of t) if (u.filtered.items.get(n) > 0) {
				u.filtered.groups.add(e);
				break;
			}
			u.filtered.count = e;
		}
		ce(() => u.search, () => {
			d();
		}), zo({
			allItems: s,
			allGroups: c,
			filterState: u
		});
		let f = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: o,
			allItems: s,
			allGroups: c,
			contains: l,
			filterState: u,
			filterItems: d,
			get cn() {
				return M;
			},
			get ListboxRoot() {
				return Ct;
			}
		};
		return Object.defineProperty(f, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), f;
	}
});
// src/components/ui/command/Command.vue
function Ba(e, t, r, i, a, o) {
	return g(), n(i.ListboxRoot, f({ "data-slot": "command" }, i.forwarded, { class: i.cn("glass-panel text-popover-foreground flex h-full w-full flex-col overflow-hidden rounded-md", i.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var F = /*#__PURE__*/ j(za, [["render", Ba], ["__file", "/workspace/packages/ui/src/components/ui/command/Command.vue"]]), Va = /*@__PURE__*/ c({
	__name: "Dialog",
	props: {
		open: {
			type: Boolean,
			required: !1
		},
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		modal: {
			type: Boolean,
			required: !1
		},
		unmountOnHide: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = {
			props: r,
			emits: i,
			forwarded: T(r, i),
			get DialogRoot() {
				return Je;
			}
		};
		return Object.defineProperty(a, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), a;
	}
});
// src/components/ui/dialog/Dialog.vue
function Ha(e, t, r, i, a, o) {
	return g(), n(i.DialogRoot, f({ "data-slot": "dialog" }, i.forwarded), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16);
}
var Ua = /*#__PURE__*/ j(Va, [["render", Ha], ["__file", "/workspace/packages/ui/src/components/ui/dialog/Dialog.vue"]]), Wa = /*@__PURE__*/ c({
	__name: "DialogClose",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get DialogClose() {
				return S;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/dialog/DialogClose.vue
function Ga(e, t, r, i, a, o) {
	return g(), n(i.DialogClose, f({ "data-slot": "dialog-close" }, i.props), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var Ka = /*#__PURE__*/ j(Wa, [["render", Ga], ["__file", "/workspace/packages/ui/src/components/ui/dialog/DialogClose.vue"]]), qa = /*@__PURE__*/ c({
	__name: "DialogOverlay",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get DialogOverlay() {
				return Ke;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/dialog/DialogOverlay.vue
function Ja(e, t, r, i, a, o) {
	return g(), n(i.DialogOverlay, f({ "data-slot": "dialog-overlay" }, i.delegatedProps, { class: i.cn("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-background/30 backdrop-blur-md", i.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var Ya = /*#__PURE__*/ j(qa, [["render", Ja], ["__file", "/workspace/packages/ui/src/components/ui/dialog/DialogOverlay.vue"]]), Xa = /*@__PURE__*/ c({
	inheritAttrs: !1,
	__name: "DialogContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		},
		showCloseButton: {
			type: Boolean,
			required: !1,
			default: !0
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class", "showCloseButton"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get X() {
				return k;
			},
			get cn() {
				return M;
			},
			get DialogClose() {
				return S;
			},
			get DialogContent() {
				return We;
			},
			get DialogPortal() {
				return qe;
			},
			DialogOverlay: Ya
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/dialog/DialogContent.vue
function Za(e, t, i, o, c, l) {
	return g(), n(o.DialogPortal, null, {
		default: x(() => [s(o.DialogOverlay), s(o.DialogContent, f({ "data-slot": "dialog-content" }, {
			...e.$attrs,
			...o.forwarded
		}, { class: o.cn("glass-panel data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-xl p-6 duration-200 sm:max-w-lg", o.props.class) }), {
			default: x(() => [y(e.$slots, "default"), i.showCloseButton ? (g(), n(o.DialogClose, {
				key: 0,
				"data-slot": "dialog-close",
				class: "ring-offset-background focus:ring-ring data-[state=open]:bg-accent data-[state=open]:text-muted-foreground absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4"
			}, {
				default: x(() => [s(o.X), t[0] ||= a("span", { class: "sr-only" }, "Close", -1)]),
				_: 1
			})) : r("v-if", !0)]),
			_: 3
		}, 16, ["class"])]),
		_: 3
	});
}
var Qa = /*#__PURE__*/ j(Xa, [["render", Za], ["__file", "/workspace/packages/ui/src/components/ui/dialog/DialogContent.vue"]]), $a = /*@__PURE__*/ c({
	__name: "DialogDescription",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get cn() {
				return M;
			},
			get DialogDescription() {
				return Ge;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/dialog/DialogDescription.vue
function eo(e, t, r, i, a, o) {
	return g(), n(i.DialogDescription, f({ "data-slot": "dialog-description" }, i.forwardedProps, { class: i.cn("text-muted-foreground text-sm", i.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var to = /*#__PURE__*/ j($a, [["render", eo], ["__file", "/workspace/packages/ui/src/components/ui/dialog/DialogDescription.vue"]]), no = /*@__PURE__*/ c({
	__name: "DialogFooter",
	props: {
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		},
		showCloseButton: {
			type: Boolean,
			required: !1,
			default: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			},
			get DialogClose() {
				return S;
			},
			get Button() {
				return N;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/dialog/DialogFooter.vue
function ro(e, t, a, c, l, u) {
	return g(), i("div", {
		"data-slot": "dialog-footer",
		class: p(c.cn("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", c.props.class))
	}, [y(e.$slots, "default"), a.showCloseButton ? (g(), n(c.DialogClose, {
		key: 0,
		"as-child": ""
	}, {
		default: x(() => [s(c.Button, { variant: "outline" }, {
			default: x(() => [...t[0] ||= [o(" Close ", -1)]]),
			_: 1
		})]),
		_: 1
	})) : r("v-if", !0)], 2);
}
var io = /*#__PURE__*/ j(no, [["render", ro], ["__file", "/workspace/packages/ui/src/components/ui/dialog/DialogFooter.vue"]]), ao = /*@__PURE__*/ c({
	__name: "DialogHeader",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/dialog/DialogHeader.vue
function oo(e, t, n, r, a, o) {
	return g(), i("div", {
		"data-slot": "dialog-header",
		class: p(r.cn("flex flex-col gap-2 text-center sm:text-left", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var so = /*#__PURE__*/ j(ao, [["render", oo], ["__file", "/workspace/packages/ui/src/components/ui/dialog/DialogHeader.vue"]]), co = /*@__PURE__*/ c({
	inheritAttrs: !1,
	__name: "DialogScrollContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get X() {
				return k;
			},
			get cn() {
				return M;
			},
			get DialogClose() {
				return S;
			},
			get DialogContent() {
				return We;
			},
			get DialogOverlay() {
				return Ke;
			},
			get DialogPortal() {
				return qe;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/dialog/DialogScrollContent.vue
function lo(e, t, r, i, o, c) {
	return g(), n(i.DialogPortal, null, {
		default: x(() => [s(i.DialogOverlay, { class: "fixed inset-0 z-50 grid place-items-center overflow-y-auto bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" }, {
			default: x(() => [s(i.DialogContent, f({ class: i.cn("relative z-50 grid w-full max-w-lg my-8 gap-4 border border-border bg-background p-6 shadow-lg duration-200 sm:rounded-lg md:w-full", i.props.class) }, {
				...e.$attrs,
				...i.forwarded
			}, { onPointerDownOutside: t[0] ||= (e) => {
				let t = e.detail.originalEvent, n = t.target;
				(t.offsetX > n.clientWidth || t.offsetY > n.clientHeight) && e.preventDefault();
			} }), {
				default: x(() => [y(e.$slots, "default"), s(i.DialogClose, { class: "absolute top-4 right-4 p-0.5 transition-colors rounded-md hover:bg-secondary" }, {
					default: x(() => [s(i.X, { class: "w-4 h-4" }), t[1] ||= a("span", { class: "sr-only" }, "Close", -1)]),
					_: 1
				})]),
				_: 3
			}, 16, ["class"])]),
			_: 3
		})]),
		_: 3
	});
}
var uo = /*#__PURE__*/ j(co, [["render", lo], ["__file", "/workspace/packages/ui/src/components/ui/dialog/DialogScrollContent.vue"]]), fo = /*@__PURE__*/ c({
	__name: "DialogTitle",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get cn() {
				return M;
			},
			get DialogTitle() {
				return Ye;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/dialog/DialogTitle.vue
function po(e, t, r, i, a, o) {
	return g(), n(i.DialogTitle, f({ "data-slot": "dialog-title" }, i.forwardedProps, { class: i.cn("text-lg leading-none font-semibold", i.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var mo = /*#__PURE__*/ j(fo, [["render", po], ["__file", "/workspace/packages/ui/src/components/ui/dialog/DialogTitle.vue"]]), ho = /*@__PURE__*/ c({
	__name: "DialogTrigger",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get DialogTrigger() {
				return Xe;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/dialog/DialogTrigger.vue
function go(e, t, r, i, a, o) {
	return g(), n(i.DialogTrigger, f({ "data-slot": "dialog-trigger" }, i.props), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var _o = /*#__PURE__*/ j(ho, [["render", go], ["__file", "/workspace/packages/ui/src/components/ui/dialog/DialogTrigger.vue"]]), vo = /*@__PURE__*/ c({
	__name: "CommandDialog",
	props: {
		open: {
			type: Boolean,
			required: !1
		},
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		modal: {
			type: Boolean,
			required: !1
		},
		unmountOnHide: {
			type: Boolean,
			required: !1
		},
		title: {
			type: String,
			required: !1,
			default: "Command Palette"
		},
		description: {
			type: String,
			required: !1,
			default: "Search for a command to run..."
		}
	},
	emits: ["update:open"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = {
			props: r,
			emits: i,
			forwarded: T(r, i),
			get Dialog() {
				return Ua;
			},
			get DialogContent() {
				return Qa;
			},
			get DialogDescription() {
				return to;
			},
			get DialogHeader() {
				return so;
			},
			get DialogTitle() {
				return mo;
			},
			Command: F
		};
		return Object.defineProperty(a, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), a;
	}
});
// src/components/ui/command/CommandDialog.vue
function yo(e, t, r, i, a, c) {
	return g(), n(i.Dialog, m(l(i.forwarded)), {
		default: x((t) => [s(i.DialogContent, { class: "overflow-hidden p-0" }, {
			default: x(() => [s(i.DialogHeader, { class: "sr-only" }, {
				default: x(() => [s(i.DialogTitle, null, {
					default: x(() => [o(b(r.title), 1)]),
					_: 1
				}), s(i.DialogDescription, null, {
					default: x(() => [o(b(r.description), 1)]),
					_: 1
				})]),
				_: 1
			}), s(i.Command, null, {
				default: x(() => [y(e.$slots, "default", m(l(t)))]),
				_: 2
			}, 1024)]),
			_: 2
		}, 1024)]),
		_: 3
	}, 16);
}
var bo = /*#__PURE__*/ j(vo, [["render", yo], ["__file", "/workspace/packages/ui/src/components/ui/command/CommandDialog.vue"]]), xo = /*@__PURE__*/ c({
	__name: "CommandEmpty",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: n }) {
		n();
		let r = e, i = E(r, "class"), { filterState: a } = V(), o = {
			props: r,
			delegatedProps: i,
			filterState: a,
			isRender: t(() => !!a.search && a.filtered.count === 0),
			get cn() {
				return M;
			},
			get Primitive() {
				return C;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/command/CommandEmpty.vue
function So(e, t, i, a, o, s) {
	return a.isRender ? (g(), n(a.Primitive, f({
		key: 0,
		"data-slot": "command-empty"
	}, a.delegatedProps, { class: a.cn("py-6 text-center text-sm", a.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"])) : r("v-if", !0);
}
var I = /*#__PURE__*/ j(xo, [["render", So], ["__file", "/workspace/packages/ui/src/components/ui/command/CommandEmpty.vue"]]), Co = /*@__PURE__*/ c({
	__name: "CommandGroup",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		},
		heading: {
			type: String,
			required: !1
		}
	},
	setup(e, { expose: n }) {
		n();
		let r = e, i = E(r, "class"), { allGroups: a, filterState: o } = V(), s = Yn(), c = t(() => !o.search || o.filtered.groups.has(s));
		Vo({ id: s }), ee(() => {
			a.value.has(s) || a.value.set(s, /* @__PURE__ */ new Set());
		}), te(() => {
			a.value.delete(s);
		});
		let l = {
			props: r,
			delegatedProps: i,
			allGroups: a,
			filterState: o,
			id: s,
			isRender: c,
			get cn() {
				return M;
			},
			get ListboxGroup() {
				return bt;
			},
			get ListboxGroupLabel() {
				return xt;
			}
		};
		return Object.defineProperty(l, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), l;
	}
});
// src/components/ui/command/CommandGroup.vue
function wo(e, t, i, a, s, c) {
	return g(), n(a.ListboxGroup, f(a.delegatedProps, {
		id: a.id,
		"data-slot": "command-group",
		class: a.cn("text-foreground overflow-hidden p-1", a.props.class),
		hidden: !a.isRender || void 0
	}), {
		default: x(() => [i.heading ? (g(), n(a.ListboxGroupLabel, {
			key: 0,
			"data-slot": "command-group-heading",
			class: "px-2 py-1.5 text-xs font-medium text-muted-foreground"
		}, {
			default: x(() => [o(b(i.heading), 1)]),
			_: 1
		})) : r("v-if", !0), y(e.$slots, "default")]),
		_: 3
	}, 16, [
		"id",
		"class",
		"hidden"
	]);
}
var L = /*#__PURE__*/ j(Co, [["render", wo], ["__file", "/workspace/packages/ui/src/components/ui/command/CommandGroup.vue"]]), To = /*@__PURE__*/ c({
	inheritAttrs: !1,
	__name: "CommandInput",
	props: {
		modelValue: {
			type: String,
			required: !1
		},
		autoFocus: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = w(r), { filterState: a } = V(), o = {
			props: n,
			delegatedProps: r,
			forwardedProps: i,
			filterState: a,
			get Search() {
				return vr;
			},
			get cn() {
				return M;
			},
			get ListboxFilter() {
				return yt;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
}), Eo = {
	"data-slot": "command-input-wrapper",
	class: "flex h-9 items-center gap-2 border-b px-3"
};
function Do(e, t, n, r, a, o) {
	return g(), i("div", Eo, [s(r.Search, { class: "size-4 shrink-0 opacity-50" }), s(r.ListboxFilter, f({
		...r.forwardedProps,
		...e.$attrs
	}, {
		modelValue: r.filterState.search,
		"onUpdate:modelValue": t[0] ||= (e) => r.filterState.search = e,
		"data-slot": "command-input",
		"auto-focus": "",
		class: r.cn("placeholder:text-muted-foreground flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-hidden disabled:cursor-not-allowed disabled:opacity-50", r.props.class)
	}), null, 16, ["modelValue", "class"])]);
}
var R = /*#__PURE__*/ j(To, [["render", Do], ["__file", "/workspace/packages/ui/src/components/ui/command/CommandInput.vue"]]), Oo = /*@__PURE__*/ c({
	__name: "CommandItem",
	props: {
		value: {
			type: null,
			required: !0
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: ["select"],
	setup(e, { expose: n, emit: r }) {
		n();
		let i = e, a = r, o = E(i, "class"), s = T(o, a), c = Yn(), { filterState: l, allItems: u, allGroups: d } = V(), f = Bo(), p = t(() => {
			if (l.search) {
				let e = l.filtered.items.get(c);
				return e === void 0 || e > 0;
			}
			return !0;
		}), m = _(), h = Xn(m);
		ee(() => {
			if (!(h.value instanceof HTMLElement)) return;
			u.value.set(c, h.value.textContent ?? i.value?.toString() ?? "");
			let e = f?.id;
			e && (d.value.has(e) ? d.value.get(e)?.add(c) : d.value.set(e, /* @__PURE__ */ new Set([c])));
		}), te(() => {
			u.value.delete(c);
		});
		let g = {
			props: i,
			emits: a,
			delegatedProps: o,
			forwarded: s,
			id: c,
			filterState: l,
			allItems: u,
			allGroups: d,
			groupContext: f,
			isRender: p,
			itemRef: m,
			currentElement: h,
			get cn() {
				return M;
			},
			get ListboxItem() {
				return St;
			}
		};
		return Object.defineProperty(g, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), g;
	}
});
// src/components/ui/command/CommandItem.vue
function ko(e, t, i, a, o, s) {
	return a.isRender ? (g(), n(a.ListboxItem, f({ key: 0 }, a.forwarded, {
		id: a.id,
		ref: "itemRef",
		"data-slot": "command-item",
		class: a.cn("data-[highlighted]:bg-accent data-[highlighted]:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", a.props.class),
		onSelect: t[0] ||= () => {
			a.filterState.search = "";
		}
	}), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["id", "class"])) : r("v-if", !0);
}
var z = /*#__PURE__*/ j(Oo, [["render", ko], ["__file", "/workspace/packages/ui/src/components/ui/command/CommandItem.vue"]]), Ao = /*@__PURE__*/ c({
	__name: "CommandList",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwarded: w(r),
			get cn() {
				return M;
			},
			get ListboxContent() {
				return vt;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
}), jo = { role: "presentation" };
function Mo(e, t, r, i, o, s) {
	return g(), n(i.ListboxContent, f({ "data-slot": "command-list" }, i.forwarded, { class: i.cn("max-h-[300px] scroll-py-1 overflow-x-hidden overflow-y-auto", i.props.class) }), {
		default: x(() => [a("div", jo, [y(e.$slots, "default")])]),
		_: 3
	}, 16, ["class"]);
}
var B = /*#__PURE__*/ j(Ao, [["render", Mo], ["__file", "/workspace/packages/ui/src/components/ui/command/CommandList.vue"]]), No = /*@__PURE__*/ c({
	__name: "CommandSeparator",
	props: {
		orientation: {
			type: String,
			required: !1
		},
		decorative: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get Separator() {
				return Dn;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/command/CommandSeparator.vue
function Po(e, t, r, i, a, o) {
	return g(), n(i.Separator, f({ "data-slot": "command-separator" }, i.delegatedProps, { class: i.cn("bg-border -mx-1 h-px", i.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var Fo = /*#__PURE__*/ j(No, [["render", Po], ["__file", "/workspace/packages/ui/src/components/ui/command/CommandSeparator.vue"]]), Io = /*@__PURE__*/ c({
	__name: "CommandShortcut",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/command/CommandShortcut.vue
function Lo(e, t, n, r, a, o) {
	return g(), i("span", {
		"data-slot": "command-shortcut",
		class: p(r.cn("text-muted-foreground ml-auto text-xs tracking-widest", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var Ro = /*#__PURE__*/ j(Io, [["render", Lo], ["__file", "/workspace/packages/ui/src/components/ui/command/CommandShortcut.vue"]]), [V, zo] = qn("Command"), [Bo, Vo] = qn("CommandGroup"), Ho = /*@__PURE__*/ c({
	__name: "DropdownMenu",
	props: {
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		open: {
			type: Boolean,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		modal: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = {
			props: r,
			emits: i,
			forwarded: T(r, i),
			get DropdownMenuRoot() {
				return st;
			}
		};
		return Object.defineProperty(a, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), a;
	}
});
// src/components/ui/dropdown-menu/DropdownMenu.vue
function Uo(e, t, r, i, a, o) {
	return g(), n(i.DropdownMenuRoot, f({ "data-slot": "dropdown-menu" }, i.forwarded), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16);
}
var Wo = /*#__PURE__*/ j(Ho, [["render", Uo], ["__file", "/workspace/packages/ui/src/components/ui/dropdown-menu/DropdownMenu.vue"]]), Go = /*@__PURE__*/ c({
	__name: "DropdownMenuCheckboxItem",
	props: {
		modelValue: {
			type: [Boolean, String],
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: ["select", "update:modelValue"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get Check() {
				return D;
			},
			get cn() {
				return M;
			},
			get DropdownMenuCheckboxItem() {
				return Ze;
			},
			get DropdownMenuItemIndicator() {
				return tt;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
}), Ko = { class: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center" };
function qo(e, t, r, i, o, c) {
	return g(), n(i.DropdownMenuCheckboxItem, f({ "data-slot": "dropdown-menu-checkbox-item" }, i.forwarded, { class: i.cn("focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", i.props.class) }), {
		default: x(() => [a("span", Ko, [s(i.DropdownMenuItemIndicator, null, {
			default: x(() => [y(e.$slots, "indicator-icon", {}, () => [s(i.Check, { class: "size-4" })])]),
			_: 3
		})]), y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var Jo = /*#__PURE__*/ j(Go, [["render", qo], ["__file", "/workspace/packages/ui/src/components/ui/dropdown-menu/DropdownMenuCheckboxItem.vue"]]), Yo = /*@__PURE__*/ c({
	inheritAttrs: !1,
	__name: "DropdownMenuContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		loop: {
			type: Boolean,
			required: !1
		},
		memoDependencies: {
			type: Array,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1,
			default: 4
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		hideShiftedArrow: {
			type: Boolean,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get cn() {
				return M;
			},
			get DropdownMenuContent() {
				return Qe;
			},
			get DropdownMenuPortal() {
				return it;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/dropdown-menu/DropdownMenuContent.vue
function Xo(e, t, r, i, a, o) {
	return g(), n(i.DropdownMenuPortal, null, {
		default: x(() => [s(i.DropdownMenuContent, f({ "data-slot": "dropdown-menu-content" }, {
			...e.$attrs,
			...i.forwarded
		}, { class: i.cn("glass-panel text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 max-h-(--reka-dropdown-menu-content-available-height) min-w-[8rem] origin-(--reka-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md p-1", i.props.class) }), {
			default: x(() => [y(e.$slots, "default")]),
			_: 3
		}, 16, ["class"])]),
		_: 3
	});
}
var Zo = /*#__PURE__*/ j(Yo, [["render", Xo], ["__file", "/workspace/packages/ui/src/components/ui/dropdown-menu/DropdownMenuContent.vue"]]), Qo = /*@__PURE__*/ c({
	__name: "DropdownMenuGroup",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get DropdownMenuGroup() {
				return $e;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/dropdown-menu/DropdownMenuGroup.vue
function $o(e, t, r, i, a, o) {
	return g(), n(i.DropdownMenuGroup, f({ "data-slot": "dropdown-menu-group" }, i.props), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var es = /*#__PURE__*/ j(Qo, [["render", $o], ["__file", "/workspace/packages/ui/src/components/ui/dropdown-menu/DropdownMenuGroup.vue"]]), ts = /*@__PURE__*/ c({
	__name: "DropdownMenuItem",
	props: {
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		},
		inset: {
			type: Boolean,
			required: !1
		},
		variant: {
			type: String,
			required: !1,
			default: "default"
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "inset", "variant", "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get cn() {
				return M;
			},
			get DropdownMenuItem() {
				return et;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/dropdown-menu/DropdownMenuItem.vue
function ns(e, t, r, i, a, o) {
	return g(), n(i.DropdownMenuItem, f({
		"data-slot": "dropdown-menu-item",
		"data-inset": r.inset ? "" : void 0,
		"data-variant": r.variant
	}, i.forwardedProps, { class: i.cn("relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 data-[variant=destructive]:focus:text-destructive dark:data-[variant=destructive]:focus:bg-destructive/20 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground data-[variant=destructive]:*:[svg]:text-destructive!", i.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, [
		"data-inset",
		"data-variant",
		"class"
	]);
}
var rs = /*#__PURE__*/ j(ts, [["render", ns], ["__file", "/workspace/packages/ui/src/components/ui/dropdown-menu/DropdownMenuItem.vue"]]), is = /*@__PURE__*/ c({
	__name: "DropdownMenuLabel",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		},
		inset: {
			type: Boolean,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class", "inset"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get cn() {
				return M;
			},
			get DropdownMenuLabel() {
				return nt;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/dropdown-menu/DropdownMenuLabel.vue
function as(e, t, r, i, a, o) {
	return g(), n(i.DropdownMenuLabel, f({
		"data-slot": "dropdown-menu-label",
		"data-inset": r.inset ? "" : void 0
	}, i.forwardedProps, { class: i.cn("px-2 py-1.5 text-sm font-medium data-[inset]:pl-8", i.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["data-inset", "class"]);
}
var os = /*#__PURE__*/ j(is, [["render", as], ["__file", "/workspace/packages/ui/src/components/ui/dropdown-menu/DropdownMenuLabel.vue"]]), ss = /*@__PURE__*/ c({
	__name: "DropdownMenuRadioGroup",
	props: {
		modelValue: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = {
			props: r,
			emits: i,
			forwarded: T(r, i),
			get DropdownMenuRadioGroup() {
				return at;
			}
		};
		return Object.defineProperty(a, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), a;
	}
});
// src/components/ui/dropdown-menu/DropdownMenuRadioGroup.vue
function cs(e, t, r, i, a, o) {
	return g(), n(i.DropdownMenuRadioGroup, f({ "data-slot": "dropdown-menu-radio-group" }, i.forwarded), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var ls = /*#__PURE__*/ j(ss, [["render", cs], ["__file", "/workspace/packages/ui/src/components/ui/dropdown-menu/DropdownMenuRadioGroup.vue"]]), us = /*@__PURE__*/ c({
	__name: "DropdownMenuRadioItem",
	props: {
		value: {
			type: null,
			required: !0
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: ["select"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get Circle() {
				return or;
			},
			get cn() {
				return M;
			},
			get DropdownMenuItemIndicator() {
				return tt;
			},
			get DropdownMenuRadioItem() {
				return ot;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
}), ds = { class: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center" };
function fs(e, t, r, i, o, c) {
	return g(), n(i.DropdownMenuRadioItem, f({ "data-slot": "dropdown-menu-radio-item" }, i.forwarded, { class: i.cn("focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", i.props.class) }), {
		default: x(() => [a("span", ds, [s(i.DropdownMenuItemIndicator, null, {
			default: x(() => [y(e.$slots, "indicator-icon", {}, () => [s(i.Circle, { class: "size-2 fill-current" })])]),
			_: 3
		})]), y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var ps = /*#__PURE__*/ j(us, [["render", fs], ["__file", "/workspace/packages/ui/src/components/ui/dropdown-menu/DropdownMenuRadioItem.vue"]]), ms = /*@__PURE__*/ c({
	__name: "DropdownMenuSeparator",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get DropdownMenuSeparator() {
				return ct;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/dropdown-menu/DropdownMenuSeparator.vue
function hs(e, t, r, i, a, o) {
	return g(), n(i.DropdownMenuSeparator, f({ "data-slot": "dropdown-menu-separator" }, i.delegatedProps, { class: i.cn("bg-border -mx-1 my-1 h-px", i.props.class) }), null, 16, ["class"]);
}
var gs = /*#__PURE__*/ j(ms, [["render", hs], ["__file", "/workspace/packages/ui/src/components/ui/dropdown-menu/DropdownMenuSeparator.vue"]]), _s = /*@__PURE__*/ c({
	__name: "DropdownMenuShortcut",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/dropdown-menu/DropdownMenuShortcut.vue
function vs(e, t, n, r, a, o) {
	return g(), i("span", {
		"data-slot": "dropdown-menu-shortcut",
		class: p(r.cn("text-muted-foreground ml-auto text-xs tracking-widest", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var ys = /*#__PURE__*/ j(_s, [["render", vs], ["__file", "/workspace/packages/ui/src/components/ui/dropdown-menu/DropdownMenuShortcut.vue"]]), bs = /*@__PURE__*/ c({
	__name: "DropdownMenuSub",
	props: {
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		open: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = {
			props: r,
			emits: i,
			forwarded: T(r, i),
			get DropdownMenuSub() {
				return lt;
			}
		};
		return Object.defineProperty(a, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), a;
	}
});
// src/components/ui/dropdown-menu/DropdownMenuSub.vue
function xs(e, t, r, i, a, o) {
	return g(), n(i.DropdownMenuSub, f({ "data-slot": "dropdown-menu-sub" }, i.forwarded), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16);
}
var Ss = /*#__PURE__*/ j(bs, [["render", xs], ["__file", "/workspace/packages/ui/src/components/ui/dropdown-menu/DropdownMenuSub.vue"]]), Cs = /*@__PURE__*/ c({
	__name: "DropdownMenuSubContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		loop: {
			type: Boolean,
			required: !1
		},
		memoDependencies: {
			type: Array,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		hideShiftedArrow: {
			type: Boolean,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"entryFocus",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get cn() {
				return M;
			},
			get DropdownMenuSubContent() {
				return ut;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/dropdown-menu/DropdownMenuSubContent.vue
function ws(e, t, r, i, a, o) {
	return g(), n(i.DropdownMenuSubContent, f({ "data-slot": "dropdown-menu-sub-content" }, i.forwarded, { class: i.cn("glass-panel text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] max-w-(--reka-dropdown-menu-content-available-width) origin-(--reka-dropdown-menu-content-transform-origin) overflow-hidden rounded-md p-1", i.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var Ts = /*#__PURE__*/ j(Cs, [["render", ws], ["__file", "/workspace/packages/ui/src/components/ui/dropdown-menu/DropdownMenuSubContent.vue"]]), Es = /*@__PURE__*/ c({
	__name: "DropdownMenuSubTrigger",
	props: {
		graceDuration: {
			type: Number,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		},
		inset: {
			type: Boolean,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class", "inset"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get ChevronRight() {
				return O;
			},
			get cn() {
				return M;
			},
			get DropdownMenuSubTrigger() {
				return dt;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/dropdown-menu/DropdownMenuSubTrigger.vue
function Ds(e, t, r, i, a, o) {
	return g(), n(i.DropdownMenuSubTrigger, f({ "data-slot": "dropdown-menu-sub-trigger" }, i.forwardedProps, {
		"data-inset": r.inset ? "" : void 0,
		class: i.cn("relative flex cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 data-[inset]:pl-8 data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 data-[variant=destructive]:focus:text-destructive dark:data-[variant=destructive]:focus:bg-destructive/20 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground data-[variant=destructive]:*:[svg]:text-destructive!", i.props.class)
	}), {
		default: x(() => [y(e.$slots, "default"), s(i.ChevronRight, { class: "ml-auto size-4" })]),
		_: 3
	}, 16, ["data-inset", "class"]);
}
var Os = /*#__PURE__*/ j(Es, [["render", Ds], ["__file", "/workspace/packages/ui/src/components/ui/dropdown-menu/DropdownMenuSubTrigger.vue"]]), ks = /*@__PURE__*/ c({
	__name: "DropdownMenuTrigger",
	props: {
		disabled: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			forwardedProps: w(n),
			get DropdownMenuTrigger() {
				return ft;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/dropdown-menu/DropdownMenuTrigger.vue
function As(e, t, r, i, a, o) {
	return g(), n(i.DropdownMenuTrigger, f({ "data-slot": "dropdown-menu-trigger" }, i.forwardedProps), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var js = /*#__PURE__*/ j(ks, [["render", As], ["__file", "/workspace/packages/ui/src/components/ui/dropdown-menu/DropdownMenuTrigger.vue"]]), Ms = /*@__PURE__*/ c({
	__name: "HoverCard",
	props: {
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		open: {
			type: Boolean,
			required: !1
		},
		openDelay: {
			type: Number,
			required: !1
		},
		closeDelay: {
			type: Number,
			required: !1
		},
		enableTouch: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = {
			props: r,
			emits: i,
			forwarded: T(r, i),
			get HoverCardRoot() {
				return ht;
			}
		};
		return Object.defineProperty(a, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), a;
	}
});
// src/components/ui/hover-card/HoverCard.vue
function Ns(e, t, r, i, a, o) {
	return g(), n(i.HoverCardRoot, f({ "data-slot": "hover-card" }, i.forwarded), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16);
}
var Ps = /*#__PURE__*/ j(Ms, [["render", Ns], ["__file", "/workspace/packages/ui/src/components/ui/hover-card/HoverCard.vue"]]), Fs = /*@__PURE__*/ c({
	inheritAttrs: !1,
	__name: "HoverCardContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		memoDependencies: {
			type: Array,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1,
			default: 4
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		hideShiftedArrow: {
			type: Boolean,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get cn() {
				return M;
			},
			get HoverCardContent() {
				return pt;
			},
			get HoverCardPortal() {
				return mt;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/hover-card/HoverCardContent.vue
function Is(e, t, r, i, a, o) {
	return g(), n(i.HoverCardPortal, null, {
		default: x(() => [s(i.HoverCardContent, f({ "data-slot": "hover-card-content" }, {
			...e.$attrs,
			...i.forwardedProps
		}, { class: i.cn("glass-panel text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-64 rounded-md p-4 outline-hidden", i.props.class) }), {
			default: x(() => [y(e.$slots, "default")]),
			_: 3
		}, 16, ["class"])]),
		_: 3
	});
}
var Ls = /*#__PURE__*/ j(Fs, [["render", Is], ["__file", "/workspace/packages/ui/src/components/ui/hover-card/HoverCardContent.vue"]]), Rs = /*@__PURE__*/ c({
	__name: "HoverCardTrigger",
	props: {
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get HoverCardTrigger() {
				return gt;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/hover-card/HoverCardTrigger.vue
function zs(e, t, r, i, a, o) {
	return g(), n(i.HoverCardTrigger, f({ "data-slot": "hover-card-trigger" }, i.props), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var Bs = /*#__PURE__*/ j(Rs, [["render", zs], ["__file", "/workspace/packages/ui/src/components/ui/hover-card/HoverCardTrigger.vue"]]), Vs = /*@__PURE__*/ c({
	__name: "Input",
	props: {
		defaultValue: {
			type: [String, Number],
			required: !1
		},
		modelValue: {
			type: [String, Number],
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = {
			props: r,
			emits: i,
			modelValue: Zn(r, "modelValue", i, {
				passive: !0,
				defaultValue: r.defaultValue
			}),
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(a, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), a;
	}
});
// src/components/ui/input/Input.vue
function Hs(e, t, n, r, a, o) {
	return le((g(), i("input", {
		"onUpdate:modelValue": t[0] ||= (e) => r.modelValue = e,
		"data-slot": "input",
		class: p(r.cn("file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground h-9 w-full min-w-0 rounded-md glass-input px-3 py-1 text-base shadow-none transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", "focus-visible:ring-ring focus-visible:ring-1", "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", r.props.class))
	}, null, 2)), [[se, r.modelValue]]);
}
var Us = /*#__PURE__*/ j(Vs, [["render", Hs], ["__file", "/workspace/packages/ui/src/components/ui/input/Input.vue"]]), Ws = /*@__PURE__*/ c({
	__name: "Label",
	props: {
		for: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get Label() {
				return _t;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/label/Label.vue
function Gs(e, t, r, i, a, o) {
	return g(), n(i.Label, f({ "data-slot": "label" }, i.delegatedProps, { class: i.cn("flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50", i.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var Ks = /*#__PURE__*/ j(Ws, [["render", Gs], ["__file", "/workspace/packages/ui/src/components/ui/label/Label.vue"]]), qs = /*@__PURE__*/ c({
	__name: "NumberField",
	props: {
		defaultValue: {
			type: Number,
			required: !1
		},
		modelValue: {
			type: [Number, null],
			required: !1
		},
		min: {
			type: Number,
			required: !1
		},
		max: {
			type: Number,
			required: !1
		},
		step: {
			type: Number,
			required: !1
		},
		stepSnapping: {
			type: Boolean,
			required: !1
		},
		allowInvalid: {
			type: Boolean,
			required: !1
		},
		focusOnChange: {
			type: Boolean,
			required: !1
		},
		formatOptions: {
			type: null,
			required: !1
		},
		locale: {
			type: String,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		readonly: {
			type: Boolean,
			required: !1
		},
		disableWheelChange: {
			type: Boolean,
			required: !1
		},
		invertWheelChange: {
			type: Boolean,
			required: !1
		},
		id: {
			type: String,
			required: !1
		},
		startingValue: {
			type: Number,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get cn() {
				return M;
			},
			get NumberFieldRoot() {
				return Dt;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/number-field/NumberField.vue
function Js(e, t, r, i, a, o) {
	return g(), n(i.NumberFieldRoot, f(i.forwarded, { class: i.cn("grid gap-1.5", i.props.class) }), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16, ["class"]);
}
var Ys = /*#__PURE__*/ j(qs, [["render", Js], ["__file", "/workspace/packages/ui/src/components/ui/number-field/NumberField.vue"]]), Xs = /*@__PURE__*/ c({
	__name: "NumberFieldContent",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/number-field/NumberFieldContent.vue
function Zs(e, t, n, r, a, o) {
	return g(), i("div", { class: p(r.cn("relative [&>[data-slot=input]]:has-[[data-slot=increment]]:pr-5 [&>[data-slot=input]]:has-[[data-slot=decrement]]:pl-5", r.props.class)) }, [y(e.$slots, "default")], 2);
}
var Qs = /*#__PURE__*/ j(Xs, [["render", Zs], ["__file", "/workspace/packages/ui/src/components/ui/number-field/NumberFieldContent.vue"]]), $s = /*@__PURE__*/ c({
	__name: "NumberFieldDecrement",
	props: {
		disabled: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwarded: w(r),
			get Minus() {
				return pr;
			},
			get cn() {
				return M;
			},
			get NumberFieldDecrement() {
				return wt;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/number-field/NumberFieldDecrement.vue
function ec(e, t, r, i, a, o) {
	return g(), n(i.NumberFieldDecrement, f({ "data-slot": "decrement" }, i.forwarded, { class: i.cn("absolute top-1/2 -translate-y-1/2 left-0 p-3 disabled:cursor-not-allowed disabled:opacity-20", i.props.class) }), {
		default: x(() => [y(e.$slots, "default", {}, () => [s(i.Minus, { class: "h-4 w-4" })])]),
		_: 3
	}, 16, ["class"]);
}
var tc = /*#__PURE__*/ j($s, [["render", ec], ["__file", "/workspace/packages/ui/src/components/ui/number-field/NumberFieldDecrement.vue"]]), nc = /*@__PURE__*/ c({
	__name: "NumberFieldIncrement",
	props: {
		disabled: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwarded: w(r),
			get Plus() {
				return _r;
			},
			get cn() {
				return M;
			},
			get NumberFieldIncrement() {
				return Tt;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/number-field/NumberFieldIncrement.vue
function rc(e, t, r, i, a, o) {
	return g(), n(i.NumberFieldIncrement, f({ "data-slot": "increment" }, i.forwarded, { class: i.cn("absolute top-1/2 -translate-y-1/2 right-0 disabled:cursor-not-allowed disabled:opacity-20 p-3", i.props.class) }), {
		default: x(() => [y(e.$slots, "default", {}, () => [s(i.Plus, { class: "h-4 w-4" })])]),
		_: 3
	}, 16, ["class"]);
}
var ic = /*#__PURE__*/ j(nc, [["render", rc], ["__file", "/workspace/packages/ui/src/components/ui/number-field/NumberFieldIncrement.vue"]]), ac = /*@__PURE__*/ c({
	__name: "NumberFieldInput",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			},
			get NumberFieldInput() {
				return Et;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/number-field/NumberFieldInput.vue
function oc(e, t, r, i, a, o) {
	return g(), n(i.NumberFieldInput, {
		"data-slot": "input",
		class: p(i.cn("glass-input flex h-9 w-full rounded-md px-3 py-1 text-base tabular-nums transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", i.props.class))
	}, null, 8, ["class"]);
}
var sc = /*#__PURE__*/ j(ac, [["render", oc], ["__file", "/workspace/packages/ui/src/components/ui/number-field/NumberFieldInput.vue"]]), cc = /*@__PURE__*/ c({
	__name: "Pagination",
	props: {
		page: {
			type: Number,
			required: !1
		},
		defaultPage: {
			type: Number,
			required: !1
		},
		itemsPerPage: {
			type: Number,
			required: !0
		},
		total: {
			type: Number,
			required: !1
		},
		siblingCount: {
			type: Number,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		showEdges: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: ["update:page"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get cn() {
				return M;
			},
			get PaginationRoot() {
				return Ft;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/pagination/Pagination.vue
function lc(e, t, r, i, a, o) {
	return g(), n(i.PaginationRoot, f({ "data-slot": "pagination" }, i.forwarded, { class: i.cn("mx-auto flex w-full justify-center", i.props.class) }), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16, ["class"]);
}
var uc = /*#__PURE__*/ j(cc, [["render", lc], ["__file", "/workspace/packages/ui/src/components/ui/pagination/Pagination.vue"]]), dc = /*@__PURE__*/ c({
	__name: "PaginationContent",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get PaginationList() {
				return jt;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/pagination/PaginationContent.vue
function fc(e, t, r, i, a, o) {
	return g(), n(i.PaginationList, f({ "data-slot": "pagination-content" }, i.delegatedProps, { class: i.cn("flex flex-row items-center gap-1", i.props.class) }), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16, ["class"]);
}
var pc = /*#__PURE__*/ j(dc, [["render", fc], ["__file", "/workspace/packages/ui/src/components/ui/pagination/PaginationContent.vue"]]), mc = /*@__PURE__*/ c({
	__name: "PaginationEllipsis",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get MoreHorizontal() {
				return hr;
			},
			get cn() {
				return M;
			},
			get PaginationEllipsis() {
				return Ot;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/pagination/PaginationEllipsis.vue
function hc(e, t, r, i, o, c) {
	return g(), n(i.PaginationEllipsis, f({ "data-slot": "pagination-ellipsis" }, i.delegatedProps, { class: i.cn("flex size-9 items-center justify-center", i.props.class) }), {
		default: x(() => [y(e.$slots, "default", {}, () => [s(i.MoreHorizontal, { class: "size-4" }), t[0] ||= a("span", { class: "sr-only" }, "More pages", -1)])]),
		_: 3
	}, 16, ["class"]);
}
var gc = /*#__PURE__*/ j(mc, [["render", hc], ["__file", "/workspace/packages/ui/src/components/ui/pagination/PaginationEllipsis.vue"]]), _c = /*@__PURE__*/ c({
	__name: "PaginationFirst",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		size: {
			type: null,
			required: !1,
			default: "default"
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class", "size"), i = {
			props: n,
			delegatedProps: r,
			forwarded: w(r),
			get ChevronLeftIcon() {
				return nr;
			},
			get cn() {
				return M;
			},
			get PaginationFirst() {
				return kt;
			},
			get buttonVariants() {
				return P;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/pagination/PaginationFirst.vue
function vc(e, t, r, i, o, c) {
	return g(), n(i.PaginationFirst, f({
		"data-slot": "pagination-first",
		class: i.cn(i.buttonVariants({
			variant: "ghost",
			size: r.size
		}), "gap-1 px-2.5 sm:pr-2.5", i.props.class)
	}, i.forwarded), {
		default: x(() => [y(e.$slots, "default", {}, () => [s(i.ChevronLeftIcon), t[0] ||= a("span", { class: "hidden sm:block" }, "First", -1)])]),
		_: 3
	}, 16, ["class"]);
}
var yc = /*#__PURE__*/ j(_c, [["render", vc], ["__file", "/workspace/packages/ui/src/components/ui/pagination/PaginationFirst.vue"]]), bc = /*@__PURE__*/ c({
	__name: "PaginationItem",
	props: {
		value: {
			type: Number,
			required: !0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		size: {
			type: null,
			required: !1,
			default: "icon"
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		},
		isActive: {
			type: Boolean,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class", "size", "isActive"),
			get cn() {
				return M;
			},
			get PaginationListItem() {
				return Mt;
			},
			get buttonVariants() {
				return P;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/pagination/PaginationItem.vue
function xc(e, t, r, i, a, o) {
	return g(), n(i.PaginationListItem, f({ "data-slot": "pagination-item" }, i.delegatedProps, { class: i.cn(i.buttonVariants({
		variant: r.isActive ? "outline" : "ghost",
		size: r.size
	}), i.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var Sc = /*#__PURE__*/ j(bc, [["render", xc], ["__file", "/workspace/packages/ui/src/components/ui/pagination/PaginationItem.vue"]]), Cc = /*@__PURE__*/ c({
	__name: "PaginationLast",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		size: {
			type: null,
			required: !1,
			default: "default"
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class", "size"), i = {
			props: n,
			delegatedProps: r,
			forwarded: w(r),
			get ChevronRightIcon() {
				return rr;
			},
			get cn() {
				return M;
			},
			get PaginationLast() {
				return At;
			},
			get buttonVariants() {
				return P;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/pagination/PaginationLast.vue
function wc(e, t, r, i, o, c) {
	return g(), n(i.PaginationLast, f({
		"data-slot": "pagination-last",
		class: i.cn(i.buttonVariants({
			variant: "ghost",
			size: r.size
		}), "gap-1 px-2.5 sm:pr-2.5", i.props.class)
	}, i.forwarded), {
		default: x(() => [y(e.$slots, "default", {}, () => [t[0] ||= a("span", { class: "hidden sm:block" }, "Last", -1), s(i.ChevronRightIcon)])]),
		_: 3
	}, 16, ["class"]);
}
var Tc = /*#__PURE__*/ j(Cc, [["render", wc], ["__file", "/workspace/packages/ui/src/components/ui/pagination/PaginationLast.vue"]]), Ec = /*@__PURE__*/ c({
	__name: "PaginationNext",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		size: {
			type: null,
			required: !1,
			default: "default"
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class", "size"), i = {
			props: n,
			delegatedProps: r,
			forwarded: w(r),
			get ChevronRightIcon() {
				return rr;
			},
			get cn() {
				return M;
			},
			get PaginationNext() {
				return Nt;
			},
			get buttonVariants() {
				return P;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/pagination/PaginationNext.vue
function Dc(e, t, r, i, o, c) {
	return g(), n(i.PaginationNext, f({
		"data-slot": "pagination-next",
		class: i.cn(i.buttonVariants({
			variant: "ghost",
			size: r.size
		}), "gap-1 px-2.5 sm:pr-2.5", i.props.class)
	}, i.forwarded), {
		default: x(() => [y(e.$slots, "default", {}, () => [t[0] ||= a("span", { class: "hidden sm:block" }, "Next", -1), s(i.ChevronRightIcon)])]),
		_: 3
	}, 16, ["class"]);
}
var Oc = /*#__PURE__*/ j(Ec, [["render", Dc], ["__file", "/workspace/packages/ui/src/components/ui/pagination/PaginationNext.vue"]]), kc = /*@__PURE__*/ c({
	__name: "PaginationPrevious",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		size: {
			type: null,
			required: !1,
			default: "default"
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class", "size"), i = {
			props: n,
			delegatedProps: r,
			forwarded: w(r),
			get ChevronLeftIcon() {
				return nr;
			},
			get cn() {
				return M;
			},
			get PaginationPrev() {
				return Pt;
			},
			get buttonVariants() {
				return P;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/pagination/PaginationPrevious.vue
function Ac(e, t, r, i, o, c) {
	return g(), n(i.PaginationPrev, f({
		"data-slot": "pagination-previous",
		class: i.cn(i.buttonVariants({
			variant: "ghost",
			size: r.size
		}), "gap-1 px-2.5 sm:pr-2.5", i.props.class)
	}, i.forwarded), {
		default: x(() => [y(e.$slots, "default", {}, () => [s(i.ChevronLeftIcon), t[0] ||= a("span", { class: "hidden sm:block" }, "Previous", -1)])]),
		_: 3
	}, 16, ["class"]);
}
var jc = /*#__PURE__*/ j(kc, [["render", Ac], ["__file", "/workspace/packages/ui/src/components/ui/pagination/PaginationPrevious.vue"]]), Mc = /*@__PURE__*/ c({
	__name: "PinInput",
	props: {
		modelValue: {
			type: null,
			required: !1
		},
		defaultValue: {
			type: null,
			required: !1
		},
		placeholder: {
			type: String,
			required: !1
		},
		mask: {
			type: Boolean,
			required: !1
		},
		otp: {
			type: Boolean,
			required: !1,
			default: !0
		},
		type: {
			type: null,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		id: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: ["update:modelValue", "complete"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get cn() {
				return M;
			},
			get PinInputRoot() {
				return Lt;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/pin-input/PinInput.vue
function Nc(e, t, r, i, a, o) {
	return g(), n(i.PinInputRoot, f({
		otp: i.props.otp,
		"data-slot": "pin-input"
	}, i.forwarded, { class: i.cn("flex items-center gap-2 has-disabled:opacity-50 disabled:cursor-not-allowed", i.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["otp", "class"]);
}
var Pc = /*#__PURE__*/ j(Mc, [["render", Nc], ["__file", "/workspace/packages/ui/src/components/ui/pin-input/PinInput.vue"]]), Fc = /*@__PURE__*/ c({
	__name: "PinInputGroup",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get cn() {
				return M;
			},
			get Primitive() {
				return C;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/pin-input/PinInputGroup.vue
function Ic(e, t, r, i, a, o) {
	return g(), n(i.Primitive, f({ "data-slot": "pin-input-group" }, i.forwardedProps, { class: i.cn("flex items-center gap-2", i.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var Lc = /*#__PURE__*/ j(Fc, [["render", Ic], ["__file", "/workspace/packages/ui/src/components/ui/pin-input/PinInputGroup.vue"]]), Rc = /*@__PURE__*/ c({
	__name: "PinInputSeparator",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			forwardedProps: w(n),
			get Minus() {
				return pr;
			},
			get Primitive() {
				return C;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/pin-input/PinInputSeparator.vue
function zc(e, t, r, i, a, o) {
	return g(), n(i.Primitive, f({ "data-slot": "pin-input-separator" }, i.forwardedProps), {
		default: x(() => [y(e.$slots, "default", {}, () => [s(i.Minus)])]),
		_: 3
	}, 16);
}
var Bc = /*#__PURE__*/ j(Rc, [["render", zc], ["__file", "/workspace/packages/ui/src/components/ui/pin-input/PinInputSeparator.vue"]]), Vc = /*@__PURE__*/ c({
	__name: "PinInputSlot",
	props: {
		index: {
			type: Number,
			required: !0
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get cn() {
				return M;
			},
			get PinInputInput() {
				return It;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/pin-input/PinInputSlot.vue
function Hc(e, t, r, i, a, o) {
	return g(), n(i.PinInputInput, f({ "data-slot": "pin-input-slot" }, i.forwardedProps, { class: i.cn("glass-input focus:border-ring focus:ring-ring/50 aria-invalid:border-destructive relative flex h-11 w-10 items-center justify-center rounded-md text-center text-lg font-semibold tabular-nums transition-all outline-none focus:z-10 focus:ring-1 disabled:cursor-not-allowed disabled:opacity-50", i.props.class) }), null, 16, ["class"]);
}
var Uc = /*#__PURE__*/ j(Vc, [["render", Hc], ["__file", "/workspace/packages/ui/src/components/ui/pin-input/PinInputSlot.vue"]]), Wc = /*@__PURE__*/ c({
	__name: "Popover",
	props: {
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		open: {
			type: Boolean,
			required: !1
		},
		modal: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = {
			props: r,
			emits: i,
			forwarded: T(r, i),
			get PopoverRoot() {
				return Vt;
			}
		};
		return Object.defineProperty(a, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), a;
	}
});
// src/components/ui/popover/Popover.vue
function Gc(e, t, r, i, a, o) {
	return g(), n(i.PopoverRoot, f({ "data-slot": "popover" }, i.forwarded), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16);
}
var Kc = /*#__PURE__*/ j(Wc, [["render", Gc], ["__file", "/workspace/packages/ui/src/components/ui/popover/Popover.vue"]]), qc = /*@__PURE__*/ c({
	__name: "PopoverAnchor",
	props: {
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get PopoverAnchor() {
				return Rt;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/popover/PopoverAnchor.vue
function Jc(e, t, r, i, a, o) {
	return g(), n(i.PopoverAnchor, f({ "data-slot": "popover-anchor" }, i.props), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var Yc = /*#__PURE__*/ j(qc, [["render", Jc], ["__file", "/workspace/packages/ui/src/components/ui/popover/PopoverAnchor.vue"]]), Xc = /*@__PURE__*/ c({
	inheritAttrs: !1,
	__name: "PopoverContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		memoDependencies: {
			type: Array,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1,
			default: 4
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		align: {
			type: null,
			required: !1,
			default: "center"
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		hideShiftedArrow: {
			type: Boolean,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get cn() {
				return M;
			},
			get PopoverContent() {
				return zt;
			},
			get PopoverPortal() {
				return Bt;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/popover/PopoverContent.vue
function Zc(e, t, r, i, a, o) {
	return g(), n(i.PopoverPortal, null, {
		default: x(() => [s(i.PopoverContent, f({ "data-slot": "popover-content" }, {
			...e.$attrs,
			...i.forwarded
		}, { class: i.cn("glass-panel text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-72 max-w-(--reka-popover-content-available-width) rounded-md p-4 origin-(--reka-popover-content-transform-origin) outline-hidden", i.props.class) }), {
			default: x(() => [y(e.$slots, "default")]),
			_: 3
		}, 16, ["class"])]),
		_: 3
	});
}
var Qc = /*#__PURE__*/ j(Xc, [["render", Zc], ["__file", "/workspace/packages/ui/src/components/ui/popover/PopoverContent.vue"]]), $c = /*@__PURE__*/ c({
	__name: "PopoverTrigger",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get PopoverTrigger() {
				return Ht;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/popover/PopoverTrigger.vue
function el(e, t, r, i, a, o) {
	return g(), n(i.PopoverTrigger, f({ "data-slot": "popover-trigger" }, i.props), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var tl = /*#__PURE__*/ j($c, [["render", el], ["__file", "/workspace/packages/ui/src/components/ui/popover/PopoverTrigger.vue"]]), nl = /*@__PURE__*/ c({
	__name: "Progress",
	props: {
		modelValue: {
			type: [Number, null],
			required: !1,
			default: 0
		},
		max: {
			type: Number,
			required: !1
		},
		getValueLabel: {
			type: Function,
			required: !1
		},
		getValueText: {
			type: Function,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get ProgressIndicator() {
				return Ut;
			},
			get ProgressRoot() {
				return Wt;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/progress/Progress.vue
function rl(e, t, r, i, a, o) {
	return g(), n(i.ProgressRoot, f({ "data-slot": "progress" }, i.delegatedProps, { class: i.cn("bg-primary/20 relative h-2 w-full overflow-hidden rounded-full", i.props.class) }), {
		default: x(() => [s(i.ProgressIndicator, {
			"data-slot": "progress-indicator",
			class: "bg-primary h-full w-full flex-1 transition-all",
			style: h(`transform: translateX(-${100 - (i.props.modelValue ?? 0)}%);`)
		}, null, 8, ["style"])]),
		_: 1
	}, 16, ["class"]);
}
var il = /*#__PURE__*/ j(nl, [["render", rl], ["__file", "/workspace/packages/ui/src/components/ui/progress/Progress.vue"]]), al = /*@__PURE__*/ c({
	__name: "RadioGroup",
	props: {
		modelValue: {
			type: null,
			required: !1
		},
		defaultValue: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		orientation: {
			type: String,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		loop: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get cn() {
				return M;
			},
			get RadioGroupRoot() {
				return qt;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/radio-group/RadioGroup.vue
function ol(e, t, r, i, a, o) {
	return g(), n(i.RadioGroupRoot, f({
		"data-slot": "radio-group",
		class: i.cn("grid gap-3", i.props.class)
	}, i.forwarded), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16, ["class"]);
}
var sl = /*#__PURE__*/ j(al, [["render", ol], ["__file", "/workspace/packages/ui/src/components/ui/radio-group/RadioGroup.vue"]]), cl = /*@__PURE__*/ c({
	__name: "RadioGroupItem",
	props: {
		id: {
			type: String,
			required: !1
		},
		value: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get CircleIcon() {
				return cr;
			},
			get cn() {
				return M;
			},
			get RadioGroupIndicator() {
				return Gt;
			},
			get RadioGroupItem() {
				return Kt;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/radio-group/RadioGroupItem.vue
function ll(e, t, r, i, a, o) {
	return g(), n(i.RadioGroupItem, f({ "data-slot": "radio-group-item" }, i.forwardedProps, { class: i.cn("border-[color:var(--switch-track)] text-primary focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 aspect-square size-4 shrink-0 rounded-full border shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-3 disabled:cursor-not-allowed disabled:opacity-50", i.props.class) }), {
		default: x(() => [s(i.RadioGroupIndicator, {
			"data-slot": "radio-group-indicator",
			class: "relative flex items-center justify-center"
		}, {
			default: x(() => [y(e.$slots, "default", {}, () => [s(i.CircleIcon, { class: "fill-primary absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2" })])]),
			_: 3
		})]),
		_: 3
	}, 16, ["class"]);
}
var ul = /*#__PURE__*/ j(cl, [["render", ll], ["__file", "/workspace/packages/ui/src/components/ui/radio-group/RadioGroupItem.vue"]]), dl = /*@__PURE__*/ c({
	__name: "RangeCalendar",
	props: {
		defaultPlaceholder: {
			type: Object,
			required: !1
		},
		defaultValue: {
			type: Object,
			required: !1
		},
		modelValue: {
			type: [Object, null],
			required: !1
		},
		placeholder: {
			type: Object,
			required: !1
		},
		allowNonContiguousRanges: {
			type: Boolean,
			required: !1
		},
		pagedNavigation: {
			type: Boolean,
			required: !1
		},
		preventDeselect: {
			type: Boolean,
			required: !1
		},
		maximumDays: {
			type: Number,
			required: !1
		},
		weekStartsOn: {
			type: Number,
			required: !1
		},
		weekdayFormat: {
			type: String,
			required: !1
		},
		calendarLabel: {
			type: String,
			required: !1
		},
		fixedWeeks: {
			type: Boolean,
			required: !1
		},
		maxValue: {
			type: Object,
			required: !1
		},
		minValue: {
			type: Object,
			required: !1
		},
		locale: {
			type: String,
			required: !1
		},
		numberOfMonths: {
			type: Number,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		readonly: {
			type: Boolean,
			required: !1
		},
		initialFocus: {
			type: Boolean,
			required: !1
		},
		isDateDisabled: {
			type: Function,
			required: !1
		},
		isDateUnavailable: {
			type: Function,
			required: !1
		},
		isDateHighlightable: {
			type: Function,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		nextPage: {
			type: Function,
			required: !1
		},
		prevPage: {
			type: Function,
			required: !1
		},
		disableDaysOutsideCurrentView: {
			type: Boolean,
			required: !1
		},
		fixedDate: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: [
		"update:modelValue",
		"update:validModelValue",
		"update:placeholder",
		"update:startValue"
	],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get cn() {
				return M;
			},
			get RangeCalendarRoot() {
				return on;
			},
			get RangeCalendarCell() {
				return vl;
			},
			get RangeCalendarCellTrigger() {
				return xl;
			},
			get RangeCalendarGrid() {
				return wl;
			},
			get RangeCalendarGridBody() {
				return Dl;
			},
			get RangeCalendarGridHead() {
				return Al;
			},
			get RangeCalendarGridRow() {
				return Nl;
			},
			get RangeCalendarHeadCell() {
				return Il;
			},
			get RangeCalendarHeader() {
				return zl;
			},
			get RangeCalendarHeading() {
				return Hl;
			},
			get RangeCalendarNextButton() {
				return Gl;
			},
			get RangeCalendarPrevButton() {
				return Jl;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
}), fl = { class: "flex items-center gap-1" }, pl = { class: "flex flex-col gap-y-4 mt-4 sm:flex-row sm:gap-x-4 sm:gap-y-0" };
function ml(t, r, c, l, u, d) {
	return g(), n(l.RangeCalendarRoot, f({
		"data-slot": "range-calendar",
		class: l.cn("p-3", l.props.class)
	}, l.forwarded), {
		default: x(({ grid: t, weekDays: r }) => [s(l.RangeCalendarHeader, null, {
			default: x(() => [s(l.RangeCalendarHeading), a("div", fl, [s(l.RangeCalendarPrevButton), s(l.RangeCalendarNextButton)])]),
			_: 1
		}), a("div", pl, [(g(!0), i(e, null, v(t, (t) => (g(), n(l.RangeCalendarGrid, { key: t.value.toString() }, {
			default: x(() => [s(l.RangeCalendarGridHead, null, {
				default: x(() => [s(l.RangeCalendarGridRow, null, {
					default: x(() => [(g(!0), i(e, null, v(r, (e) => (g(), n(l.RangeCalendarHeadCell, { key: e }, {
						default: x(() => [o(b(e), 1)]),
						_: 2
					}, 1024))), 128))]),
					_: 2
				}, 1024)]),
				_: 2
			}, 1024), s(l.RangeCalendarGridBody, null, {
				default: x(() => [(g(!0), i(e, null, v(t.rows, (r, a) => (g(), n(l.RangeCalendarGridRow, {
					key: `weekDate-${a}`,
					class: "mt-2 w-full"
				}, {
					default: x(() => [(g(!0), i(e, null, v(r, (e) => (g(), n(l.RangeCalendarCell, {
						key: e.toString(),
						date: e
					}, {
						default: x(() => [s(l.RangeCalendarCellTrigger, {
							day: e,
							month: t.value
						}, null, 8, ["day", "month"])]),
						_: 2
					}, 1032, ["date"]))), 128))]),
					_: 2
				}, 1024))), 128))]),
				_: 2
			}, 1024)]),
			_: 2
		}, 1024))), 128))])]),
		_: 1
	}, 16, ["class"]);
}
var hl = /*#__PURE__*/ j(dl, [["render", ml], ["__file", "/workspace/packages/ui/src/components/ui/range-calendar/RangeCalendar.vue"]]), gl = /*@__PURE__*/ c({
	__name: "RangeCalendarCell",
	props: {
		date: {
			type: Object,
			required: !0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get cn() {
				return M;
			},
			get RangeCalendarCell() {
				return Jt;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/range-calendar/RangeCalendarCell.vue
function _l(e, t, r, i, a, o) {
	return g(), n(i.RangeCalendarCell, f({
		"data-slot": "range-calendar-cell",
		class: i.cn("relative p-0 text-center text-sm focus-within:relative focus-within:z-20 [&:has([data-selected])]:bg-accent first:[&:has([data-selected])]:rounded-l-md last:[&:has([data-selected])]:rounded-r-md [&:has([data-selected][data-selection-end])]:rounded-r-md [&:has([data-selected][data-selection-start])]:rounded-l-md", i.props.class)
	}, i.forwardedProps), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var vl = /*#__PURE__*/ j(gl, [["render", _l], ["__file", "/workspace/packages/ui/src/components/ui/range-calendar/RangeCalendarCell.vue"]]), yl = /*@__PURE__*/ c({
	__name: "RangeCalendarCellTrigger",
	props: {
		day: {
			type: Object,
			required: !0
		},
		month: {
			type: Object,
			required: !0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "button"
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get cn() {
				return M;
			},
			get RangeCalendarCellTrigger() {
				return Yt;
			},
			get buttonVariants() {
				return P;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/range-calendar/RangeCalendarCellTrigger.vue
function bl(e, t, r, i, a, o) {
	return g(), n(i.RangeCalendarCellTrigger, f({
		"data-slot": "range-calendar-trigger",
		class: i.cn(i.buttonVariants({ variant: "ghost" }), "h-8 w-8 p-0 font-normal data-[selected]:opacity-100", "[&[data-today]:not([data-selected])]:bg-accent [&[data-today]:not([data-selected])]:text-accent-foreground", "data-[selection-start]:bg-primary data-[selection-start]:text-primary-foreground [&[data-selection-start]:hover]:bg-primary data-[selection-start]:hover:text-primary-foreground data-[selection-start]:focus:bg-primary data-[selection-start]:focus:text-primary-foreground", "data-[selection-end]:bg-primary data-[selection-end]:text-primary-foreground [&[data-selection-end]:hover]:bg-primary data-[selection-end]:hover:text-primary-foreground data-[selection-end]:focus:bg-primary data-[selection-end]:focus:text-primary-foreground", "data-[outside-view]:text-muted-foreground", "data-[disabled]:text-muted-foreground data-[disabled]:opacity-50", "data-[unavailable]:text-destructive-foreground data-[unavailable]:line-through", i.props.class)
	}, i.forwardedProps), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var xl = /*#__PURE__*/ j(yl, [["render", bl], ["__file", "/workspace/packages/ui/src/components/ui/range-calendar/RangeCalendarCellTrigger.vue"]]), Sl = /*@__PURE__*/ c({
	__name: "RangeCalendarGrid",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get cn() {
				return M;
			},
			get RangeCalendarGrid() {
				return Xt;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/range-calendar/RangeCalendarGrid.vue
function Cl(e, t, r, i, a, o) {
	return g(), n(i.RangeCalendarGrid, f({
		"data-slot": "range-calendar-grid",
		class: i.cn("w-full border-collapse space-x-1", i.props.class)
	}, i.forwardedProps), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var wl = /*#__PURE__*/ j(Sl, [["render", Cl], ["__file", "/workspace/packages/ui/src/components/ui/range-calendar/RangeCalendarGrid.vue"]]), Tl = /*@__PURE__*/ c({
	__name: "RangeCalendarGridBody",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get RangeCalendarGridBody() {
				return Zt;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/range-calendar/RangeCalendarGridBody.vue
function El(e, t, r, i, a, o) {
	return g(), n(i.RangeCalendarGridBody, f({ "data-slot": "range-calendar-grid-body" }, i.props), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var Dl = /*#__PURE__*/ j(Tl, [["render", El], ["__file", "/workspace/packages/ui/src/components/ui/range-calendar/RangeCalendarGridBody.vue"]]), Ol = /*@__PURE__*/ c({
	__name: "RangeCalendarGridHead",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get RangeCalendarGridHead() {
				return Qt;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/range-calendar/RangeCalendarGridHead.vue
function kl(e, t, r, i, a, o) {
	return g(), n(i.RangeCalendarGridHead, f({ "data-slot": "range-calendar-grid-head" }, i.props), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var Al = /*#__PURE__*/ j(Ol, [["render", kl], ["__file", "/workspace/packages/ui/src/components/ui/range-calendar/RangeCalendarGridHead.vue"]]), jl = /*@__PURE__*/ c({
	__name: "RangeCalendarGridRow",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get cn() {
				return M;
			},
			get RangeCalendarGridRow() {
				return $t;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/range-calendar/RangeCalendarGridRow.vue
function Ml(e, t, r, i, a, o) {
	return g(), n(i.RangeCalendarGridRow, f({
		"data-slot": "range-calendar-grid-row",
		class: i.cn("flex", i.props.class)
	}, i.forwardedProps), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var Nl = /*#__PURE__*/ j(jl, [["render", Ml], ["__file", "/workspace/packages/ui/src/components/ui/range-calendar/RangeCalendarGridRow.vue"]]), Pl = /*@__PURE__*/ c({
	__name: "RangeCalendarHeadCell",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get cn() {
				return M;
			},
			get RangeCalendarHeadCell() {
				return en;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/range-calendar/RangeCalendarHeadCell.vue
function Fl(e, t, r, i, a, o) {
	return g(), n(i.RangeCalendarHeadCell, f({
		"data-slot": "range-calendar-head-cell",
		class: i.cn("w-8 rounded-md text-[0.8rem] font-normal text-muted-foreground", i.props.class)
	}, i.forwardedProps), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var Il = /*#__PURE__*/ j(Pl, [["render", Fl], ["__file", "/workspace/packages/ui/src/components/ui/range-calendar/RangeCalendarHeadCell.vue"]]), Ll = /*@__PURE__*/ c({
	__name: "RangeCalendarHeader",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get cn() {
				return M;
			},
			get RangeCalendarHeader() {
				return tn;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/range-calendar/RangeCalendarHeader.vue
function Rl(e, t, r, i, a, o) {
	return g(), n(i.RangeCalendarHeader, f({
		"data-slot": "range-calendar-header",
		class: i.cn("flex justify-center pt-1 relative items-center w-full", i.props.class)
	}, i.forwardedProps), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var zl = /*#__PURE__*/ j(Ll, [["render", Rl], ["__file", "/workspace/packages/ui/src/components/ui/range-calendar/RangeCalendarHeader.vue"]]), Bl = /*@__PURE__*/ c({
	__name: "RangeCalendarHeading",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get cn() {
				return M;
			},
			get RangeCalendarHeading() {
				return nn;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/range-calendar/RangeCalendarHeading.vue
function Vl(e, t, r, i, a, s) {
	return g(), n(i.RangeCalendarHeading, f({
		"data-slot": "range-calendar-heading",
		class: i.cn("text-sm font-medium", i.props.class)
	}, i.forwardedProps), {
		default: x(({ headingValue: t }) => [y(e.$slots, "default", { headingValue: t }, () => [o(b(t), 1)])]),
		_: 3
	}, 16, ["class"]);
}
var Hl = /*#__PURE__*/ j(Bl, [["render", Vl], ["__file", "/workspace/packages/ui/src/components/ui/range-calendar/RangeCalendarHeading.vue"]]), Ul = /*@__PURE__*/ c({
	__name: "RangeCalendarNextButton",
	props: {
		nextPage: {
			type: Function,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get ChevronRight() {
				return O;
			},
			get cn() {
				return M;
			},
			get RangeCalendarNext() {
				return rn;
			},
			get buttonVariants() {
				return P;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/range-calendar/RangeCalendarNextButton.vue
function Wl(e, t, r, i, a, o) {
	return g(), n(i.RangeCalendarNext, f({
		"data-slot": "range-calendar-next-button",
		class: i.cn(i.buttonVariants({ variant: "outline" }), "absolute right-1", "size-7 bg-transparent p-0 opacity-50 hover:opacity-100", i.props.class)
	}, i.forwardedProps), {
		default: x(() => [y(e.$slots, "default", {}, () => [s(i.ChevronRight, { class: "size-4" })])]),
		_: 3
	}, 16, ["class"]);
}
var Gl = /*#__PURE__*/ j(Ul, [["render", Wl], ["__file", "/workspace/packages/ui/src/components/ui/range-calendar/RangeCalendarNextButton.vue"]]), Kl = /*@__PURE__*/ c({
	__name: "RangeCalendarPrevButton",
	props: {
		prevPage: {
			type: Function,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get ChevronLeft() {
				return tr;
			},
			get cn() {
				return M;
			},
			get RangeCalendarPrev() {
				return an;
			},
			get buttonVariants() {
				return P;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/range-calendar/RangeCalendarPrevButton.vue
function ql(e, t, r, i, a, o) {
	return g(), n(i.RangeCalendarPrev, f({
		"data-slot": "range-calendar-prev-button",
		class: i.cn(i.buttonVariants({ variant: "outline" }), "absolute left-1", "size-7 bg-transparent p-0 opacity-50 hover:opacity-100", i.props.class)
	}, i.forwardedProps), {
		default: x(() => [y(e.$slots, "default", {}, () => [s(i.ChevronLeft, { class: "size-4" })])]),
		_: 3
	}, 16, ["class"]);
}
var Jl = /*#__PURE__*/ j(Kl, [["render", ql], ["__file", "/workspace/packages/ui/src/components/ui/range-calendar/RangeCalendarPrevButton.vue"]]), Yl = /*@__PURE__*/ c({
	__name: "ScrollBar",
	props: {
		orientation: {
			type: String,
			required: !1,
			default: "vertical"
		},
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get ScrollAreaScrollbar() {
				return ln;
			},
			get ScrollAreaThumb() {
				return un;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/scroll-area/ScrollBar.vue
function Xl(e, t, r, i, a, o) {
	return g(), n(i.ScrollAreaScrollbar, f({ "data-slot": "scroll-area-scrollbar" }, i.delegatedProps, { class: i.cn("flex touch-none p-px transition-colors select-none", r.orientation === "vertical" && "h-full w-2.5 border-l border-l-transparent", r.orientation === "horizontal" && "h-2.5 flex-col border-t border-t-transparent", i.props.class) }), {
		default: x(() => [s(i.ScrollAreaThumb, {
			"data-slot": "scroll-area-thumb",
			class: "bg-border relative flex-1 rounded-full"
		})]),
		_: 1
	}, 16, ["class"]);
}
var Zl = /*#__PURE__*/ j(Yl, [["render", Xl], ["__file", "/workspace/packages/ui/src/components/ui/scroll-area/ScrollBar.vue"]]), Ql = /*@__PURE__*/ c({
	__name: "ScrollArea",
	props: {
		type: {
			type: String,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		scrollHideDelay: {
			type: Number,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get ScrollAreaCorner() {
				return sn;
			},
			get ScrollAreaRoot() {
				return cn;
			},
			get ScrollAreaViewport() {
				return dn;
			},
			ScrollBar: Zl
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/scroll-area/ScrollArea.vue
function $l(e, t, r, i, a, o) {
	return g(), n(i.ScrollAreaRoot, f({ "data-slot": "scroll-area" }, i.delegatedProps, { class: i.cn("relative", i.props.class) }), {
		default: x(() => [
			s(i.ScrollAreaViewport, {
				"data-slot": "scroll-area-viewport",
				class: "focus-visible:ring-ring/50 size-full rounded-[inherit] transition-[color,box-shadow] outline-none focus-visible:ring-3 focus-visible:outline-1"
			}, {
				default: x(() => [y(e.$slots, "default")]),
				_: 3
			}),
			s(i.ScrollBar),
			s(i.ScrollAreaCorner)
		]),
		_: 3
	}, 16, ["class"]);
}
var eu = /*#__PURE__*/ j(Ql, [["render", $l], ["__file", "/workspace/packages/ui/src/components/ui/scroll-area/ScrollArea.vue"]]), tu = /*@__PURE__*/ c({
	__name: "Select",
	props: {
		open: {
			type: Boolean,
			required: !1
		},
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		defaultValue: {
			type: null,
			required: !1
		},
		modelValue: {
			type: null,
			required: !1
		},
		nullableValue: {
			type: String,
			required: !1
		},
		by: {
			type: [String, Function],
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		multiple: {
			type: Boolean,
			required: !1
		},
		autocomplete: {
			type: String,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["update:modelValue", "update:open"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = {
			props: r,
			emits: i,
			forwarded: T(r, i),
			get SelectRoot() {
				return bn;
			}
		};
		return Object.defineProperty(a, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), a;
	}
});
// src/components/ui/select/Select.vue
function nu(e, t, r, i, a, o) {
	return g(), n(i.SelectRoot, f({ "data-slot": "select" }, i.forwarded), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16);
}
var ru = /*#__PURE__*/ j(tu, [["render", nu], ["__file", "/workspace/packages/ui/src/components/ui/select/Select.vue"]]), iu = /*@__PURE__*/ c({
	inheritAttrs: !1,
	__name: "SelectContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		position: {
			type: String,
			required: !1,
			default: "popper"
		},
		bodyLock: {
			type: Boolean,
			required: !1
		},
		loop: {
			type: Boolean,
			required: !1
		},
		memoDependencies: {
			type: Array,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1
		},
		sideFlip: {
			type: Boolean,
			required: !1
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		alignFlip: {
			type: Boolean,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		hideShiftedArrow: {
			type: Boolean,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		disableUpdateOnLayoutShift: {
			type: Boolean,
			required: !1
		},
		prioritizePosition: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: [
		"closeAutoFocus",
		"escapeKeyDown",
		"pointerDownOutside"
	],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get cn() {
				return M;
			},
			get SelectContent() {
				return fn;
			},
			get SelectPortal() {
				return yn;
			},
			get SelectViewport() {
				return En;
			},
			get SelectScrollDownButton() {
				return Su;
			},
			get SelectScrollUpButton() {
				return Tu;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/select/SelectContent.vue
function au(e, t, r, i, a, o) {
	return g(), n(i.SelectPortal, null, {
		default: x(() => [s(i.SelectContent, f({ "data-slot": "select-content" }, {
			...e.$attrs,
			...i.forwarded
		}, { class: i.cn("glass-panel text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 max-h-(--reka-select-content-available-height) min-w-[8rem] overflow-x-hidden overflow-y-auto rounded-md", r.position === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1", i.props.class) }), {
			default: x(() => [
				s(i.SelectScrollUpButton),
				s(i.SelectViewport, { class: p(i.cn("p-1", r.position === "popper" && "h-(--reka-select-trigger-height) w-full min-w-(--reka-select-trigger-width) scroll-my-1")) }, {
					default: x(() => [y(e.$slots, "default")]),
					_: 3
				}, 8, ["class"]),
				s(i.SelectScrollDownButton)
			]),
			_: 3
		}, 16, ["class"])]),
		_: 3
	});
}
var ou = /*#__PURE__*/ j(iu, [["render", au], ["__file", "/workspace/packages/ui/src/components/ui/select/SelectContent.vue"]]), su = /*@__PURE__*/ c({
	__name: "SelectGroup",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get SelectGroup() {
				return pn;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/select/SelectGroup.vue
function cu(e, t, r, i, a, o) {
	return g(), n(i.SelectGroup, f({ "data-slot": "select-group" }, i.props), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var lu = /*#__PURE__*/ j(su, [["render", cu], ["__file", "/workspace/packages/ui/src/components/ui/select/SelectGroup.vue"]]), uu = /*@__PURE__*/ c({
	__name: "SelectItem",
	props: {
		value: {
			type: null,
			required: !0
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		textValue: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get Check() {
				return D;
			},
			get cn() {
				return M;
			},
			get SelectItem() {
				return hn;
			},
			get SelectItemIndicator() {
				return gn;
			},
			get SelectItemText() {
				return _n;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
}), du = { class: "absolute right-2 flex size-3.5 items-center justify-center" };
function fu(e, t, r, i, o, c) {
	return g(), n(i.SelectItem, f({ "data-slot": "select-item" }, i.forwardedProps, { class: i.cn("focus:bg-accent focus:text-accent-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2", i.props.class) }), {
		default: x(() => [a("span", du, [s(i.SelectItemIndicator, null, {
			default: x(() => [y(e.$slots, "indicator-icon", {}, () => [s(i.Check, { class: "size-4" })])]),
			_: 3
		})]), s(i.SelectItemText, null, {
			default: x(() => [y(e.$slots, "default")]),
			_: 3
		})]),
		_: 3
	}, 16, ["class"]);
}
var pu = /*#__PURE__*/ j(uu, [["render", fu], ["__file", "/workspace/packages/ui/src/components/ui/select/SelectItem.vue"]]), mu = /*@__PURE__*/ c({
	__name: "SelectItemText",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get SelectItemText() {
				return _n;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/select/SelectItemText.vue
function hu(e, t, r, i, a, o) {
	return g(), n(i.SelectItemText, f({ "data-slot": "select-item-text" }, i.props), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var gu = /*#__PURE__*/ j(mu, [["render", hu], ["__file", "/workspace/packages/ui/src/components/ui/select/SelectItemText.vue"]]), _u = /*@__PURE__*/ c({
	__name: "SelectLabel",
	props: {
		for: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			},
			get SelectLabel() {
				return vn;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/select/SelectLabel.vue
function vu(e, t, r, i, a, o) {
	return g(), n(i.SelectLabel, {
		"data-slot": "select-label",
		class: p(i.cn("text-muted-foreground px-2 py-1.5 text-xs", i.props.class))
	}, {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 8, ["class"]);
}
var yu = /*#__PURE__*/ j(_u, [["render", vu], ["__file", "/workspace/packages/ui/src/components/ui/select/SelectLabel.vue"]]), bu = /*@__PURE__*/ c({
	__name: "SelectScrollDownButton",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get ChevronDown() {
				return er;
			},
			get cn() {
				return M;
			},
			get SelectScrollDownButton() {
				return xn;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/select/SelectScrollDownButton.vue
function xu(e, t, r, i, a, o) {
	return g(), n(i.SelectScrollDownButton, f({ "data-slot": "select-scroll-down-button" }, i.forwardedProps, { class: i.cn("flex cursor-default items-center justify-center py-1", i.props.class) }), {
		default: x(() => [y(e.$slots, "default", {}, () => [s(i.ChevronDown, { class: "size-4" })])]),
		_: 3
	}, 16, ["class"]);
}
var Su = /*#__PURE__*/ j(bu, [["render", xu], ["__file", "/workspace/packages/ui/src/components/ui/select/SelectScrollDownButton.vue"]]), Cu = /*@__PURE__*/ c({
	__name: "SelectScrollUpButton",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get ChevronUp() {
				return ir;
			},
			get cn() {
				return M;
			},
			get SelectScrollUpButton() {
				return Sn;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/select/SelectScrollUpButton.vue
function wu(e, t, r, i, a, o) {
	return g(), n(i.SelectScrollUpButton, f({ "data-slot": "select-scroll-up-button" }, i.forwardedProps, { class: i.cn("flex cursor-default items-center justify-center py-1", i.props.class) }), {
		default: x(() => [y(e.$slots, "default", {}, () => [s(i.ChevronUp, { class: "size-4" })])]),
		_: 3
	}, 16, ["class"]);
}
var Tu = /*#__PURE__*/ j(Cu, [["render", wu], ["__file", "/workspace/packages/ui/src/components/ui/select/SelectScrollUpButton.vue"]]), Eu = /*@__PURE__*/ c({
	__name: "SelectSeparator",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get SelectSeparator() {
				return Cn;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/select/SelectSeparator.vue
function Du(e, t, r, i, a, o) {
	return g(), n(i.SelectSeparator, f({ "data-slot": "select-separator" }, i.delegatedProps, { class: i.cn("bg-border pointer-events-none -mx-1 my-1 h-px", i.props.class) }), null, 16, ["class"]);
}
var Ou = /*#__PURE__*/ j(Eu, [["render", Du], ["__file", "/workspace/packages/ui/src/components/ui/select/SelectSeparator.vue"]]), ku = /*@__PURE__*/ c({
	__name: "SelectTrigger",
	props: {
		disabled: {
			type: Boolean,
			required: !1
		},
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		},
		size: {
			type: String,
			required: !1,
			default: "default"
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class", "size"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get ChevronDown() {
				return er;
			},
			get cn() {
				return M;
			},
			get SelectIcon() {
				return mn;
			},
			get SelectTrigger() {
				return wn;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/select/SelectTrigger.vue
function Au(e, t, r, i, a, o) {
	return g(), n(i.SelectTrigger, f({
		"data-slot": "select-trigger",
		"data-size": r.size
	}, i.forwardedProps, { class: i.cn("data-[placeholder]:text-muted-foreground [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:ring-ring aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive flex w-fit items-center justify-between gap-2 rounded-md glass-input px-3 py-2 text-sm whitespace-nowrap shadow-none transition-[color,box-shadow] outline-none focus-visible:ring-1 disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", i.props.class) }), {
		default: x(() => [y(e.$slots, "default"), s(i.SelectIcon, { "as-child": "" }, {
			default: x(() => [s(i.ChevronDown, { class: "size-4 opacity-50" })]),
			_: 1
		})]),
		_: 3
	}, 16, ["data-size", "class"]);
}
var ju = /*#__PURE__*/ j(ku, [["render", Au], ["__file", "/workspace/packages/ui/src/components/ui/select/SelectTrigger.vue"]]), Mu = /*@__PURE__*/ c({
	__name: "SelectValue",
	props: {
		placeholder: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get SelectValue() {
				return Tn;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/select/SelectValue.vue
function Nu(e, t, r, i, a, o) {
	return g(), n(i.SelectValue, f({ "data-slot": "select-value" }, i.props), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var Pu = /*#__PURE__*/ j(Mu, [["render", Nu], ["__file", "/workspace/packages/ui/src/components/ui/select/SelectValue.vue"]]), Fu = /*@__PURE__*/ c({
	__name: "Separator",
	props: {
		orientation: {
			type: String,
			required: !1,
			default: "horizontal"
		},
		decorative: {
			type: Boolean,
			required: !1,
			default: !0
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get Separator() {
				return Dn;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/separator/Separator.vue
function Iu(e, t, r, i, a, o) {
	return g(), n(i.Separator, f({ "data-slot": "separator" }, i.delegatedProps, { class: i.cn("bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px", i.props.class) }), null, 16, ["class"]);
}
var Lu = /*#__PURE__*/ j(Fu, [["render", Iu], ["__file", "/workspace/packages/ui/src/components/ui/separator/Separator.vue"]]), Ru = /*@__PURE__*/ c({
	__name: "Sheet",
	props: {
		open: {
			type: Boolean,
			required: !1
		},
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		modal: {
			type: Boolean,
			required: !1
		},
		unmountOnHide: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = {
			props: r,
			emits: i,
			forwarded: T(r, i),
			get DialogRoot() {
				return Je;
			}
		};
		return Object.defineProperty(a, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), a;
	}
});
// src/components/ui/sheet/Sheet.vue
function zu(e, t, r, i, a, o) {
	return g(), n(i.DialogRoot, f({ "data-slot": "sheet" }, i.forwarded), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16);
}
var H = /*#__PURE__*/ j(Ru, [["render", zu], ["__file", "/workspace/packages/ui/src/components/ui/sheet/Sheet.vue"]]), Bu = /*@__PURE__*/ c({
	__name: "SheetClose",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get DialogClose() {
				return S;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/sheet/SheetClose.vue
function Vu(e, t, r, i, a, o) {
	return g(), n(i.DialogClose, f({ "data-slot": "sheet-close" }, i.props), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var Hu = /*#__PURE__*/ j(Bu, [["render", Vu], ["__file", "/workspace/packages/ui/src/components/ui/sheet/SheetClose.vue"]]), Uu = /*@__PURE__*/ c({
	__name: "SheetOverlay",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get DialogOverlay() {
				return Ke;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/sheet/SheetOverlay.vue
function Wu(e, t, r, i, a, o) {
	return g(), n(i.DialogOverlay, f({
		"data-slot": "sheet-overlay",
		class: i.cn("data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 blur-overlay", i.props.class)
	}, i.delegatedProps), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var Gu = /*#__PURE__*/ j(Uu, [["render", Wu], ["__file", "/workspace/packages/ui/src/components/ui/sheet/SheetOverlay.vue"]]), Ku = /*@__PURE__*/ c({
	inheritAttrs: !1,
	__name: "SheetContent",
	props: {
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		},
		side: {
			type: String,
			required: !1,
			default: "right"
		},
		showCloseButton: {
			type: Boolean,
			required: !1,
			default: !0
		},
		forceMount: {
			type: Boolean,
			required: !1
		},
		disableOutsidePointerEvents: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	emits: [
		"escapeKeyDown",
		"pointerDownOutside",
		"focusOutside",
		"interactOutside",
		"openAutoFocus",
		"closeAutoFocus"
	],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class", "side", "showCloseButton"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get X() {
				return k;
			},
			get cn() {
				return M;
			},
			get DialogClose() {
				return S;
			},
			get DialogContent() {
				return We;
			},
			get DialogPortal() {
				return qe;
			},
			SheetOverlay: Gu
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/sheet/SheetContent.vue
function qu(e, t, i, o, c, l) {
	return g(), n(o.DialogPortal, null, {
		default: x(() => [s(o.SheetOverlay), s(o.DialogContent, f({
			"data-slot": "sheet-content",
			class: o.cn("glass-panel glass-frame-scope overflow-y-auto rounded-xl data-[state=open]:animate-in data-[state=closed]:animate-out fixed z-50 flex flex-col gap-4 transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500", i.side === "right" && "data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right inset-y-3 right-3 h-auto w-[calc(75%-12px)] sm:max-w-sm", i.side === "left" && "data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left inset-y-3 left-3 h-auto w-[calc(75%-12px)] sm:max-w-sm", i.side === "top" && "data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top inset-x-3 top-3 h-auto", i.side === "bottom" && "data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom inset-x-3 bottom-3 h-auto", o.props.class)
		}, {
			...e.$attrs,
			...o.forwarded
		}), {
			default: x(() => [y(e.$slots, "default"), i.showCloseButton ? (g(), n(o.DialogClose, {
				key: 0,
				"data-slot": "sheet-close",
				class: "ring-offset-background focus:ring-ring data-[state=open]:bg-secondary absolute top-4 right-4 rounded-xs opacity-70 transition-opacity hover:opacity-100 focus:ring-2 focus:ring-offset-2 focus:outline-hidden disabled:pointer-events-none"
			}, {
				default: x(() => [s(o.X, { class: "size-4" }), t[0] ||= a("span", { class: "sr-only" }, "Close", -1)]),
				_: 1
			})) : r("v-if", !0)]),
			_: 3
		}, 16, ["class"])]),
		_: 3
	});
}
var U = /*#__PURE__*/ j(Ku, [["render", qu], ["__file", "/workspace/packages/ui/src/components/ui/sheet/SheetContent.vue"]]), Ju = /*@__PURE__*/ c({
	__name: "SheetDescription",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get DialogDescription() {
				return Ge;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/sheet/SheetDescription.vue
function Yu(e, t, r, i, a, o) {
	return g(), n(i.DialogDescription, f({
		"data-slot": "sheet-description",
		class: i.cn("text-muted-foreground text-sm", i.props.class)
	}, i.delegatedProps), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var Xu = /*#__PURE__*/ j(Ju, [["render", Yu], ["__file", "/workspace/packages/ui/src/components/ui/sheet/SheetDescription.vue"]]), Zu = /*@__PURE__*/ c({
	__name: "SheetFooter",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/sheet/SheetFooter.vue
function Qu(e, t, n, r, a, o) {
	return g(), i("div", {
		"data-slot": "sheet-footer",
		class: p(r.cn("mt-auto flex flex-col gap-2 p-4", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var $u = /*#__PURE__*/ j(Zu, [["render", Qu], ["__file", "/workspace/packages/ui/src/components/ui/sheet/SheetFooter.vue"]]), ed = /*@__PURE__*/ c({
	__name: "SheetHeader",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/sheet/SheetHeader.vue
function td(e, t, n, r, a, o) {
	return g(), i("div", {
		"data-slot": "sheet-header",
		class: p(r.cn("flex flex-col gap-1.5 p-4", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var nd = /*#__PURE__*/ j(ed, [["render", td], ["__file", "/workspace/packages/ui/src/components/ui/sheet/SheetHeader.vue"]]), rd = /*@__PURE__*/ c({
	__name: "SheetTitle",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get DialogTitle() {
				return Ye;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/sheet/SheetTitle.vue
function id(e, t, r, i, a, o) {
	return g(), n(i.DialogTitle, f({
		"data-slot": "sheet-title",
		class: i.cn("text-foreground font-semibold", i.props.class)
	}, i.delegatedProps), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var W = /*#__PURE__*/ j(rd, [["render", id], ["__file", "/workspace/packages/ui/src/components/ui/sheet/SheetTitle.vue"]]), ad = /*@__PURE__*/ c({
	__name: "SheetTrigger",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get DialogTrigger() {
				return Xe;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/sheet/SheetTrigger.vue
function od(e, t, r, i, a, o) {
	return g(), n(i.DialogTrigger, f({ "data-slot": "sheet-trigger" }, i.props), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var sd = /*#__PURE__*/ j(ad, [["render", od], ["__file", "/workspace/packages/ui/src/components/ui/sheet/SheetTrigger.vue"]]), cd = /*@__PURE__*/ c({
	__name: "Skeleton",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/skeleton/Skeleton.vue
function ld(e, t, n, r, a, o) {
	return g(), i("div", {
		"data-slot": "skeleton",
		class: p(r.cn("animate-pulse rounded-md bg-primary/10", r.props.class))
	}, null, 2);
}
var ud = /*#__PURE__*/ j(cd, [["render", ld], ["__file", "/workspace/packages/ui/src/components/ui/skeleton/Skeleton.vue"]]), dd = /*@__PURE__*/ c({
	__name: "Slider",
	props: {
		defaultValue: {
			type: Array,
			required: !1
		},
		modelValue: {
			type: [Array, null],
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		orientation: {
			type: String,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		inverted: {
			type: Boolean,
			required: !1
		},
		min: {
			type: Number,
			required: !1
		},
		max: {
			type: Number,
			required: !1
		},
		step: {
			type: Number,
			required: !1
		},
		minStepsBetweenThumbs: {
			type: Number,
			required: !1
		},
		thumbAlignment: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: ["update:modelValue", "valueCommit"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get cn() {
				return M;
			},
			get SliderRange() {
				return On;
			},
			get SliderRoot() {
				return kn;
			},
			get SliderThumb() {
				return An;
			},
			get SliderTrack() {
				return jn;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/slider/Slider.vue
function fd(t, r, a, o, c, l) {
	return g(), n(o.SliderRoot, f({
		"data-slot": "slider",
		class: o.cn("relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col", o.props.class)
	}, o.forwarded), {
		default: x(({ modelValue: t }) => [s(o.SliderTrack, {
			"data-slot": "slider-track",
			class: "bg-muted relative grow overflow-hidden rounded-full data-[orientation=horizontal]:h-1.5 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1.5"
		}, {
			default: x(() => [s(o.SliderRange, {
				"data-slot": "slider-range",
				class: "bg-primary absolute data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full"
			})]),
			_: 1
		}), (g(!0), i(e, null, v(t, (e, t) => (g(), n(o.SliderThumb, {
			key: t,
			"data-slot": "slider-thumb",
			class: "bg-white border-primary ring-ring/50 block size-4 shrink-0 rounded-full border shadow-sm transition-[color,box-shadow] hover:ring-4 focus-visible:ring-4 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50"
		}))), 128))]),
		_: 1
	}, 16, ["class"]);
}
var pd = /*#__PURE__*/ j(dd, [["render", fd], ["__file", "/workspace/packages/ui/src/components/ui/slider/Slider.vue"]]), md = /*@__PURE__*/ c({
	__name: "Sonner",
	props: {
		id: {
			type: String,
			required: !1
		},
		invert: {
			type: Boolean,
			required: !1
		},
		theme: {
			type: String,
			required: !1
		},
		position: {
			type: String,
			required: !1
		},
		closeButtonPosition: {
			type: String,
			required: !1
		},
		hotkey: {
			type: Array,
			required: !1
		},
		richColors: {
			type: Boolean,
			required: !1
		},
		expand: {
			type: Boolean,
			required: !1
		},
		duration: {
			type: Number,
			required: !1
		},
		gap: {
			type: Number,
			required: !1
		},
		visibleToasts: {
			type: Number,
			required: !1
		},
		closeButton: {
			type: Boolean,
			required: !1
		},
		toastOptions: {
			type: Object,
			required: !1
		},
		class: {
			type: String,
			required: !1
		},
		style: {
			type: Object,
			required: !1
		},
		offset: {
			type: [
				Object,
				String,
				Number
			],
			required: !1
		},
		mobileOffset: {
			type: [
				Object,
				String,
				Number
			],
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		swipeDirections: {
			type: Array,
			required: !1
		},
		icons: {
			type: Object,
			required: !1
		},
		containerAriaLabel: {
			type: String,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get CircleCheckIcon() {
				return sr;
			},
			get InfoIcon() {
				return lr;
			},
			get Loader2Icon() {
				return dr;
			},
			get OctagonXIcon() {
				return gr;
			},
			get TriangleAlertIcon() {
				return br;
			},
			get XIcon() {
				return xr;
			},
			get cn() {
				return M;
			},
			get Sonner() {
				return Sr;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/sonner/Sonner.vue
function hd(e, t, r, i, o, c) {
	return g(), n(i.Sonner, f({
		class: i.cn("toaster group text-base", i.props.class),
		style: {
			"--normal-bg": "var(--popover)",
			"--normal-text": "var(--popover-foreground)",
			"--normal-border": "var(--border)",
			"--border-radius": "var(--radius)"
		}
	}, i.props), {
		"success-icon": x(() => [s(i.CircleCheckIcon, { class: "size-4" })]),
		"info-icon": x(() => [s(i.InfoIcon, { class: "size-4" })]),
		"warning-icon": x(() => [s(i.TriangleAlertIcon, { class: "size-4" })]),
		"error-icon": x(() => [s(i.OctagonXIcon, { class: "size-4" })]),
		"loading-icon": x(() => [a("div", null, [s(i.Loader2Icon, { class: "size-4 animate-spin" })])]),
		"close-icon": x(() => [s(i.XIcon, { class: "size-4" })]),
		_: 1
	}, 16, ["class"]);
}
var gd = /*#__PURE__*/ j(md, [["render", hd], ["__file", "/workspace/packages/ui/src/components/ui/sonner/Sonner.vue"]]), _d = /*@__PURE__*/ c({
	__name: "Switch",
	props: {
		defaultValue: {
			type: null,
			required: !1
		},
		modelValue: {
			type: null,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		id: {
			type: String,
			required: !1
		},
		value: {
			type: String,
			required: !1
		},
		trueValue: {
			type: null,
			required: !1
		},
		falseValue: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get cn() {
				return M;
			},
			get SwitchRoot() {
				return Mn;
			},
			get SwitchThumb() {
				return Nn;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/switch/Switch.vue
function vd(e, t, r, i, a, o) {
	return g(), n(i.SwitchRoot, f({ "data-slot": "switch" }, i.forwarded, { class: i.cn("peer data-[state=checked]:bg-primary data-[state=unchecked]:bg-switch-track focus-visible:border-ring focus-visible:ring-ring/50 dark:data-[state=unchecked]:bg-switch-track/80 inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border border-transparent shadow-none transition-all outline-none focus-visible:ring-3 disabled:cursor-not-allowed disabled:opacity-50", i.props.class) }), {
		default: x((t) => [s(i.SwitchThumb, {
			"data-slot": "switch-thumb",
			class: p(i.cn("bg-background dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0"))
		}, {
			default: x(() => [y(e.$slots, "thumb", m(l(t)))]),
			_: 2
		}, 1032, ["class"])]),
		_: 3
	}, 16, ["class"]);
}
var yd = /*#__PURE__*/ j(_d, [["render", vd], ["__file", "/workspace/packages/ui/src/components/ui/switch/Switch.vue"]]), bd = /*@__PURE__*/ c({
	__name: "Table",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
}), xd = {
	"data-slot": "table-container",
	class: "relative w-full overflow-auto"
};
function Sd(e, t, n, r, o, s) {
	return g(), i("div", xd, [a("table", {
		"data-slot": "table",
		class: p(r.cn("w-full caption-bottom text-sm", r.props.class))
	}, [y(e.$slots, "default")], 2)]);
}
var Cd = /*#__PURE__*/ j(bd, [["render", Sd], ["__file", "/workspace/packages/ui/src/components/ui/table/Table.vue"]]), wd = /*@__PURE__*/ c({
	__name: "TableBody",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/table/TableBody.vue
function Td(e, t, n, r, a, o) {
	return g(), i("tbody", {
		"data-slot": "table-body",
		class: p(r.cn("[&_tr:last-child]:border-0", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var Ed = /*#__PURE__*/ j(wd, [["render", Td], ["__file", "/workspace/packages/ui/src/components/ui/table/TableBody.vue"]]), Dd = /*@__PURE__*/ c({
	__name: "TableCaption",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/table/TableCaption.vue
function Od(e, t, n, r, a, o) {
	return g(), i("caption", {
		"data-slot": "table-caption",
		class: p(r.cn("text-muted-foreground mt-4 text-sm", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var kd = /*#__PURE__*/ j(Dd, [["render", Od], ["__file", "/workspace/packages/ui/src/components/ui/table/TableCaption.vue"]]), Ad = /*@__PURE__*/ c({
	__name: "TableCell",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/table/TableCell.vue
function jd(e, t, n, r, a, o) {
	return g(), i("td", {
		"data-slot": "table-cell",
		class: p(r.cn("p-2 align-middle whitespace-nowrap [&:has([role=checkbox])]:pr-0 *:[[role=checkbox]]:translate-y-0.5", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var Md = /*#__PURE__*/ j(Ad, [["render", jd], ["__file", "/workspace/packages/ui/src/components/ui/table/TableCell.vue"]]), Nd = /*@__PURE__*/ c({
	__name: "TableRow",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/table/TableRow.vue
function Pd(e, t, n, r, a, o) {
	return g(), i("tr", {
		"data-slot": "table-row",
		class: p(r.cn("hover:bg-muted/50 data-[state=selected]:bg-muted border-b transition-colors", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var Fd = /*#__PURE__*/ j(Nd, [["render", Pd], ["__file", "/workspace/packages/ui/src/components/ui/table/TableRow.vue"]]), Id = /*@__PURE__*/ c({
	__name: "TableEmpty",
	props: {
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		},
		colspan: {
			type: Number,
			required: !1,
			default: 1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			TableCell: Md,
			TableRow: Fd
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
}), Ld = { class: "flex items-center justify-center py-10" };
function Rd(e, t, r, i, o, c) {
	return g(), n(i.TableRow, null, {
		default: x(() => [s(i.TableCell, f({ class: i.cn("p-4 whitespace-nowrap align-middle text-sm text-foreground", i.props.class) }, i.delegatedProps), {
			default: x(() => [a("div", Ld, [y(e.$slots, "default")])]),
			_: 3
		}, 16, ["class"])]),
		_: 3
	});
}
var zd = /*#__PURE__*/ j(Id, [["render", Rd], ["__file", "/workspace/packages/ui/src/components/ui/table/TableEmpty.vue"]]), Bd = /*@__PURE__*/ c({
	__name: "TableFooter",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/table/TableFooter.vue
function Vd(e, t, n, r, a, o) {
	return g(), i("tfoot", {
		"data-slot": "table-footer",
		class: p(r.cn("bg-muted/50 border-t font-medium [&>tr]:last:border-b-0", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var Hd = /*#__PURE__*/ j(Bd, [["render", Vd], ["__file", "/workspace/packages/ui/src/components/ui/table/TableFooter.vue"]]), Ud = /*@__PURE__*/ c({
	__name: "TableHead",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/table/TableHead.vue
function Wd(e, t, n, r, a, o) {
	return g(), i("th", {
		"data-slot": "table-head",
		class: p(r.cn("text-foreground h-10 px-2 text-left align-middle font-medium whitespace-nowrap [&:has([role=checkbox])]:pr-0 *:[[role=checkbox]]:translate-y-0.5", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var Gd = /*#__PURE__*/ j(Ud, [["render", Wd], ["__file", "/workspace/packages/ui/src/components/ui/table/TableHead.vue"]]), Kd = /*@__PURE__*/ c({
	__name: "TableHeader",
	props: { class: {
		type: [
			Boolean,
			null,
			String,
			Object,
			Array
		],
		required: !1,
		skipCheck: !0
	} },
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/table/TableHeader.vue
function qd(e, t, n, r, a, o) {
	return g(), i("thead", {
		"data-slot": "table-header",
		class: p(r.cn("[&_tr]:border-b", r.props.class))
	}, [y(e.$slots, "default")], 2);
}
var Jd = /*#__PURE__*/ j(Kd, [["render", qd], ["__file", "/workspace/packages/ui/src/components/ui/table/TableHeader.vue"]]), Yd = /*@__PURE__*/ c({
	__name: "Tabs",
	props: {
		defaultValue: {
			type: null,
			required: !1
		},
		orientation: {
			type: String,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		activationMode: {
			type: String,
			required: !1
		},
		modelValue: {
			type: null,
			required: !1
		},
		unmountOnHide: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get cn() {
				return M;
			},
			get TabsRoot() {
				return In;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/tabs/Tabs.vue
function Xd(e, t, r, i, a, o) {
	return g(), n(i.TabsRoot, f({ "data-slot": "tabs" }, i.forwarded, { class: i.cn("flex flex-col gap-2", i.props.class) }), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16, ["class"]);
}
var Zd = /*#__PURE__*/ j(Yd, [["render", Xd], ["__file", "/workspace/packages/ui/src/components/ui/tabs/Tabs.vue"]]), Qd = /*@__PURE__*/ c({
	__name: "TabsContent",
	props: {
		value: {
			type: [String, Number],
			required: !0
		},
		forceMount: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get TabsContent() {
				return Pn;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/tabs/TabsContent.vue
function $d(e, t, r, i, a, o) {
	return g(), n(i.TabsContent, f({
		"data-slot": "tabs-content",
		class: i.cn("flex-1 outline-none", i.props.class)
	}, i.delegatedProps), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var ef = /*#__PURE__*/ j(Qd, [["render", $d], ["__file", "/workspace/packages/ui/src/components/ui/tabs/TabsContent.vue"]]), tf = /*@__PURE__*/ c({
	__name: "TabsList",
	props: {
		loop: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = {
			props: n,
			delegatedProps: E(n, "class"),
			get cn() {
				return M;
			},
			get TabsList() {
				return Fn;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
});
// src/components/ui/tabs/TabsList.vue
function nf(e, t, r, i, a, o) {
	return g(), n(i.TabsList, f({ "data-slot": "tabs-list" }, i.delegatedProps, { class: i.cn("glass-switcher text-foreground/60 inline-flex h-auto w-fit items-center justify-center gap-1 rounded-md p-1", i.props.class) }), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var rf = /*#__PURE__*/ j(tf, [["render", nf], ["__file", "/workspace/packages/ui/src/components/ui/tabs/TabsList.vue"]]), af = /*@__PURE__*/ c({
	__name: "TabsTrigger",
	props: {
		value: {
			type: [String, Number],
			required: !0
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = E(n, "class"), i = {
			props: n,
			delegatedProps: r,
			forwardedProps: w(r),
			get cn() {
				return M;
			},
			get TabsTrigger() {
				return Ln;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
});
// src/components/ui/tabs/TabsTrigger.vue
function of(e, t, r, i, a, o) {
	return g(), n(i.TabsTrigger, f({
		"data-slot": "tabs-trigger",
		class: i.cn("inline-flex flex-1 items-center justify-center gap-1.5 whitespace-nowrap rounded-md px-3 py-2 text-xs leading-none font-medium transition-colors hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ring-offset-background disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:hover:text-primary-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", i.props.class)
	}, i.forwardedProps), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16, ["class"]);
}
var sf = /*#__PURE__*/ j(af, [["render", of], ["__file", "/workspace/packages/ui/src/components/ui/tabs/TabsTrigger.vue"]]), cf = /*@__PURE__*/ c({
	__name: "Textarea",
	props: {
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		},
		defaultValue: {
			type: [String, Number],
			required: !1
		},
		modelValue: {
			type: [String, Number],
			required: !1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = {
			props: r,
			emits: i,
			modelValue: Zn(r, "modelValue", i, {
				passive: !0,
				defaultValue: r.defaultValue
			}),
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(a, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), a;
	}
});
// src/components/ui/textarea/Textarea.vue
function lf(e, t, n, r, a, o) {
	return le((g(), i("textarea", {
		"onUpdate:modelValue": t[0] ||= (e) => r.modelValue = e,
		"data-slot": "textarea",
		class: p(r.cn("placeholder:text-muted-foreground focus-visible:ring-ring aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive flex field-sizing-content min-h-16 w-full rounded-md glass-input px-3 py-2 text-base shadow-none transition-[color,box-shadow] outline-none focus-visible:ring-1 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", r.props.class))
	}, null, 2)), [[se, r.modelValue]]);
}
var uf = /*#__PURE__*/ j(cf, [["render", lf], ["__file", "/workspace/packages/ui/src/components/ui/textarea/Textarea.vue"]]), df = /*@__PURE__*/ c({
	__name: "ToggleGroup",
	props: {
		rovingFocus: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		orientation: {
			type: String,
			required: !1
		},
		dir: {
			type: String,
			required: !1
		},
		loop: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		},
		type: {
			type: String,
			required: !1
		},
		modelValue: {
			type: null,
			required: !1
		},
		defaultValue: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		},
		variant: {
			type: null,
			required: !1
		},
		size: {
			type: null,
			required: !1
		},
		spacing: {
			type: Number,
			required: !1,
			default: 0
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n;
		ne("toggleGroup", {
			variant: r.variant,
			size: r.size,
			spacing: r.spacing
		});
		let a = E(r, "class", "size", "variant"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get cn() {
				return M;
			},
			get ToggleGroupRoot() {
				return Bn;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/toggle-group/ToggleGroup.vue
function ff(e, t, r, i, a, o) {
	return g(), n(i.ToggleGroupRoot, f({
		"data-slot": "toggle-group",
		"data-size": r.size,
		"data-variant": r.variant,
		"data-spacing": r.spacing,
		style: { "--gap": r.spacing }
	}, i.forwarded, { class: i.cn("group/toggle-group flex w-fit items-center gap-[--spacing(var(--gap))] rounded-md data-[spacing=default]:data-[variant=outline]:shadow-xs", i.props.class) }), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16, [
		"data-size",
		"data-variant",
		"data-spacing",
		"style",
		"class"
	]);
}
var pf = /*#__PURE__*/ j(df, [["render", ff], ["__file", "/workspace/packages/ui/src/components/ui/toggle-group/ToggleGroup.vue"]]), mf = /*@__PURE__*/ c({
	__name: "Toggle",
	props: {
		defaultValue: {
			type: Boolean,
			required: !1
		},
		modelValue: {
			type: [Boolean, null],
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1,
			default: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		name: {
			type: String,
			required: !1
		},
		required: {
			type: Boolean,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		},
		variant: {
			type: null,
			required: !1,
			default: "default"
		},
		size: {
			type: null,
			required: !1,
			default: "default"
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class", "size", "variant"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get cn() {
				return M;
			},
			get Toggle() {
				return Rn;
			},
			get toggleVariants() {
				return G;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/toggle/Toggle.vue
function hf(e, t, r, i, a, o) {
	return g(), n(i.Toggle, f({ "data-slot": "toggle" }, i.forwarded, { class: i.cn(i.toggleVariants({
		variant: r.variant,
		size: r.size
	}), i.props.class) }), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16, ["class"]);
}
var gf = /*#__PURE__*/ j(mf, [["render", hf], ["__file", "/workspace/packages/ui/src/components/ui/toggle/Toggle.vue"]]), G = A("inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium hover:bg-muted hover:text-muted-foreground disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-3 outline-none transition-[color,box-shadow] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive whitespace-nowrap", {
	variants: {
		variant: {
			default: "bg-transparent",
			outline: "border border-input bg-transparent shadow-xs hover:bg-accent hover:text-accent-foreground"
		},
		size: {
			default: "h-9 px-2 min-w-9",
			sm: "h-8 px-1.5 min-w-8",
			lg: "h-10 px-2.5 min-w-10"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
}), _f = /*@__PURE__*/ c({
	__name: "ToggleGroupItem",
	props: {
		value: {
			type: null,
			required: !0
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		},
		variant: {
			type: null,
			required: !1
		},
		size: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = u("toggleGroup"), i = E(n, "class", "size", "variant"), a = {
			props: n,
			context: r,
			delegatedProps: i,
			forwardedProps: w(i),
			get cn() {
				return M;
			},
			get ToggleGroupItem() {
				return zn;
			},
			get toggleVariants() {
				return G;
			}
		};
		return Object.defineProperty(a, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), a;
	}
});
// src/components/ui/toggle-group/ToggleGroupItem.vue
function vf(e, t, r, i, a, o) {
	return g(), n(i.ToggleGroupItem, f({
		"data-slot": "toggle-group-item",
		"data-variant": i.context?.variant || r.variant,
		"data-size": i.context?.size || r.size,
		"data-spacing": i.context?.spacing
	}, i.forwardedProps, { class: i.cn(i.toggleVariants({
		variant: i.context?.variant || r.variant,
		size: i.context?.size || r.size
	}), "w-auto min-w-0 shrink-0 px-3 focus:z-10 focus-visible:z-10", "data-[spacing=0]:rounded-none data-[spacing=0]:shadow-none data-[spacing=0]:first:rounded-l-md data-[spacing=0]:last:rounded-r-md data-[spacing=0]:data-[variant=outline]:border-l-0 data-[spacing=0]:data-[variant=outline]:first:border-l", i.props.class) }), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16, [
		"data-variant",
		"data-size",
		"data-spacing",
		"class"
	]);
}
var yf = /*#__PURE__*/ j(_f, [["render", vf], ["__file", "/workspace/packages/ui/src/components/ui/toggle-group/ToggleGroupItem.vue"]]), bf = /*@__PURE__*/ c({
	__name: "Tooltip",
	props: {
		defaultOpen: {
			type: Boolean,
			required: !1
		},
		open: {
			type: Boolean,
			required: !1
		},
		delayDuration: {
			type: Number,
			required: !1
		},
		disableHoverableContent: {
			type: Boolean,
			required: !1
		},
		disableClosingTrigger: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		ignoreNonKeyboardFocus: {
			type: Boolean,
			required: !1
		}
	},
	emits: ["update:open"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = {
			props: r,
			emits: i,
			forwarded: T(r, i),
			get TooltipRoot() {
				return Gn;
			}
		};
		return Object.defineProperty(a, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), a;
	}
});
// src/components/ui/tooltip/Tooltip.vue
function xf(e, t, r, i, a, o) {
	return g(), n(i.TooltipRoot, f({ "data-slot": "tooltip" }, i.forwarded), {
		default: x((t) => [y(e.$slots, "default", m(l(t)))]),
		_: 3
	}, 16);
}
var Sf = /*#__PURE__*/ j(bf, [["render", xf], ["__file", "/workspace/packages/ui/src/components/ui/tooltip/Tooltip.vue"]]), Cf = /*@__PURE__*/ c({
	inheritAttrs: !1,
	__name: "TooltipContent",
	props: {
		forceMount: {
			type: Boolean,
			required: !1
		},
		ariaLabel: {
			type: String,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		},
		side: {
			type: null,
			required: !1
		},
		sideOffset: {
			type: Number,
			required: !1,
			default: 4
		},
		align: {
			type: null,
			required: !1
		},
		alignOffset: {
			type: Number,
			required: !1
		},
		avoidCollisions: {
			type: Boolean,
			required: !1
		},
		collisionBoundary: {
			type: null,
			required: !1
		},
		collisionPadding: {
			type: [Number, Object],
			required: !1
		},
		arrowPadding: {
			type: Number,
			required: !1
		},
		sticky: {
			type: String,
			required: !1
		},
		hideWhenDetached: {
			type: Boolean,
			required: !1
		},
		positionStrategy: {
			type: String,
			required: !1
		},
		updatePositionStrategy: {
			type: String,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: ["escapeKeyDown", "pointerDownOutside"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = e, i = n, a = E(r, "class"), o = {
			props: r,
			emits: i,
			delegatedProps: a,
			forwarded: T(a, i),
			get cn() {
				return M;
			},
			get TooltipArrow() {
				return Vn;
			},
			get TooltipContent() {
				return Hn;
			},
			get TooltipPortal() {
				return Un;
			}
		};
		return Object.defineProperty(o, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), o;
	}
});
// src/components/ui/tooltip/TooltipContent.vue
function wf(e, t, r, i, a, o) {
	return g(), n(i.TooltipPortal, null, {
		default: x(() => [s(i.TooltipContent, f({ "data-slot": "tooltip-content" }, {
			...i.forwarded,
			...e.$attrs
		}, { class: i.cn("bg-foreground text-background animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit rounded-md px-3 py-1.5 text-xs text-balance", i.props.class) }), {
			default: x(() => [y(e.$slots, "default"), s(i.TooltipArrow, { class: "bg-foreground fill-foreground z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-xs" })]),
			_: 3
		}, 16, ["class"])]),
		_: 3
	});
}
var Tf = /*#__PURE__*/ j(Cf, [["render", wf], ["__file", "/workspace/packages/ui/src/components/ui/tooltip/TooltipContent.vue"]]), Ef = /*@__PURE__*/ c({
	__name: "TooltipProvider",
	props: {
		delayDuration: {
			type: Number,
			required: !1,
			default: 0
		},
		skipDelayDuration: {
			type: Number,
			required: !1
		},
		disableHoverableContent: {
			type: Boolean,
			required: !1
		},
		disableClosingTrigger: {
			type: Boolean,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		ignoreNonKeyboardFocus: {
			type: Boolean,
			required: !1
		},
		content: {
			type: Object,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get TooltipProvider() {
				return Wn;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/tooltip/TooltipProvider.vue
function Df(e, t, r, i, a, o) {
	return g(), n(i.TooltipProvider, m(l(i.props)), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var Of = /*#__PURE__*/ j(Ef, [["render", Df], ["__file", "/workspace/packages/ui/src/components/ui/tooltip/TooltipProvider.vue"]]), kf = /*@__PURE__*/ c({
	__name: "TooltipTrigger",
	props: {
		reference: {
			type: null,
			required: !1
		},
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get TooltipTrigger() {
				return Kn;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/ui/tooltip/TooltipTrigger.vue
function Af(e, t, r, i, a, o) {
	return g(), n(i.TooltipTrigger, f({ "data-slot": "tooltip-trigger" }, i.props), {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 16);
}
var jf = /*#__PURE__*/ j(kf, [["render", Af], ["__file", "/workspace/packages/ui/src/components/ui/tooltip/TooltipTrigger.vue"]]), Mf = /*@__PURE__*/ c({
	__name: "AppShell",
	props: {
		bare: {
			type: Boolean,
			required: !1,
			default: !1
		},
		menuLabel: {
			type: String,
			required: !1,
			default: "Open navigation menu"
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = e, r = _(!1), i = {
			props: n,
			menuOpen: r,
			close: () => {
				r.value = !1;
			},
			get Menu() {
				return fr;
			},
			get Button() {
				return N;
			},
			get Sheet() {
				return H;
			},
			get SheetContent() {
				return U;
			},
			get SheetTitle() {
				return W;
			},
			get SheetTrigger() {
				return sd;
			},
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(i, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), i;
	}
}), Nf = { class: "sticky top-[var(--app-banner-h,0px)] hidden h-[calc(100vh-var(--app-banner-h,0px))] w-64 shrink-0 p-2 lg:block" }, Pf = { class: "glass-panel flex h-full text-base w-full flex-col overflow-hidden rounded-xl" }, Ff = { class: "flex min-w-0 flex-1 flex-col" }, If = { class: "sticky top-[var(--app-banner-h,0px)] z-40 p-3" }, Lf = { class: "glass-panel flex flex-col text-base rounded-2xl" }, Rf = { class: "grid h-12 grid-cols-[minmax(max-content,1fr)_minmax(0,auto)_minmax(max-content,1fr)] items-center gap-3 px-3" }, zf = { class: "flex min-w-0 items-center gap-3" }, Bf = { class: "flex min-w-0 justify-center truncate text-sm font-semibold text-foreground" }, Vf = { class: "flex min-w-0 items-center justify-end gap-2" };
function Hf(e, t, n, r, c, l) {
	return n.bare ? (g(), i("div", {
		key: 0,
		"data-slot": "app-shell",
		class: p(r.cn("app-aurora min-h-[calc(100vh-var(--app-banner-h,0px))] mt-[var(--app-banner-h,0px)]", r.props.class))
	}, [y(e.$slots, "default")], 2)) : (g(), i("div", {
		key: 1,
		"data-slot": "app-shell",
		class: p(r.cn("app-aurora flex min-h-[calc(100vh-var(--app-banner-h,0px))] mt-[var(--app-banner-h,0px)]", r.props.class))
	}, [a("aside", Nf, [a("div", Pf, [y(e.$slots, "sidebar", { close: r.close })])]), a("div", Ff, [a("div", If, [a("header", Lf, [a("div", Rf, [
		a("div", zf, [s(r.Sheet, {
			open: r.menuOpen,
			"onUpdate:open": t[0] ||= (e) => r.menuOpen = e
		}, {
			default: x(() => [s(r.SheetTrigger, { "as-child": "" }, {
				default: x(() => [s(r.Button, {
					variant: "ghost",
					size: "icon",
					"aria-label": n.menuLabel,
					class: "shrink-0 hover:bg-primary hover:text-primary-foreground lg:hidden"
				}, {
					default: x(() => [s(r.Menu, { class: "size-5" })]),
					_: 1
				}, 8, ["aria-label"])]),
				_: 1
			}), s(r.SheetContent, {
				side: "left",
				class: "w-72 text-base gap-0 p-0",
				"show-close-button": !1
			}, {
				default: x(() => [s(r.SheetTitle, { class: "sr-only" }, {
					default: x(() => [o(b(n.menuLabel), 1)]),
					_: 1
				}), y(e.$slots, "sidebar", { close: r.close })]),
				_: 3
			})]),
			_: 3
		}, 8, ["open"]), y(e.$slots, "header-start")]),
		a("div", Bf, [y(e.$slots, "header")]),
		a("div", Vf, [y(e.$slots, "header-end")])
	]), y(e.$slots, "header-bottom")])]), y(e.$slots, "default")])], 2));
}
var Uf = /*#__PURE__*/ j(Mf, [["render", Hf], ["__file", "/workspace/packages/ui/src/components/app/AppShell.vue"]]), Wf = /*@__PURE__*/ c({
	__name: "ComboboxSelect",
	props: {
		modelValue: {
			type: null,
			required: !1
		},
		options: {
			type: Array,
			required: !0
		},
		optionValue: {
			type: [String, Function],
			required: !1
		},
		optionLabel: {
			type: [String, Function],
			required: !1
		},
		optionDisabled: {
			type: Function,
			required: !1
		},
		placeholder: {
			type: String,
			required: !1,
			default: ""
		},
		searchPlaceholder: {
			type: String,
			required: !1,
			default: "Search…"
		},
		emptyText: {
			type: String,
			required: !1,
			default: "No results"
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		id: {
			type: String,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: n, emit: r }) {
		n();
		let i = e, a = r, o = _(!1);
		function s(e, t) {
			return typeof t == "function" ? t(e) : t && typeof e == "object" && e ? e[t] : e;
		}
		let c = (e) => s(e, i.optionValue), l = (e) => String(s(e, i.optionLabel) ?? ""), u = t(() => i.options.find((e) => c(e) === i.modelValue));
		function d(e) {
			a("update:modelValue", c(e)), o.value = !1;
		}
		let f = {
			props: i,
			emit: a,
			isOpen: o,
			pick: s,
			valueOf: c,
			labelOf: l,
			selected: u,
			select: d,
			get Check() {
				return D;
			},
			get ChevronsUpDown() {
				return ar;
			},
			get Command() {
				return F;
			},
			get CommandEmpty() {
				return I;
			},
			get CommandGroup() {
				return L;
			},
			get CommandInput() {
				return R;
			},
			get CommandItem() {
				return z;
			},
			get CommandList() {
				return B;
			},
			get Popover() {
				return Kc;
			},
			get PopoverContent() {
				return Qc;
			},
			get PopoverTrigger() {
				return tl;
			},
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(f, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), f;
	}
}), Gf = [
	"id",
	"aria-expanded",
	"disabled"
], Kf = {
	key: 0,
	class: "flex min-w-0 items-center gap-2 overflow-x-clip whitespace-nowrap"
}, qf = {
	key: 1,
	class: "truncate text-muted-foreground"
}, Jf = { class: "flex min-w-0 items-center gap-2 overflow-x-clip whitespace-nowrap" };
function Yf(t, c, l, u, d, f) {
	return g(), n(u.Popover, {
		open: u.isOpen,
		"onUpdate:open": c[0] ||= (e) => u.isOpen = e
	}, {
		default: x(() => [s(u.PopoverTrigger, { "as-child": "" }, {
			default: x(() => [a("button", {
				id: l.id,
				type: "button",
				"data-slot": "combobox-trigger",
				role: "combobox",
				"aria-expanded": u.isOpen,
				disabled: l.disabled,
				class: p(u.cn("glass-input flex h-9 w-full items-center justify-between gap-2 rounded-md px-3 py-2 text-sm whitespace-nowrap focus-visible:ring-1 focus-visible:ring-ring focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50", u.props.class))
			}, [u.selected ? (g(), i("span", Kf, [y(t.$slots, "option", {
				option: u.selected,
				label: u.labelOf(u.selected)
			}, () => [o(b(u.labelOf(u.selected)), 1)])])) : (g(), i("span", qf, b(l.placeholder), 1)), s(u.ChevronsUpDown, { class: "size-4 shrink-0 opacity-50" })], 10, Gf)]),
			_: 3
		}), s(u.PopoverContent, {
			align: "start",
			class: "w-(--reka-popover-trigger-width) min-w-56 p-0"
		}, {
			default: x(() => [s(u.Command, null, {
				default: x(() => [s(u.CommandInput, { placeholder: l.searchPlaceholder }, null, 8, ["placeholder"]), s(u.CommandList, { class: "max-h-72" }, {
					default: x(() => [s(u.CommandEmpty, null, {
						default: x(() => [o(b(l.emptyText), 1)]),
						_: 1
					}), s(u.CommandGroup, null, {
						default: x(() => [(g(!0), i(e, null, v(l.options, (e, i) => (g(), n(u.CommandItem, {
							key: i,
							value: u.labelOf(e),
							disabled: l.optionDisabled ? l.optionDisabled(e) : !1,
							onSelect: () => u.select(e)
						}, {
							default: x(() => [a("span", Jf, [y(t.$slots, "option", {
								option: e,
								label: u.labelOf(e)
							}, () => [o(b(u.labelOf(e)), 1)])]), u.selected === e ? (g(), n(u.Check, {
								key: 0,
								class: "ml-auto"
							})) : r("v-if", !0)]),
							_: 2
						}, 1032, [
							"value",
							"disabled",
							"onSelect"
						]))), 128))]),
						_: 3
					})]),
					_: 3
				})]),
				_: 3
			})]),
			_: 3
		})]),
		_: 3
	}, 8, ["open"]);
}
var Xf = /*#__PURE__*/ j(Wf, [["render", Yf], ["__file", "/workspace/packages/ui/src/components/app/ComboboxSelect.vue"]]);
// ../../node_modules/@internationalized/date/dist/private/utils.mjs
function Zf(e, t) {
	return e - t * Math.floor(e / t);
}
// ../../node_modules/@internationalized/date/dist/private/calendars/GregorianCalendar.mjs
var Qf = 1721426;
function K(e, t, n, r) {
	t = $f(e, t);
	let i = t - 1, a = -2;
	return n <= 2 ? a = 0 : q(t) && (a = -1), 1721425 + 365 * i + Math.floor(i / 4) - Math.floor(i / 100) + Math.floor(i / 400) + Math.floor((367 * n - 362) / 12 + a + r);
}
function q(e) {
	return e % 4 == 0 && (e % 100 != 0 || e % 400 == 0);
}
function $f(e, t) {
	return e === "BC" ? 1 - t : t;
}
function ep(e) {
	let t = "AD";
	return e <= 0 && (t = "BC", e = 1 - e), [t, e];
}
var tp = {
	standard: [
		31,
		28,
		31,
		30,
		31,
		30,
		31,
		31,
		30,
		31,
		30,
		31
	],
	leapyear: [
		31,
		29,
		31,
		30,
		31,
		30,
		31,
		31,
		30,
		31,
		30,
		31
	]
}, J = class {
	fromJulianDay(e) {
		let t = e, n = t - Qf, r = Math.floor(n / 146097), i = Zf(n, 146097), a = Math.floor(i / 36524), o = Zf(i, 36524), s = Math.floor(o / 1461), c = Zf(o, 1461), l = Math.floor(c / 365), [u, d] = ep(r * 400 + a * 100 + s * 4 + l + +(a !== 4 && l !== 4)), f = t - K(u, d, 1, 1), p = 2;
		t < K(u, d, 3, 1) ? p = 0 : q(d) && (p = 1);
		let m = Math.floor(((f + p) * 12 + 373) / 367);
		return new Rp(u, d, m, t - K(u, d, m, 1) + 1);
	}
	toJulianDay(e) {
		return K(e.era, e.year, e.month, e.day);
	}
	getDaysInMonth(e) {
		return tp[q(e.year) ? "leapyear" : "standard"][e.month - 1];
	}
	getMonthsInYear(e) {
		return 12;
	}
	getDaysInYear(e) {
		return q(e.year) ? 366 : 365;
	}
	getMaximumMonthsInYear() {
		return 12;
	}
	getMaximumDaysInMonth() {
		return 31;
	}
	getYearsInEra(e) {
		return 9999;
	}
	getEras() {
		return ["BC", "AD"];
	}
	isInverseEra(e) {
		return e.era === "BC";
	}
	balanceDate(e) {
		e.year <= 0 && (e.era = e.era === "BC" ? "AD" : "BC", e.year = 1 - e.year);
	}
	constructor() {
		this.identifier = "gregory";
	}
};
// ../../node_modules/@internationalized/date/dist/private/queries.mjs
function np(e, t) {
	return e.isEqual?.(t) ?? t.isEqual?.(e) ?? e.identifier === t.identifier;
}
function rp(e, t) {
	return e.calendar.toJulianDay(e) - t.calendar.toJulianDay(t);
}
function ip(e, t) {
	return ap(e) - ap(t);
}
function ap(e) {
	return e.hour * 36e5 + e.minute * 6e4 + e.second * 1e3 + e.millisecond;
}
var op = null, sp = !1;
function Y() {
	return op ??= new Intl.DateTimeFormat().resolvedOptions().timeZone, op;
}
function cp() {
	return sp;
}
// ../../node_modules/@internationalized/date/dist/private/conversion.mjs
function lp(e) {
	return e = bp(e, new J()), up($f(e.era, e.year), e.month, e.day, e.hour, e.minute, e.second, e.millisecond);
}
function up(e, t, n, r, i, a, o) {
	let s = /* @__PURE__ */ new Date();
	return s.setUTCHours(r, i, a, o), s.setUTCFullYear(e, t - 1, n), s.getTime();
}
function dp(e, t) {
	if (t === "UTC") return 0;
	if (e > 0 && t === Y() && !cp()) return new Date(e).getTimezoneOffset() * -6e4;
	let { year: n, month: r, day: i, hour: a, minute: o, second: s } = pp(e, t);
	return up(n, r, i, a, o, s, 0) - Math.floor(e / 1e3) * 1e3;
}
var fp = /* @__PURE__ */ new Map();
function pp(e, t) {
	let n = fp.get(t);
	n || (n = new Intl.DateTimeFormat("en-US", {
		timeZone: t,
		hour12: !1,
		era: "short",
		year: "numeric",
		month: "numeric",
		day: "numeric",
		hour: "numeric",
		minute: "numeric",
		second: "numeric"
	}), fp.set(t, n));
	let r = n.formatToParts(new Date(e)), i = {};
	for (let e of r) e.type !== "literal" && (i[e.type] = e.value);
	return {
		year: i.era === "BC" || i.era === "B" ? -i.year + 1 : +i.year,
		month: +i.month,
		day: +i.day,
		hour: i.hour === "24" ? 0 : +i.hour,
		minute: +i.minute,
		second: +i.second
	};
}
var mp = 864e5;
function hp(e, t, n, r) {
	return (n === r ? [n] : [n, r]).filter((n) => gp(e, t, n));
}
function gp(e, t, n) {
	let r = pp(n, t);
	return e.year === r.year && e.month === r.month && e.day === r.day && e.hour === r.hour && e.minute === r.minute && e.second === r.second;
}
function _p(e, t, n = "compatible") {
	let r = yp(e);
	if (t === "UTC") return lp(r);
	if (t === Y() && n === "compatible" && !cp()) {
		r = bp(r, new J());
		let e = /* @__PURE__ */ new Date(), t = $f(r.era, r.year);
		return e.setFullYear(t, r.month - 1, r.day), e.setHours(r.hour, r.minute, r.second, r.millisecond), e.getTime();
	}
	let i = lp(r), a = dp(i - mp, t), o = dp(i + mp, t), s = hp(r, t, i - a, i - o);
	if (s.length === 1) return s[0];
	if (s.length > 1) switch (n) {
		case "compatible":
		case "earlier": return s[0];
		case "later": return s[s.length - 1];
		case "reject": throw RangeError("Multiple possible absolute times found");
	}
	switch (n) {
		case "earlier": return Math.min(i - a, i - o);
		case "compatible":
		case "later": return Math.max(i - a, i - o);
		case "reject": throw RangeError("No such absolute time found");
	}
}
function vp(e, t, n = "compatible") {
	return new Date(_p(e, t, n));
}
function yp(e, t) {
	let n = 0, r = 0, i = 0, a = 0;
	if ("timeZone" in e) ({hour: n, minute: r, second: i, millisecond: a} = e);
	else if ("hour" in e && !t) return e;
	return t && ({hour: n, minute: r, second: i, millisecond: a} = t), new zp(e.calendar, e.era, e.year, e.month, e.day, n, r, i, a);
}
function bp(e, t) {
	if (np(e.calendar, t)) return e;
	let n = t.fromJulianDay(e.calendar.toJulianDay(e)), r = e.copy();
	return r.calendar = t, r.era = n.era, r.year = n.year, r.month = n.month, r.day = n.day, Z(r), r;
}
// ../../node_modules/@internationalized/date/dist/private/manipulation.mjs
function xp(e, t) {
	let n = e.copy(), r = "hour" in n ? jp(n, t) : 0;
	Sp(n, t.years || 0), n.calendar.balanceYearMonth && n.calendar.balanceYearMonth(n, e), n.month += t.months || 0, X(n), wp(n), n.day += (t.weeks || 0) * 7, n.day += t.days || 0, n.day += r, Cp(n), n.calendar.balanceDate && n.calendar.balanceDate(n), n.year < 1 && (n.year = 1, n.month = 1, n.day = 1);
	let i = n.calendar.getYearsInEra(n);
	if (n.year > i) {
		let e = n.calendar.isInverseEra?.(n);
		n.year = i, n.month = e ? 1 : n.calendar.getMonthsInYear(n), n.day = e ? 1 : n.calendar.getDaysInMonth(n);
	}
	n.month < 1 && (n.month = 1, n.day = 1);
	let a = n.calendar.getMonthsInYear(n);
	return n.month > a && (n.month = a, n.day = n.calendar.getDaysInMonth(n)), n.day = Math.max(1, Math.min(n.calendar.getDaysInMonth(n), n.day)), n;
}
function Sp(e, t) {
	e.calendar.isInverseEra?.(e) && (t = -t), e.year += t;
}
function X(e) {
	for (; e.month < 1;) Sp(e, -1), e.month += e.calendar.getMonthsInYear(e);
	let t = 0;
	for (; e.month > (t = e.calendar.getMonthsInYear(e));) e.month -= t, Sp(e, 1);
}
function Cp(e) {
	for (; e.day < 1;) e.month--, X(e), e.day += e.calendar.getDaysInMonth(e);
	for (; e.day > e.calendar.getDaysInMonth(e);) e.day -= e.calendar.getDaysInMonth(e), e.month++, X(e);
}
function wp(e) {
	e.month = Math.max(1, Math.min(e.calendar.getMonthsInYear(e), e.month)), e.day = Math.max(1, Math.min(e.calendar.getDaysInMonth(e), e.day));
}
function Z(e) {
	e.calendar.constrainDate && e.calendar.constrainDate(e), e.year = Math.max(1, Math.min(e.calendar.getYearsInEra(e), e.year)), wp(e);
}
function Tp(e) {
	let t = {};
	for (let n in e) typeof e[n] == "number" && (t[n] = -e[n]);
	return t;
}
function Ep(e, t) {
	return xp(e, Tp(t));
}
function Dp(e, t) {
	let n = e.copy();
	return t.era != null && (n.era = t.era), t.year != null && (n.year = t.year), t.month != null && (n.month = t.month), t.day != null && (n.day = t.day), Z(n), n;
}
function Op(e, t) {
	let n = e.copy();
	return t.hour != null && (n.hour = t.hour), t.minute != null && (n.minute = t.minute), t.second != null && (n.second = t.second), t.millisecond != null && (n.millisecond = t.millisecond), Ap(n), n;
}
function kp(e) {
	e.second += Math.floor(e.millisecond / 1e3), e.millisecond = Q(e.millisecond, 1e3), e.minute += Math.floor(e.second / 60), e.second = Q(e.second, 60), e.hour += Math.floor(e.minute / 60), e.minute = Q(e.minute, 60);
	let t = Math.floor(e.hour / 24);
	return e.hour = Q(e.hour, 24), t;
}
function Ap(e) {
	e.millisecond = Math.max(0, Math.min(e.millisecond, 999)), e.second = Math.max(0, Math.min(e.second, 59)), e.minute = Math.max(0, Math.min(e.minute, 59)), e.hour = Math.max(0, Math.min(e.hour, 23));
}
function Q(e, t) {
	let n = e % t;
	return n < 0 && (n += t), n;
}
function jp(e, t) {
	return e.hour += t.hours || 0, e.minute += t.minutes || 0, e.second += t.seconds || 0, e.millisecond += t.milliseconds || 0, kp(e);
}
function Mp(e, t, n, r) {
	let i = e.copy();
	switch (t) {
		case "era": {
			let t = e.calendar.getEras(), a = t.indexOf(e.era);
			if (a < 0) throw Error("Invalid era: " + e.era);
			a = $(a, n, 0, t.length - 1, r?.round), i.era = t[a], Z(i);
			break;
		}
		case "year":
			i.calendar.isInverseEra?.(i) && (n = -n), i.year = $(e.year, n, -Infinity, 9999, r?.round), i.year === -Infinity && (i.year = 1), i.calendar.balanceYearMonth && i.calendar.balanceYearMonth(i, e);
			break;
		case "month":
			i.month = $(e.month, n, 1, e.calendar.getMonthsInYear(e), r?.round);
			break;
		case "day":
			i.day = $(e.day, n, 1, e.calendar.getDaysInMonth(e), r?.round);
			break;
		default: throw Error("Unsupported field " + t);
	}
	return e.calendar.balanceDate && e.calendar.balanceDate(i), Z(i), i;
}
function Np(e, t, n, r) {
	let i = e.copy();
	switch (t) {
		case "hour": {
			let t = e.hour, a = 0, o = 23;
			if (r?.hourCycle === 12) {
				let e = t >= 12;
				a = e ? 12 : 0, o = e ? 23 : 11;
			}
			i.hour = $(t, n, a, o, r?.round);
			break;
		}
		case "minute":
			i.minute = $(e.minute, n, 0, 59, r?.round);
			break;
		case "second":
			i.second = $(e.second, n, 0, 59, r?.round);
			break;
		case "millisecond":
			i.millisecond = $(e.millisecond, n, 0, 999, r?.round);
			break;
		default: throw Error("Unsupported field " + t);
	}
	return i;
}
function $(e, t, n, r, i = !1) {
	if (i) {
		e += Math.sign(t), e < n && (e = r);
		let i = Math.abs(t);
		e = t > 0 ? Math.ceil(e / i) * i : Math.floor(e / i) * i, e > r && (e = n);
	} else e += t, e < n ? e = r - (n - e - 1) : e > r && (e = n + (e - r - 1));
	return e;
}
function Pp(e) {
	return `${String(e.hour).padStart(2, "0")}:${String(e.minute).padStart(2, "0")}:${String(e.second).padStart(2, "0")}${e.millisecond ? String(e.millisecond / 1e3).slice(1) : ""}`;
}
function Fp(e) {
	let t = bp(e, new J()), n;
	return n = t.era === "BC" ? t.year === 1 ? "0000" : "-" + String(Math.abs(1 - t.year)).padStart(6, "00") : String(t.year).padStart(4, "0"), `${n}-${String(t.month).padStart(2, "0")}-${String(t.day).padStart(2, "0")}`;
}
function Ip(e) {
	return `${Fp(e)}T${Pp(e)}`;
}
// ../../node_modules/@internationalized/date/dist/private/CalendarDate.mjs
function Lp(e) {
	let t = typeof e[0] == "object" ? e.shift() : new J(), n;
	if (typeof e[0] == "string") n = e.shift();
	else {
		let e = t.getEras();
		n = e[e.length - 1];
	}
	let r = e.shift(), i = e.shift(), a = e.shift();
	return [
		t,
		n,
		r,
		i,
		a
	];
}
var Rp = class e {
	constructor(...e) {
		let [t, n, r, i, a] = Lp(e);
		this.calendar = t, this.era = n, this.year = r, this.month = i, this.day = a, Z(this);
	}
	copy() {
		return this.era ? new e(this.calendar, this.era, this.year, this.month, this.day) : new e(this.calendar, this.year, this.month, this.day);
	}
	add(e) {
		return xp(this, e);
	}
	subtract(e) {
		return Ep(this, e);
	}
	set(e) {
		return Dp(this, e);
	}
	cycle(e, t, n) {
		return Mp(this, e, t, n);
	}
	toDate(e) {
		return vp(this, e);
	}
	toString() {
		return Fp(this);
	}
	compare(e) {
		return rp(this, e);
	}
}, zp = class e {
	constructor(...e) {
		let [t, n, r, i, a] = Lp(e);
		this.calendar = t, this.era = n, this.year = r, this.month = i, this.day = a, this.hour = e.shift() || 0, this.minute = e.shift() || 0, this.second = e.shift() || 0, this.millisecond = e.shift() || 0, Z(this);
	}
	copy() {
		return this.era ? new e(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond) : new e(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
	}
	add(e) {
		return xp(this, e);
	}
	subtract(e) {
		return Ep(this, e);
	}
	set(e) {
		return Dp(Op(this, e), e);
	}
	cycle(e, t, n) {
		switch (e) {
			case "era":
			case "year":
			case "month":
			case "day": return Mp(this, e, t, n);
			default: return Np(this, e, t, n);
		}
	}
	toDate(e, t) {
		return vp(this, e, t);
	}
	toString() {
		return Ip(this);
	}
	compare(e) {
		let t = rp(this, e);
		return t === 0 ? ip(this, yp(e)) : t;
	}
}, Bp = /*@__PURE__*/ c({
	__name: "DateCalendar",
	props: {
		modelValue: {
			type: [Date, null],
			required: !0
		},
		locale: {
			type: String,
			required: !1,
			default: "en"
		},
		minDate: {
			type: [Date, null],
			required: !1,
			default: null
		},
		maxDate: {
			type: [Date, null],
			required: !1,
			default: null
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: n, emit: r }) {
		n();
		let i = e, a = r;
		function o(e) {
			return e ? new Rp(e.getFullYear(), e.getMonth() + 1, e.getDate()) : void 0;
		}
		let s = t(() => o(i.modelValue)), c = t(() => o(i.minDate)), l = t(() => o(i.maxDate));
		function u(e) {
			e && a("update:modelValue", e.toDate(Y()));
		}
		let d = {
			props: i,
			emit: a,
			toCalendarDate: o,
			value: s,
			minValue: c,
			maxValue: l,
			onUpdate: u,
			get Calendar() {
				return aa;
			}
		};
		return Object.defineProperty(d, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), d;
	}
});
// src/components/app/DateCalendar.vue
function Vp(e, t, r, i, a, o) {
	return g(), n(i.Calendar, {
		"model-value": i.value,
		"default-placeholder": i.value,
		locale: r.locale,
		"min-value": i.minValue,
		"max-value": i.maxValue,
		"weekday-format": "short",
		"prevent-deselect": "",
		"onUpdate:modelValue": i.onUpdate
	}, null, 8, [
		"model-value",
		"default-placeholder",
		"locale",
		"min-value",
		"max-value"
	]);
}
var Hp = /*#__PURE__*/ j(Bp, [["render", Vp], ["__file", "/workspace/packages/ui/src/components/app/DateCalendar.vue"]]), Up = /*@__PURE__*/ c({
	__name: "DateRangeCalendar",
	props: {
		modelValue: {
			type: Object,
			required: !0
		},
		locale: {
			type: String,
			required: !1,
			default: "en"
		},
		maxDate: {
			type: [Date, null],
			required: !1,
			default: null
		},
		numberOfMonths: {
			type: Number,
			required: !1,
			default: 1
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: n, emit: r }) {
		n();
		let i = e, a = r;
		function o(e) {
			return e ? new Rp(e.getFullYear(), e.getMonth() + 1, e.getDate()) : void 0;
		}
		let s = t(() => ({
			start: o(i.modelValue.start),
			end: o(i.modelValue.end)
		})), c = t(() => o(i.maxDate));
		function l(e) {
			if (!e.start || !e.end) return;
			let t = e.start.toDate(Y()), n = e.end.toDate(Y());
			t.setHours(0, 0, 0, 0), n.setHours(23, 59, 59, 999), a("update:modelValue", {
				start: t,
				end: n
			});
		}
		let u = {
			props: i,
			emit: a,
			toCalendarDate: o,
			range: s,
			maxValue: c,
			onUpdate: l,
			get RangeCalendar() {
				return hl;
			}
		};
		return Object.defineProperty(u, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), u;
	}
});
// src/components/app/DateRangeCalendar.vue
function Wp(e, t, r, i, a, o) {
	return g(), n(i.RangeCalendar, {
		"model-value": i.range,
		locale: r.locale,
		"max-value": i.maxValue,
		"number-of-months": r.numberOfMonths,
		"weekday-format": "short",
		"onUpdate:modelValue": i.onUpdate
	}, null, 8, [
		"model-value",
		"locale",
		"max-value",
		"number-of-months"
	]);
}
var Gp = /*#__PURE__*/ j(Up, [["render", Wp], ["__file", "/workspace/packages/ui/src/components/app/DateRangeCalendar.vue"]]), Kp = /*@__PURE__*/ c({
	__name: "EmptyState",
	props: {
		title: {
			type: String,
			required: !0
		},
		description: {
			type: String,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
}), qp = {
	key: 0,
	class: "flex size-12 items-center justify-center rounded-2xl bg-primary/10 text-primary [&_svg]:size-6"
}, Jp = { class: "flex max-w-sm flex-col gap-1" }, Yp = { class: "text-base font-semibold" }, Xp = {
	key: 0,
	class: "text-sm text-muted-foreground"
};
function Zp(e, t, n, o, s, c) {
	return g(), i("div", {
		"data-slot": "empty-state",
		class: p(o.cn("flex flex-col items-center justify-center gap-3 px-6 py-12 text-center", o.props.class))
	}, [
		e.$slots.icon ? (g(), i("div", qp, [y(e.$slots, "icon")])) : r("v-if", !0),
		a("div", Jp, [a("h3", Yp, b(n.title), 1), n.description ? (g(), i("p", Xp, b(n.description), 1)) : r("v-if", !0)]),
		y(e.$slots, "default")
	], 2);
}
var Qp = /*#__PURE__*/ j(Kp, [["render", Zp], ["__file", "/workspace/packages/ui/src/components/app/EmptyState.vue"]]), $p = /*@__PURE__*/ c({
	__name: "ModalLayout",
	props: {
		title: {
			type: String,
			required: !1,
			default: ""
		},
		description: {
			type: String,
			required: !1,
			default: ""
		},
		icon: {
			type: null,
			required: !1,
			default: null
		},
		tone: {
			type: String,
			required: !1,
			default: "primary"
		},
		stacked: {
			type: Boolean,
			required: !1,
			default: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: n }) {
		n();
		let r = e, i = oe(), a = {
			props: r,
			slots: i,
			hasHeader: t(() => !!(r.title || i.header || i.toolbar)),
			TONES: {
				primary: "bg-primary/10 text-primary",
				destructive: "bg-destructive/10 text-destructive",
				warning: "bg-warning/15 text-warning",
				success: "bg-success/15 text-success"
			},
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(a, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), a;
	}
}), em = {
	key: 0,
	"data-slot": "modal-layout-header",
	class: "flex shrink-0 flex-col gap-4 border-b border-border/60 pb-4"
}, tm = {
	key: 0,
	class: "flex items-center gap-3"
}, nm = { class: "flex min-w-0 flex-1 flex-col gap-1" }, rm = {
	key: 0,
	class: "text-xl leading-tight font-semibold text-foreground"
}, im = {
	key: 0,
	class: "text-muted-foreground"
};
function am(e, t, o, s, c, l) {
	return g(), i("div", {
		"data-slot": "modal-layout",
		class: p(s.cn("flex max-h-full min-h-0 flex-col text-sm text-foreground", s.props.class))
	}, [
		s.hasHeader ? (g(), i("header", em, [o.title || e.$slots.header ? (g(), i("div", tm, [o.icon ? (g(), i("span", {
			key: 0,
			class: p(s.cn("flex size-10 shrink-0 items-center justify-center rounded-xl", s.TONES[o.tone]))
		}, [(g(), n(ie(o.icon), { class: "size-5" }))], 2)) : r("v-if", !0), a("div", nm, [o.title ? (g(), i("h2", rm, b(o.title), 1)) : r("v-if", !0), y(e.$slots, "header")])])) : r("v-if", !0), y(e.$slots, "toolbar")])) : r("v-if", !0),
		a("div", {
			"data-slot": "modal-layout-body",
			class: p(s.cn("scrollbar-thin -mx-4 flex min-h-0 flex-1 flex-col gap-5 overflow-y-auto px-4 *:shrink-0", s.hasHeader && "pt-5", e.$slots.footer ? "pb-4" : "pb-5"))
		}, [o.description ? (g(), i("p", im, b(o.description), 1)) : r("v-if", !0), y(e.$slots, "default")], 2),
		e.$slots.footer ? (g(), i("footer", {
			key: 1,
			"data-slot": "modal-layout-footer",
			class: p(s.cn("flex shrink-0 gap-2 border-t border-border/60 pt-4 pb-5 *:flex-1", o.stacked && "flex-col"))
		}, [y(e.$slots, "footer")], 2)) : r("v-if", !0)
	], 2);
}
var om = /*#__PURE__*/ j($p, [["render", am], ["__file", "/workspace/packages/ui/src/components/app/ModalLayout.vue"]]), sm = /*@__PURE__*/ c({
	__name: "NumberInput",
	props: {
		modelValue: {
			type: [Number, null],
			required: !1,
			default: null
		},
		min: {
			type: Number,
			required: !1
		},
		max: {
			type: Number,
			required: !1
		},
		step: {
			type: Number,
			required: !1,
			default: 1
		},
		decimals: {
			type: Number,
			required: !1
		},
		locale: {
			type: String,
			required: !1,
			default: "en"
		},
		placeholder: {
			type: String,
			required: !1
		},
		disabled: {
			type: Boolean,
			required: !1
		},
		id: {
			type: String,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	emits: ["update:modelValue"],
	setup(e, { expose: n, emit: r }) {
		n();
		let i = e, a = r, o = t(() => i.decimals === void 0 ? (String(i.step).split(".")[1] ?? "").length : i.decimals), s = t(() => ({
			useGrouping: !1,
			minimumFractionDigits: 0,
			maximumFractionDigits: o.value
		}));
		function c(e) {
			a("update:modelValue", e == null || Number.isNaN(e) ? null : e);
		}
		let l = {
			props: i,
			emit: a,
			fractionDigits: o,
			formatOptions: s,
			onUpdate: c,
			get NumberField() {
				return Ys;
			},
			get NumberFieldContent() {
				return Qs;
			},
			get NumberFieldInput() {
				return sc;
			}
		};
		return Object.defineProperty(l, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), l;
	}
});
// src/components/app/NumberInput.vue
function cm(e, t, r, i, a, o) {
	return g(), n(i.NumberField, {
		"model-value": r.modelValue,
		min: r.min,
		max: r.max,
		step: r.step,
		locale: r.locale,
		"format-options": i.formatOptions,
		disabled: r.disabled,
		class: p(i.props.class),
		"onUpdate:modelValue": i.onUpdate
	}, {
		default: x(() => [s(i.NumberFieldContent, null, {
			default: x(() => [s(i.NumberFieldInput, {
				id: r.id,
				placeholder: r.placeholder
			}, null, 8, ["id", "placeholder"])]),
			_: 1
		})]),
		_: 1
	}, 8, [
		"model-value",
		"min",
		"max",
		"step",
		"locale",
		"format-options",
		"disabled",
		"class"
	]);
}
var lm = /*#__PURE__*/ j(sm, [["render", cm], ["__file", "/workspace/packages/ui/src/components/app/NumberInput.vue"]]), um = /*@__PURE__*/ c({
	__name: "PageHeader",
	props: {
		title: {
			type: String,
			required: !0
		},
		description: {
			type: String,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
}), dm = { class: "text-center" }, fm = { class: "text-lg font-semibold tracking-tight" }, pm = {
	key: 0,
	class: "mt-1 text-sm text-muted-foreground"
}, mm = { class: "flex justify-end gap-2" };
function hm(e, t, n, o, s, c) {
	return g(), i("div", {
		"data-slot": "page-header",
		class: p(o.cn("grid grid-cols-[1fr_auto_1fr] items-center gap-4 border-b border-border px-6 py-5", o.props.class))
	}, [
		t[0] ||= a("div", null, null, -1),
		a("div", dm, [a("h1", fm, b(n.title), 1), n.description ? (g(), i("p", pm, b(n.description), 1)) : r("v-if", !0)]),
		a("div", mm, [y(e.$slots, "actions")])
	], 2);
}
var gm = /*#__PURE__*/ j(um, [["render", hm], ["__file", "/workspace/packages/ui/src/components/app/PageHeader.vue"]]), _m = /*@__PURE__*/ c({
	__name: "ResponsiveFilters",
	props: {
		activeCount: {
			type: Number,
			required: !1,
			default: 0
		},
		title: {
			type: String,
			required: !1,
			default: "Filters"
		},
		clearLabel: {
			type: String,
			required: !1,
			default: "Clear filters"
		},
		closeLabel: {
			type: String,
			required: !1,
			default: "Close"
		}
	},
	emits: ["clear"],
	setup(e, { expose: t, emit: n }) {
		t();
		let r = {
			emit: n,
			isOpen: _(!1),
			get ListFilter() {
				return ur;
			},
			get Button() {
				return N;
			},
			get Sheet() {
				return H;
			},
			get SheetContent() {
				return U;
			},
			get SheetDescription() {
				return Xu;
			},
			get SheetHeader() {
				return nd;
			},
			get SheetTitle() {
				return W;
			}
		};
		return Object.defineProperty(r, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), r;
	}
}), vm = {
	"data-slot": "responsive-filters",
	class: "contents max-md:hidden"
}, ym = {
	key: 0,
	class: "flex size-4.5 items-center justify-center rounded-full bg-primary text-[10px] font-semibold text-primary-foreground tabular-nums"
}, bm = { class: "flex flex-col gap-4" }, xm = { class: "flex gap-3" };
function Sm(t, c, l, u, d, f) {
	return g(), i(e, null, [
		a("div", vm, [y(t.$slots, "default", { stacked: !1 })]),
		s(u.Button, {
			"data-slot": "responsive-filters-trigger",
			variant: "outline",
			class: "md:hidden",
			"aria-label": l.title,
			onClick: c[0] ||= (e) => u.isOpen = !0
		}, {
			default: x(() => [s(u.ListFilter), l.activeCount === 0 ? r("v-if", !0) : (g(), i("span", ym, b(l.activeCount), 1))]),
			_: 1
		}, 8, ["aria-label"]),
		s(u.Sheet, {
			open: u.isOpen,
			"onUpdate:open": c[3] ||= (e) => u.isOpen = e
		}, {
			default: x(() => [s(u.SheetContent, {
				side: "bottom",
				class: "mx-auto max-w-sm gap-4 p-4"
			}, {
				default: x(() => [
					s(u.SheetHeader, { class: "p-0" }, {
						default: x(() => [s(u.SheetTitle, null, {
							default: x(() => [o(b(l.title), 1)]),
							_: 1
						}), s(u.SheetDescription, { class: "sr-only" }, {
							default: x(() => [o(b(l.title), 1)]),
							_: 1
						})]),
						_: 1
					}),
					a("div", bm, [y(t.$slots, "default", { stacked: !0 })]),
					a("div", xm, [l.activeCount === 0 ? r("v-if", !0) : (g(), n(u.Button, {
						key: 0,
						variant: "outline",
						class: "flex-1",
						onClick: c[1] ||= (e) => u.emit("clear")
					}, {
						default: x(() => [o(b(l.clearLabel), 1)]),
						_: 1
					})), s(u.Button, {
						class: "flex-1",
						onClick: c[2] ||= (e) => u.isOpen = !1
					}, {
						default: x(() => [o(b(l.closeLabel), 1)]),
						_: 1
					})])
				]),
				_: 3
			})]),
			_: 3
		}, 8, ["open"])
	], 64);
}
var Cm = /*#__PURE__*/ j(_m, [["render", Sm], ["__file", "/workspace/packages/ui/src/components/app/ResponsiveFilters.vue"]]), wm = /*@__PURE__*/ c({
	__name: "SidebarBrand",
	props: {
		logo: {
			type: String,
			required: !1
		},
		title: {
			type: String,
			required: !0
		},
		subtitle: {
			type: String,
			required: !1
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
}), Tm = {
	"data-slot": "sidebar-brand",
	class: "flex h-10 items-center gap-2 px-2"
}, Em = ["src"], Dm = { class: "flex min-w-0 flex-col justify-center truncate" }, Om = { class: "truncate text-base leading-4 font-bold tracking-tight text-sidebar-foreground" }, km = {
	key: 0,
	class: "truncate text-[11px] leading-3 font-medium text-muted-foreground"
};
function Am(e, t, n, o, s, c) {
	return g(), i("div", Tm, [y(e.$slots, "logo", {}, () => [n.logo ? (g(), i("img", {
		key: 0,
		src: n.logo,
		alt: "",
		class: "size-7"
	}, null, 8, Em)) : r("v-if", !0)]), a("span", Dm, [a("span", Om, b(n.title), 1), n.subtitle ? (g(), i("span", km, b(n.subtitle), 1)) : r("v-if", !0)])]);
}
var jm = /*#__PURE__*/ j(wm, [["render", Am], ["__file", "/workspace/packages/ui/src/components/app/SidebarBrand.vue"]]), Mm = /*@__PURE__*/ c({
	__name: "SidebarNavBadge",
	setup(e, { expose: t }) {
		t();
		let n = {};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
}), Nm = {
	"data-slot": "sidebar-nav-badge",
	class: "ml-auto rounded-full bg-primary px-1.5 py-0.5 text-[10px] leading-none font-semibold text-primary-foreground in-data-active:bg-primary-foreground in-data-active:text-primary"
};
function Pm(e, t, n, r, a, o) {
	return g(), i("span", Nm, [y(e.$slots, "default")]);
}
var Fm = /*#__PURE__*/ j(Mm, [["render", Pm], ["__file", "/workspace/packages/ui/src/components/app/SidebarNavBadge.vue"]]), Im = /*@__PURE__*/ c({
	__name: "SidebarNavItem",
	props: {
		asChild: {
			type: Boolean,
			required: !1
		},
		as: {
			type: null,
			required: !1,
			default: "a"
		},
		active: {
			type: Boolean,
			required: !1,
			default: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get Primitive() {
				return C;
			},
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/app/SidebarNavItem.vue
function Lm(e, t, r, i, a, o) {
	return g(), n(i.Primitive, {
		"data-slot": "sidebar-nav-item",
		"data-active": r.active || void 0,
		"aria-current": r.active ? "page" : void 0,
		as: r.as,
		"as-child": r.asChild,
		class: p(i.cn("flex h-8 items-center gap-2 rounded-md p-2 text-sm font-medium text-sidebar-foreground transition-colors hover:bg-primary/50 hover:text-primary-foreground [&_svg]:size-4 [&_svg]:shrink-0", r.active && "bg-primary text-primary-foreground hover:bg-primary", i.props.class))
	}, {
		default: x(() => [y(e.$slots, "default")]),
		_: 3
	}, 8, [
		"data-active",
		"aria-current",
		"as",
		"as-child",
		"class"
	]);
}
var Rm = /*#__PURE__*/ j(Im, [["render", Lm], ["__file", "/workspace/packages/ui/src/components/app/SidebarNavItem.vue"]]), zm = /*@__PURE__*/ c({
	__name: "SidebarSection",
	props: {
		label: {
			type: String,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
}), Bm = {
	key: 0,
	class: "flex h-8 shrink-0 items-center px-2 text-xs font-medium text-sidebar-foreground/70"
}, Vm = { class: "flex flex-col gap-1" };
function Hm(e, t, n, o, s, c) {
	return g(), i("div", {
		"data-slot": "sidebar-section",
		class: p(o.cn("flex flex-col p-2", o.props.class))
	}, [n.label ? (g(), i("p", Bm, b(n.label), 1)) : r("v-if", !0), a("nav", Vm, [y(e.$slots, "default")])], 2);
}
var Um = /*#__PURE__*/ j(zm, [["render", Hm], ["__file", "/workspace/packages/ui/src/components/app/SidebarSection.vue"]]), Wm = /*@__PURE__*/ c({
	__name: "StatTile",
	props: {
		label: {
			type: String,
			required: !0
		},
		value: {
			type: [String, Number],
			required: !0
		},
		hint: {
			type: String,
			required: !1
		},
		class: {
			type: [
				Boolean,
				null,
				String,
				Object,
				Array
			],
			required: !1,
			skipCheck: !0
		}
	},
	setup(e, { expose: t }) {
		t();
		let n = {
			props: e,
			get cn() {
				return M;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
}), Gm = { class: "flex items-center justify-between gap-2 text-xs font-medium text-muted-foreground [&_svg]:size-4" }, Km = { class: "truncate" }, qm = { class: "text-2xl font-semibold tracking-tight tabular-nums" }, Jm = {
	key: 0,
	class: "text-xs text-muted-foreground"
};
function Ym(e, t, n, s, c, l) {
	return g(), i("div", {
		"data-slot": "stat-tile",
		class: p(s.cn("glass-tile flex flex-col gap-1 rounded-2xl p-4", s.props.class))
	}, [
		a("div", Gm, [a("span", Km, b(n.label), 1), y(e.$slots, "icon")]),
		a("div", qm, b(n.value), 1),
		n.hint || e.$slots.hint ? (g(), i("div", Jm, [y(e.$slots, "hint", {}, () => [o(b(n.hint), 1)])])) : r("v-if", !0)
	], 2);
}
var Xm = /*#__PURE__*/ j(Wm, [["render", Ym], ["__file", "/workspace/packages/ui/src/components/app/StatTile.vue"]]), Zm = /*@__PURE__*/ c({
	__name: "ThemeToggle",
	props: /*@__PURE__*/ d({
		lightLabel: {
			type: String,
			required: !1,
			default: "Switch to light mode"
		},
		darkLabel: {
			type: String,
			required: !1,
			default: "Switch to dark mode"
		}
	}, {
		modelValue: {
			type: String,
			required: !0
		},
		modelModifiers: {}
	}),
	emits: ["update:modelValue"],
	setup(e, { expose: t }) {
		t();
		let n = {
			scheme: ae(e, "modelValue"),
			get Moon() {
				return mr;
			},
			get Sun() {
				return yr;
			},
			get Button() {
				return N;
			}
		};
		return Object.defineProperty(n, "__isScriptSetup", {
			enumerable: !1,
			value: !0
		}), n;
	}
});
// src/components/app/ThemeToggle.vue
function Qm(e, t, r, i, a, o) {
	return g(), n(i.Button, {
		variant: "ghost",
		size: "icon",
		"aria-label": i.scheme === "dark" ? r.lightLabel : r.darkLabel,
		onClick: t[0] ||= (e) => i.scheme = i.scheme === "dark" ? "light" : "dark"
	}, {
		default: x(() => [i.scheme === "dark" ? (g(), n(i.Sun, {
			key: 0,
			class: "size-5"
		})) : (g(), n(i.Moon, {
			key: 1,
			class: "size-5"
		}))]),
		_: 1
	}, 8, ["aria-label"]);
}
var $m = /*#__PURE__*/ j(Zm, [["render", Qm], ["__file", "/workspace/packages/ui/src/components/app/ThemeToggle.vue"]]), eh = /* @__PURE__ */ wr({
	Accordion: () => Dr,
	AccordionContent: () => Ar,
	AccordionItem: () => Nr,
	AccordionTrigger: () => Ir,
	Alert: () => mi,
	AlertDescription: () => _i,
	AlertDialog: () => zr,
	AlertDialogAction: () => Wr,
	AlertDialogCancel: () => qr,
	AlertDialogContent: () => Xr,
	AlertDialogDescription: () => $r,
	AlertDialogFooter: () => ni,
	AlertDialogHeader: () => ai,
	AlertDialogTitle: () => ci,
	AlertDialogTrigger: () => di,
	AlertTitle: () => bi,
	AppShell: () => Uf,
	Avatar: () => wi,
	AvatarFallback: () => Di,
	AvatarImage: () => Ai,
	Badge: () => Ni,
	Breadcrumb: () => Li,
	BreadcrumbEllipsis: () => Bi,
	BreadcrumbItem: () => Ui,
	BreadcrumbLink: () => Ki,
	BreadcrumbList: () => Yi,
	BreadcrumbPage: () => Qi,
	BreadcrumbSeparator: () => ta,
	Button: () => N,
	Calendar: () => aa,
	Card: () => ca,
	CardAction: () => da,
	CardContent: () => ma,
	CardDescription: () => _a,
	CardFooter: () => ba,
	CardHeader: () => Ca,
	CardTitle: () => Ea,
	Checkbox: () => ka,
	Collapsible: () => Ma,
	CollapsibleContent: () => Fa,
	CollapsibleTrigger: () => Ra,
	ComboboxSelect: () => Xf,
	Command: () => F,
	CommandDialog: () => bo,
	CommandEmpty: () => I,
	CommandGroup: () => L,
	CommandInput: () => R,
	CommandItem: () => z,
	CommandList: () => B,
	CommandSeparator: () => Fo,
	CommandShortcut: () => Ro,
	DateCalendar: () => Hp,
	DateRangeCalendar: () => Gp,
	Dialog: () => Ua,
	DialogClose: () => Ka,
	DialogContent: () => Qa,
	DialogDescription: () => to,
	DialogFooter: () => io,
	DialogHeader: () => so,
	DialogOverlay: () => Ya,
	DialogScrollContent: () => uo,
	DialogTitle: () => mo,
	DialogTrigger: () => _o,
	DropdownMenu: () => Wo,
	DropdownMenuCheckboxItem: () => Jo,
	DropdownMenuContent: () => Zo,
	DropdownMenuGroup: () => es,
	DropdownMenuItem: () => rs,
	DropdownMenuLabel: () => os,
	DropdownMenuPortal: () => rt,
	DropdownMenuRadioGroup: () => ls,
	DropdownMenuRadioItem: () => ps,
	DropdownMenuSeparator: () => gs,
	DropdownMenuShortcut: () => ys,
	DropdownMenuSub: () => Ss,
	DropdownMenuSubContent: () => Ts,
	DropdownMenuSubTrigger: () => Os,
	DropdownMenuTrigger: () => js,
	EmptyState: () => Qp,
	HoverCard: () => Ps,
	HoverCardContent: () => Ls,
	HoverCardTrigger: () => Bs,
	Input: () => Us,
	Label: () => Ks,
	ModalLayout: () => om,
	NumberField: () => Ys,
	NumberFieldContent: () => Qs,
	NumberFieldDecrement: () => tc,
	NumberFieldIncrement: () => ic,
	NumberFieldInput: () => sc,
	NumberInput: () => lm,
	PageHeader: () => gm,
	Pagination: () => uc,
	PaginationContent: () => pc,
	PaginationEllipsis: () => gc,
	PaginationFirst: () => yc,
	PaginationItem: () => Sc,
	PaginationLast: () => Tc,
	PaginationNext: () => Oc,
	PaginationPrevious: () => jc,
	PinInput: () => Pc,
	PinInputGroup: () => Lc,
	PinInputSeparator: () => Bc,
	PinInputSlot: () => Uc,
	Popover: () => Kc,
	PopoverAnchor: () => Yc,
	PopoverContent: () => Qc,
	PopoverTrigger: () => tl,
	Progress: () => il,
	RadioGroup: () => sl,
	RadioGroupItem: () => ul,
	RangeCalendar: () => hl,
	RangeCalendarCell: () => vl,
	RangeCalendarCellTrigger: () => xl,
	RangeCalendarGrid: () => wl,
	RangeCalendarGridBody: () => Dl,
	RangeCalendarGridHead: () => Al,
	RangeCalendarGridRow: () => Nl,
	RangeCalendarHeadCell: () => Il,
	RangeCalendarHeader: () => zl,
	RangeCalendarHeading: () => Hl,
	RangeCalendarNextButton: () => Gl,
	RangeCalendarPrevButton: () => Jl,
	ResponsiveFilters: () => Cm,
	ScrollArea: () => eu,
	ScrollBar: () => Zl,
	Select: () => ru,
	SelectContent: () => ou,
	SelectGroup: () => lu,
	SelectItem: () => pu,
	SelectItemText: () => gu,
	SelectLabel: () => yu,
	SelectScrollDownButton: () => Su,
	SelectScrollUpButton: () => Tu,
	SelectSeparator: () => Ou,
	SelectTrigger: () => ju,
	SelectValue: () => Pu,
	Separator: () => Lu,
	Sheet: () => H,
	SheetClose: () => Hu,
	SheetContent: () => U,
	SheetDescription: () => Xu,
	SheetFooter: () => $u,
	SheetHeader: () => nd,
	SheetTitle: () => W,
	SheetTrigger: () => sd,
	SidebarBrand: () => jm,
	SidebarNavBadge: () => Fm,
	SidebarNavItem: () => Rm,
	SidebarSection: () => Um,
	Skeleton: () => ud,
	Slider: () => pd,
	StatTile: () => Xm,
	Switch: () => yd,
	Table: () => Cd,
	TableBody: () => Ed,
	TableCaption: () => kd,
	TableCell: () => Md,
	TableEmpty: () => zd,
	TableFooter: () => Hd,
	TableHead: () => Gd,
	TableHeader: () => Jd,
	TableRow: () => Fd,
	Tabs: () => Zd,
	TabsContent: () => ef,
	TabsList: () => rf,
	TabsTrigger: () => sf,
	Textarea: () => uf,
	ThemeToggle: () => $m,
	Toaster: () => gd,
	Toggle: () => gf,
	ToggleGroup: () => pf,
	ToggleGroupItem: () => yf,
	Tooltip: () => Sf,
	TooltipContent: () => Tf,
	TooltipProvider: () => Of,
	TooltipTrigger: () => jf,
	alertVariants: () => xi,
	badgeVariants: () => Pi,
	buttonVariants: () => P,
	provideCommandContext: () => zo,
	provideCommandGroupContext: () => Vo,
	toggleVariants: () => G,
	useCommand: () => V,
	useCommandGroup: () => Bo
}), th = "theme", nh = ["theme-turisztikai", "theme-shoprenter"];
function rh() {
	try {
		let e = localStorage.getItem(th);
		if (e === "light" || e === "dark") return e;
	} catch {}
	return matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
var ih = _(rh()), ah = _("ad");
function oh() {
	return ce(ih, (e) => {
		document.documentElement.dataset.theme = e;
		try {
			localStorage.setItem(th, e);
		} catch {}
	}, { immediate: !0 }), ce(ah, (e) => {
		let t = document.documentElement;
		t.classList.remove(...nh), e !== "ad" && t.classList.add(`theme-${e}`);
	}, { immediate: !0 }), {
		scheme: ih,
		brand: ah
	};
}
// src/plugin.ts
function sh(e) {
	return typeof e == "object" && !!e && ("setup" in e || "render" in e || "__name" in e);
}
var ch = { install(e, { prefix: t = "Ui" } = {}) {
	for (let [n, r] of Object.entries(eh)) sh(r) && e.component(`${t}${n}`, r);
} };
export { Dr as Accordion, Ar as AccordionContent, Nr as AccordionItem, Ir as AccordionTrigger, mi as Alert, _i as AlertDescription, zr as AlertDialog, Wr as AlertDialogAction, qr as AlertDialogCancel, Xr as AlertDialogContent, $r as AlertDialogDescription, ni as AlertDialogFooter, ai as AlertDialogHeader, ci as AlertDialogTitle, di as AlertDialogTrigger, bi as AlertTitle, Uf as AppShell, wi as Avatar, Di as AvatarFallback, Ai as AvatarImage, Ni as Badge, Li as Breadcrumb, Bi as BreadcrumbEllipsis, Ui as BreadcrumbItem, Ki as BreadcrumbLink, Yi as BreadcrumbList, Qi as BreadcrumbPage, ta as BreadcrumbSeparator, N as Button, aa as Calendar, ca as Card, da as CardAction, ma as CardContent, _a as CardDescription, ba as CardFooter, Ca as CardHeader, Ea as CardTitle, ka as Checkbox, Ma as Collapsible, Fa as CollapsibleContent, Ra as CollapsibleTrigger, Xf as ComboboxSelect, F as Command, bo as CommandDialog, I as CommandEmpty, L as CommandGroup, R as CommandInput, z as CommandItem, B as CommandList, Fo as CommandSeparator, Ro as CommandShortcut, Hp as DateCalendar, Gp as DateRangeCalendar, Ua as Dialog, Ka as DialogClose, Qa as DialogContent, to as DialogDescription, io as DialogFooter, so as DialogHeader, Ya as DialogOverlay, uo as DialogScrollContent, mo as DialogTitle, _o as DialogTrigger, Wo as DropdownMenu, Jo as DropdownMenuCheckboxItem, Zo as DropdownMenuContent, es as DropdownMenuGroup, rs as DropdownMenuItem, os as DropdownMenuLabel, rt as DropdownMenuPortal, ls as DropdownMenuRadioGroup, ps as DropdownMenuRadioItem, gs as DropdownMenuSeparator, ys as DropdownMenuShortcut, Ss as DropdownMenuSub, Ts as DropdownMenuSubContent, Os as DropdownMenuSubTrigger, js as DropdownMenuTrigger, Qp as EmptyState, Ps as HoverCard, Ls as HoverCardContent, Bs as HoverCardTrigger, ch as InfiniteUi, Us as Input, Ks as Label, om as ModalLayout, Ys as NumberField, Qs as NumberFieldContent, tc as NumberFieldDecrement, ic as NumberFieldIncrement, sc as NumberFieldInput, lm as NumberInput, gm as PageHeader, uc as Pagination, pc as PaginationContent, gc as PaginationEllipsis, yc as PaginationFirst, Sc as PaginationItem, Tc as PaginationLast, Oc as PaginationNext, jc as PaginationPrevious, Pc as PinInput, Lc as PinInputGroup, Bc as PinInputSeparator, Uc as PinInputSlot, Kc as Popover, Yc as PopoverAnchor, Qc as PopoverContent, tl as PopoverTrigger, il as Progress, sl as RadioGroup, ul as RadioGroupItem, hl as RangeCalendar, vl as RangeCalendarCell, xl as RangeCalendarCellTrigger, wl as RangeCalendarGrid, Dl as RangeCalendarGridBody, Al as RangeCalendarGridHead, Nl as RangeCalendarGridRow, Il as RangeCalendarHeadCell, zl as RangeCalendarHeader, Hl as RangeCalendarHeading, Gl as RangeCalendarNextButton, Jl as RangeCalendarPrevButton, Cm as ResponsiveFilters, eu as ScrollArea, Zl as ScrollBar, ru as Select, ou as SelectContent, lu as SelectGroup, pu as SelectItem, gu as SelectItemText, yu as SelectLabel, Su as SelectScrollDownButton, Tu as SelectScrollUpButton, Ou as SelectSeparator, ju as SelectTrigger, Pu as SelectValue, Lu as Separator, H as Sheet, Hu as SheetClose, U as SheetContent, Xu as SheetDescription, $u as SheetFooter, nd as SheetHeader, W as SheetTitle, sd as SheetTrigger, jm as SidebarBrand, Fm as SidebarNavBadge, Rm as SidebarNavItem, Um as SidebarSection, ud as Skeleton, pd as Slider, Xm as StatTile, yd as Switch, Cd as Table, Ed as TableBody, kd as TableCaption, Md as TableCell, zd as TableEmpty, Hd as TableFooter, Gd as TableHead, Jd as TableHeader, Fd as TableRow, Zd as Tabs, ef as TabsContent, rf as TabsList, sf as TabsTrigger, uf as Textarea, $m as ThemeToggle, gd as Toaster, gf as Toggle, pf as ToggleGroup, yf as ToggleGroupItem, Sf as Tooltip, Tf as TooltipContent, Of as TooltipProvider, jf as TooltipTrigger, xi as alertVariants, Pi as badgeVariants, P as buttonVariants, M as cn, zo as provideCommandContext, Vo as provideCommandGroupContext, G as toggleVariants, oh as useColorScheme, V as useCommand, Bo as useCommandGroup };
